import Ve, { useState as tt, useEffect as at, useId as qr, forwardRef as Yi, useRef as En, useContext as Gi, createElement as La, Component as Ma, createContext as Da, useImperativeHandle as Fa, useCallback as Ln } from "react";
import $a from "react-dom";
function Xi(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var li = { exports: {} }, Kn = {};
var Eo;
function Ba() {
  if (Eo) return Kn;
  Eo = 1;
  var e = Ve, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, i = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, a = { key: !0, ref: !0, __self: !0, __source: !0 };
  function d(p, m, h) {
    var b, k = {}, _ = null, I = null;
    h !== void 0 && (_ = "" + h), m.key !== void 0 && (_ = "" + m.key), m.ref !== void 0 && (I = m.ref);
    for (b in m) r.call(m, b) && !a.hasOwnProperty(b) && (k[b] = m[b]);
    if (p && p.defaultProps) for (b in m = p.defaultProps, m) k[b] === void 0 && (k[b] = m[b]);
    return { $$typeof: t, type: p, key: _, ref: I, props: k, _owner: i.current };
  }
  return Kn.Fragment = n, Kn.jsx = d, Kn.jsxs = d, Kn;
}
var Co;
function za() {
  return Co || (Co = 1, li.exports = Ba()), li.exports;
}
var f = za(), ci = { exports: {} }, ui, Ro;
function Ha() {
  if (Ro) return ui;
  Ro = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return ui = e, ui;
}
var di, Oo;
function Va() {
  if (Oo) return di;
  Oo = 1;
  var e = /* @__PURE__ */ Ha();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, di = function() {
    function r(d, p, m, h, b, k) {
      if (k !== e) {
        var _ = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw _.name = "Invariant Violation", _;
      }
    }
    r.isRequired = r;
    function i() {
      return r;
    }
    var a = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: i,
      element: r,
      elementType: r,
      instanceOf: i,
      node: r,
      objectOf: i,
      oneOf: i,
      oneOfType: i,
      shape: i,
      exact: i,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return a.PropTypes = a, a;
  }, di;
}
var Ao;
function Wa() {
  return Ao || (Ao = 1, ci.exports = /* @__PURE__ */ Va()()), ci.exports;
}
var qa = /* @__PURE__ */ Wa();
const l = /* @__PURE__ */ Xi(qa), Ua = () => {
  const [e, t] = tt(null), [n, r] = tt(!1), [i, a] = tt(null), [d, p] = tt("");
  return at(() => {
    if (!d) return;
    (() => {
      a(null), r(!0);
      try {
        fetch(d).then((h) => h.json()).then((h) => {
          t(h), r(!1);
        }).catch((h) => {
          a(h), r(!1);
        });
      } catch (h) {
        a(h);
      }
    })();
  }, [d]), [{ data: e, loading: n, error: i }, p];
};
function Ya(e) {
  const [t, n] = tt(!1);
  return at(() => {
    const r = window.matchMedia(e);
    r.matches !== t && n(r.matches);
    const i = () => {
      n(r.matches);
    };
    return r.addEventListener("change", i), () => r.removeEventListener("change", i);
  }, [t, e]), t;
}
const jo = (e, t, n) => e ? t : n, Nr = (e) => (e || []).join(" ");
const {
  entries: Es,
  setPrototypeOf: No,
  isFrozen: Ga,
  getPrototypeOf: Xa,
  getOwnPropertyDescriptor: Ka
} = Object;
let {
  freeze: ct,
  seal: St,
  create: nr
} = Object, {
  apply: Ei,
  construct: Ci
} = typeof Reflect < "u" && Reflect;
ct || (ct = function(t) {
  return t;
});
St || (St = function(t) {
  return t;
});
Ei || (Ei = function(t, n) {
  for (var r = arguments.length, i = new Array(r > 2 ? r - 2 : 0), a = 2; a < r; a++)
    i[a - 2] = arguments[a];
  return t.apply(n, i);
});
Ci || (Ci = function(t) {
  for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
    r[i - 1] = arguments[i];
  return new t(...r);
});
const Zn = ut(Array.prototype.forEach), Za = ut(Array.prototype.lastIndexOf), Io = ut(Array.prototype.pop), Jn = ut(Array.prototype.push), Ja = ut(Array.prototype.splice), Ir = ut(String.prototype.toLowerCase), fi = ut(String.prototype.toString), pi = ut(String.prototype.match), Pn = ut(String.prototype.replace), Qa = ut(String.prototype.indexOf), el = ut(String.prototype.trim), It = ut(Object.prototype.hasOwnProperty), st = ut(RegExp.prototype.test), Qn = tl(TypeError);
function ut(e) {
  return function(t) {
    t instanceof RegExp && (t.lastIndex = 0);
    for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
      r[i - 1] = arguments[i];
    return Ei(e, t, r);
  };
}
function tl(e) {
  return function() {
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    return Ci(e, n);
  };
}
function me(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Ir;
  No && No(e, null);
  let r = t.length;
  for (; r--; ) {
    let i = t[r];
    if (typeof i == "string") {
      const a = n(i);
      a !== i && (Ga(t) || (t[r] = a), i = a);
    }
    e[i] = !0;
  }
  return e;
}
function nl(e) {
  for (let t = 0; t < e.length; t++)
    It(e, t) || (e[t] = null);
  return e;
}
function $t(e) {
  const t = nr(null);
  for (const [n, r] of Es(e))
    It(e, n) && (Array.isArray(r) ? t[n] = nl(r) : r && typeof r == "object" && r.constructor === Object ? t[n] = $t(r) : t[n] = r);
  return t;
}
function er(e, t) {
  for (; e !== null; ) {
    const r = Ka(e, t);
    if (r) {
      if (r.get)
        return ut(r.get);
      if (typeof r.value == "function")
        return ut(r.value);
    }
    e = Xa(e);
  }
  function n() {
    return null;
  }
  return n;
}
const Po = ct(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "search", "section", "select", "shadow", "slot", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), hi = ct(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "enterkeyhint", "exportparts", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "inputmode", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "part", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), mi = ct(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), rl = ct(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), gi = ct(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), il = ct(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), Lo = ct(["#text"]), Mo = ct(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "exportparts", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inert", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "part", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "slot", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns", "slot"]), vi = ct(["accent-height", "accumulate", "additive", "alignment-baseline", "amplitude", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "exponent", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "intercept", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "mask-type", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "slope", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "tablevalues", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), Do = ct(["accent", "accentunder", "align", "bevelled", "close", "columnalign", "columnlines", "columnspacing", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lquote", "lspace", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), Tr = ct(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), ol = St(/\{\{[\w\W]*|[\w\W]*\}\}/gm), sl = St(/<%[\w\W]*|[\w\W]*%>/gm), al = St(/\$\{[\w\W]*/gm), ll = St(/^data-[\-\w.\u00B7-\uFFFF]+$/), cl = St(/^aria-[\-\w]+$/), Cs = St(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), ul = St(/^(?:\w+script|data):/i), dl = St(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), Rs = St(/^html$/i), fl = St(/^[a-z][.\w]*(-[.\w]+)+$/i);
var Fo = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ARIA_ATTR: cl,
  ATTR_WHITESPACE: dl,
  CUSTOM_ELEMENT: fl,
  DATA_ATTR: ll,
  DOCTYPE_NAME: Rs,
  ERB_EXPR: sl,
  IS_ALLOWED_URI: Cs,
  IS_SCRIPT_OR_DATA: ul,
  MUSTACHE_EXPR: ol,
  TMPLIT_EXPR: al
});
const tr = {
  element: 1,
  text: 3,
  // Deprecated
  progressingInstruction: 7,
  comment: 8,
  document: 9
}, pl = function() {
  return typeof window > "u" ? null : window;
}, hl = function(t, n) {
  if (typeof t != "object" || typeof t.createPolicy != "function")
    return null;
  let r = null;
  const i = "data-tt-policy-suffix";
  n && n.hasAttribute(i) && (r = n.getAttribute(i));
  const a = "dompurify" + (r ? "#" + r : "");
  try {
    return t.createPolicy(a, {
      createHTML(d) {
        return d;
      },
      createScriptURL(d) {
        return d;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + a + " could not be created."), null;
  }
}, $o = function() {
  return {
    afterSanitizeAttributes: [],
    afterSanitizeElements: [],
    afterSanitizeShadowDOM: [],
    beforeSanitizeAttributes: [],
    beforeSanitizeElements: [],
    beforeSanitizeShadowDOM: [],
    uponSanitizeAttribute: [],
    uponSanitizeElement: [],
    uponSanitizeShadowNode: []
  };
};
function Os() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : pl();
  const t = (K) => Os(K);
  if (t.version = "3.4.0", t.removed = [], !e || !e.document || e.document.nodeType !== tr.document || !e.Element)
    return t.isSupported = !1, t;
  let {
    document: n
  } = e;
  const r = n, i = r.currentScript, {
    DocumentFragment: a,
    HTMLTemplateElement: d,
    Node: p,
    Element: m,
    NodeFilter: h,
    NamedNodeMap: b = e.NamedNodeMap || e.MozNamedAttrMap,
    HTMLFormElement: k,
    DOMParser: _,
    trustedTypes: I
  } = e, C = m.prototype, w = er(C, "cloneNode"), N = er(C, "remove"), M = er(C, "nextSibling"), D = er(C, "childNodes"), V = er(C, "parentNode");
  if (typeof d == "function") {
    const K = n.createElement("template");
    K.content && K.content.ownerDocument && (n = K.content.ownerDocument);
  }
  let W, A = "";
  const {
    implementation: X,
    createNodeIterator: re,
    createDocumentFragment: Me,
    getElementsByTagName: Ne
  } = n, {
    importNode: De
  } = r;
  let ve = $o();
  t.isSupported = typeof Es == "function" && typeof V == "function" && X && X.createHTMLDocument !== void 0;
  const {
    MUSTACHE_EXPR: fe,
    ERB_EXPR: Z,
    TMPLIT_EXPR: ue,
    DATA_ATTR: Ae,
    ARIA_ATTR: dt,
    IS_SCRIPT_OR_DATA: ze,
    ATTR_WHITESPACE: He,
    CUSTOM_ELEMENT: Ue
  } = Fo;
  let {
    IS_ALLOWED_URI: ft
  } = Fo, be = null;
  const G = me({}, [...Po, ...hi, ...mi, ...gi, ...Lo]);
  let z = null;
  const U = me({}, [...Mo, ...vi, ...Do, ...Tr]);
  let q = Object.seal(nr(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), j = null, de = null;
  const $ = Object.seal(nr(null, {
    tagCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    }
  }));
  let ge = !0, oe = !0, se = !1, Q = !0, ae = !1, Se = !0, ie = !1, Ie = !1, he = !1, ke = !1, Qe = !1, Ce = !1, wt = !0, Ge = !1;
  const Re = "user-content-";
  let J = !0, we = !1, it = {}, Xe = null;
  const Ke = me({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
  let dn = null;
  const fn = me({}, ["audio", "video", "img", "source", "image", "track"]);
  let pn = null;
  const Zt = me({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), kt = "http://www.w3.org/1998/Math/MathML", Jt = "http://www.w3.org/2000/svg", pt = "http://www.w3.org/1999/xhtml";
  let Lt = pt, hn = !1, mn = null;
  const ht = me({}, [kt, Jt, pt], fi);
  let Mt = me({}, ["mi", "mo", "mn", "ms", "mtext"]), Tt = me({}, ["annotation-xml"]);
  const Te = me({}, ["title", "style", "font", "a", "script"]);
  let gt = null;
  const Qt = ["application/xhtml+xml", "text/html"], zt = "text/html";
  let _e = null, vt = null;
  const _t = n.createElement("form"), gn = function(S) {
    return S instanceof RegExp || S instanceof Function;
  }, Ht = function() {
    let S = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!(vt && vt === S)) {
      if ((!S || typeof S != "object") && (S = {}), S = $t(S), gt = // eslint-disable-next-line unicorn/prefer-includes
      Qt.indexOf(S.PARSER_MEDIA_TYPE) === -1 ? zt : S.PARSER_MEDIA_TYPE, _e = gt === "application/xhtml+xml" ? fi : Ir, be = It(S, "ALLOWED_TAGS") ? me({}, S.ALLOWED_TAGS, _e) : G, z = It(S, "ALLOWED_ATTR") ? me({}, S.ALLOWED_ATTR, _e) : U, mn = It(S, "ALLOWED_NAMESPACES") ? me({}, S.ALLOWED_NAMESPACES, fi) : ht, pn = It(S, "ADD_URI_SAFE_ATTR") ? me($t(Zt), S.ADD_URI_SAFE_ATTR, _e) : Zt, dn = It(S, "ADD_DATA_URI_TAGS") ? me($t(fn), S.ADD_DATA_URI_TAGS, _e) : fn, Xe = It(S, "FORBID_CONTENTS") ? me({}, S.FORBID_CONTENTS, _e) : Ke, j = It(S, "FORBID_TAGS") ? me({}, S.FORBID_TAGS, _e) : $t({}), de = It(S, "FORBID_ATTR") ? me({}, S.FORBID_ATTR, _e) : $t({}), it = It(S, "USE_PROFILES") ? S.USE_PROFILES : !1, ge = S.ALLOW_ARIA_ATTR !== !1, oe = S.ALLOW_DATA_ATTR !== !1, se = S.ALLOW_UNKNOWN_PROTOCOLS || !1, Q = S.ALLOW_SELF_CLOSE_IN_ATTR !== !1, ae = S.SAFE_FOR_TEMPLATES || !1, Se = S.SAFE_FOR_XML !== !1, ie = S.WHOLE_DOCUMENT || !1, ke = S.RETURN_DOM || !1, Qe = S.RETURN_DOM_FRAGMENT || !1, Ce = S.RETURN_TRUSTED_TYPE || !1, he = S.FORCE_BODY || !1, wt = S.SANITIZE_DOM !== !1, Ge = S.SANITIZE_NAMED_PROPS || !1, J = S.KEEP_CONTENT !== !1, we = S.IN_PLACE || !1, ft = S.ALLOWED_URI_REGEXP || Cs, Lt = S.NAMESPACE || pt, Mt = S.MATHML_TEXT_INTEGRATION_POINTS || Mt, Tt = S.HTML_INTEGRATION_POINTS || Tt, q = S.CUSTOM_ELEMENT_HANDLING || nr(null), S.CUSTOM_ELEMENT_HANDLING && gn(S.CUSTOM_ELEMENT_HANDLING.tagNameCheck) && (q.tagNameCheck = S.CUSTOM_ELEMENT_HANDLING.tagNameCheck), S.CUSTOM_ELEMENT_HANDLING && gn(S.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) && (q.attributeNameCheck = S.CUSTOM_ELEMENT_HANDLING.attributeNameCheck), S.CUSTOM_ELEMENT_HANDLING && typeof S.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements == "boolean" && (q.allowCustomizedBuiltInElements = S.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements), ae && (oe = !1), Qe && (ke = !0), it && (be = me({}, Lo), z = nr(null), it.html === !0 && (me(be, Po), me(z, Mo)), it.svg === !0 && (me(be, hi), me(z, vi), me(z, Tr)), it.svgFilters === !0 && (me(be, mi), me(z, vi), me(z, Tr)), it.mathMl === !0 && (me(be, gi), me(z, Do), me(z, Tr))), $.tagCheck = null, $.attributeCheck = null, S.ADD_TAGS && (typeof S.ADD_TAGS == "function" ? $.tagCheck = S.ADD_TAGS : (be === G && (be = $t(be)), me(be, S.ADD_TAGS, _e))), S.ADD_ATTR && (typeof S.ADD_ATTR == "function" ? $.attributeCheck = S.ADD_ATTR : (z === U && (z = $t(z)), me(z, S.ADD_ATTR, _e))), S.ADD_URI_SAFE_ATTR && me(pn, S.ADD_URI_SAFE_ATTR, _e), S.FORBID_CONTENTS && (Xe === Ke && (Xe = $t(Xe)), me(Xe, S.FORBID_CONTENTS, _e)), S.ADD_FORBID_CONTENTS && (Xe === Ke && (Xe = $t(Xe)), me(Xe, S.ADD_FORBID_CONTENTS, _e)), J && (be["#text"] = !0), ie && me(be, ["html", "head", "body"]), be.table && (me(be, ["tbody"]), delete j.tbody), S.TRUSTED_TYPES_POLICY) {
        if (typeof S.TRUSTED_TYPES_POLICY.createHTML != "function")
          throw Qn('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
        if (typeof S.TRUSTED_TYPES_POLICY.createScriptURL != "function")
          throw Qn('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
        W = S.TRUSTED_TYPES_POLICY, A = W.createHTML("");
      } else
        W === void 0 && (W = hl(I, i)), W !== null && typeof A == "string" && (A = W.createHTML(""));
      ct && ct(S), vt = S;
    }
  }, en = me({}, [...hi, ...mi, ...rl]), vn = me({}, [...gi, ...il]), On = function(S) {
    let F = V(S);
    (!F || !F.tagName) && (F = {
      namespaceURI: Lt,
      tagName: "template"
    });
    const Y = Ir(S.tagName), Oe = Ir(F.tagName);
    return mn[S.namespaceURI] ? S.namespaceURI === Jt ? F.namespaceURI === pt ? Y === "svg" : F.namespaceURI === kt ? Y === "svg" && (Oe === "annotation-xml" || Mt[Oe]) : !!en[Y] : S.namespaceURI === kt ? F.namespaceURI === pt ? Y === "math" : F.namespaceURI === Jt ? Y === "math" && Tt[Oe] : !!vn[Y] : S.namespaceURI === pt ? F.namespaceURI === Jt && !Tt[Oe] || F.namespaceURI === kt && !Mt[Oe] ? !1 : !vn[Y] && (Te[Y] || !en[Y]) : !!(gt === "application/xhtml+xml" && mn[S.namespaceURI]) : !1;
  }, nt = function(S) {
    Jn(t.removed, {
      element: S
    });
    try {
      V(S).removeChild(S);
    } catch {
      N(S);
    }
  }, Et = function(S, F) {
    try {
      Jn(t.removed, {
        attribute: F.getAttributeNode(S),
        from: F
      });
    } catch {
      Jn(t.removed, {
        attribute: null,
        from: F
      });
    }
    if (F.removeAttribute(S), S === "is")
      if (ke || Qe)
        try {
          nt(F);
        } catch {
        }
      else
        try {
          F.setAttribute(S, "");
        } catch {
        }
  }, An = function(S) {
    let F = null, Y = null;
    if (he)
      S = "<remove></remove>" + S;
    else {
      const ye = pi(S, /^[\r\n\t ]+/);
      Y = ye && ye[0];
    }
    gt === "application/xhtml+xml" && Lt === pt && (S = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + S + "</body></html>");
    const Oe = W ? W.createHTML(S) : S;
    if (Lt === pt)
      try {
        F = new _().parseFromString(Oe, gt);
      } catch {
      }
    if (!F || !F.documentElement) {
      F = X.createDocument(Lt, "template", null);
      try {
        F.documentElement.innerHTML = hn ? A : Oe;
      } catch {
      }
    }
    const We = F.body || F.documentElement;
    return S && Y && We.insertBefore(n.createTextNode(Y), We.childNodes[0] || null), Lt === pt ? Ne.call(F, ie ? "html" : "body")[0] : ie ? F.documentElement : We;
  }, Vt = function(S) {
    return re.call(
      S.ownerDocument || S,
      S,
      // eslint-disable-next-line no-bitwise
      h.SHOW_ELEMENT | h.SHOW_COMMENT | h.SHOW_TEXT | h.SHOW_PROCESSING_INSTRUCTION | h.SHOW_CDATA_SECTION,
      null
    );
  }, tn = function(S) {
    return S instanceof k && (typeof S.nodeName != "string" || typeof S.textContent != "string" || typeof S.removeChild != "function" || !(S.attributes instanceof b) || typeof S.removeAttribute != "function" || typeof S.setAttribute != "function" || typeof S.namespaceURI != "string" || typeof S.insertBefore != "function" || typeof S.hasChildNodes != "function");
  }, Dt = function(S) {
    return typeof p == "function" && S instanceof p;
  };
  function ot(K, S, F) {
    Zn(K, (Y) => {
      Y.call(t, S, F, vt);
    });
  }
  const jn = function(S) {
    let F = null;
    if (ot(ve.beforeSanitizeElements, S, null), tn(S))
      return nt(S), !0;
    const Y = _e(S.nodeName);
    if (ot(ve.uponSanitizeElement, S, {
      tagName: Y,
      allowedTags: be
    }), Se && S.hasChildNodes() && !Dt(S.firstElementChild) && st(/<[/\w!]/g, S.innerHTML) && st(/<[/\w!]/g, S.textContent) || Se && S.namespaceURI === pt && Y === "style" && Dt(S.firstElementChild) || S.nodeType === tr.progressingInstruction || Se && S.nodeType === tr.comment && st(/<[/\w]/g, S.data))
      return nt(S), !0;
    if (j[Y] || !($.tagCheck instanceof Function && $.tagCheck(Y)) && !be[Y]) {
      if (!j[Y] && Nn(Y) && (q.tagNameCheck instanceof RegExp && st(q.tagNameCheck, Y) || q.tagNameCheck instanceof Function && q.tagNameCheck(Y)))
        return !1;
      if (J && !Xe[Y]) {
        const Oe = V(S) || S.parentNode, We = D(S) || S.childNodes;
        if (We && Oe) {
          const ye = We.length;
          for (let Ze = ye - 1; Ze >= 0; --Ze) {
            const Je = w(We[Ze], !0);
            Je.__removalCount = (S.__removalCount || 0) + 1, Oe.insertBefore(Je, M(S));
          }
        }
      }
      return nt(S), !0;
    }
    return S instanceof m && !On(S) || (Y === "noscript" || Y === "noembed" || Y === "noframes") && st(/<\/no(script|embed|frames)/i, S.innerHTML) ? (nt(S), !0) : (ae && S.nodeType === tr.text && (F = S.textContent, Zn([fe, Z, ue], (Oe) => {
      F = Pn(F, Oe, " ");
    }), S.textContent !== F && (Jn(t.removed, {
      element: S.cloneNode()
    }), S.textContent = F)), ot(ve.afterSanitizeElements, S, null), !1);
  }, Ft = function(S, F, Y) {
    if (de[F] || wt && (F === "id" || F === "name") && (Y in n || Y in _t))
      return !1;
    if (!(oe && !de[F] && st(Ae, F))) {
      if (!(ge && st(dt, F))) {
        if (!($.attributeCheck instanceof Function && $.attributeCheck(F, S))) {
          if (!z[F] || de[F]) {
            if (
              // First condition does a very basic check if a) it's basically a valid custom element tagname AND
              // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
              // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
              !(Nn(S) && (q.tagNameCheck instanceof RegExp && st(q.tagNameCheck, S) || q.tagNameCheck instanceof Function && q.tagNameCheck(S)) && (q.attributeNameCheck instanceof RegExp && st(q.attributeNameCheck, F) || q.attributeNameCheck instanceof Function && q.attributeNameCheck(F, S)) || // Alternative, second condition checks if it's an `is`-attribute, AND
              // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
              F === "is" && q.allowCustomizedBuiltInElements && (q.tagNameCheck instanceof RegExp && st(q.tagNameCheck, Y) || q.tagNameCheck instanceof Function && q.tagNameCheck(Y)))
            ) return !1;
          } else if (!pn[F]) {
            if (!st(ft, Pn(Y, He, ""))) {
              if (!((F === "src" || F === "xlink:href" || F === "href") && S !== "script" && Qa(Y, "data:") === 0 && dn[S])) {
                if (!(se && !st(ze, Pn(Y, He, "")))) {
                  if (Y)
                    return !1;
                }
              }
            }
          }
        }
      }
    }
    return !0;
  }, Nn = function(S) {
    return S !== "annotation-xml" && pi(S, Ue);
  }, nn = function(S) {
    ot(ve.beforeSanitizeAttributes, S, null);
    const {
      attributes: F
    } = S;
    if (!F || tn(S))
      return;
    const Y = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: z,
      forceKeepAttr: void 0
    };
    let Oe = F.length;
    for (; Oe--; ) {
      const We = F[Oe], {
        name: ye,
        namespaceURI: Ze,
        value: Je
      } = We, mt = _e(ye), rn = Je;
      let Pe = ye === "value" ? rn : el(rn);
      if (Y.attrName = mt, Y.attrValue = Pe, Y.keepAttr = !0, Y.forceKeepAttr = void 0, ot(ve.uponSanitizeAttribute, S, Y), Pe = Y.attrValue, Ge && (mt === "id" || mt === "name") && (Et(ye, S), Pe = Re + Pe), Se && st(/((--!?|])>)|<\/(style|script|title|xmp|textarea|noscript|iframe|noembed|noframes)/i, Pe)) {
        Et(ye, S);
        continue;
      }
      if (mt === "attributename" && pi(Pe, "href")) {
        Et(ye, S);
        continue;
      }
      if (Y.forceKeepAttr)
        continue;
      if (!Y.keepAttr) {
        Et(ye, S);
        continue;
      }
      if (!Q && st(/\/>/i, Pe)) {
        Et(ye, S);
        continue;
      }
      ae && Zn([fe, Z, ue], (yn) => {
        Pe = Pn(Pe, yn, " ");
      });
      const Ct = _e(S.nodeName);
      if (!Ft(Ct, mt, Pe)) {
        Et(ye, S);
        continue;
      }
      if (W && typeof I == "object" && typeof I.getAttributeType == "function" && !Ze)
        switch (I.getAttributeType(Ct, mt)) {
          case "TrustedHTML": {
            Pe = W.createHTML(Pe);
            break;
          }
          case "TrustedScriptURL": {
            Pe = W.createScriptURL(Pe);
            break;
          }
        }
      if (Pe !== rn)
        try {
          Ze ? S.setAttributeNS(Ze, ye, Pe) : S.setAttribute(ye, Pe), tn(S) ? nt(S) : Io(t.removed);
        } catch {
          Et(ye, S);
        }
    }
    ot(ve.afterSanitizeAttributes, S, null);
  }, Wt = function(S) {
    let F = null;
    const Y = Vt(S);
    for (ot(ve.beforeSanitizeShadowDOM, S, null); F = Y.nextNode(); )
      ot(ve.uponSanitizeShadowNode, F, null), jn(F), nn(F), F.content instanceof a && Wt(F.content);
    ot(ve.afterSanitizeShadowDOM, S, null);
  };
  return t.sanitize = function(K) {
    let S = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, F = null, Y = null, Oe = null, We = null;
    if (hn = !K, hn && (K = "<!-->"), typeof K != "string" && !Dt(K))
      if (typeof K.toString == "function") {
        if (K = K.toString(), typeof K != "string")
          throw Qn("dirty is not a string, aborting");
      } else
        throw Qn("toString is not a function");
    if (!t.isSupported)
      return K;
    if (Ie || Ht(S), t.removed = [], typeof K == "string" && (we = !1), we) {
      if (K.nodeName) {
        const Je = _e(K.nodeName);
        if (!be[Je] || j[Je])
          throw Qn("root node is forbidden and cannot be sanitized in-place");
      }
    } else if (K instanceof p)
      F = An("<!---->"), Y = F.ownerDocument.importNode(K, !0), Y.nodeType === tr.element && Y.nodeName === "BODY" || Y.nodeName === "HTML" ? F = Y : F.appendChild(Y);
    else {
      if (!ke && !ae && !ie && // eslint-disable-next-line unicorn/prefer-includes
      K.indexOf("<") === -1)
        return W && Ce ? W.createHTML(K) : K;
      if (F = An(K), !F)
        return ke ? null : Ce ? A : "";
    }
    F && he && nt(F.firstChild);
    const ye = Vt(we ? K : F);
    for (; Oe = ye.nextNode(); )
      jn(Oe), nn(Oe), Oe.content instanceof a && Wt(Oe.content);
    if (we)
      return K;
    if (ke) {
      if (ae) {
        F.normalize();
        let Je = F.innerHTML;
        Zn([fe, Z, ue], (mt) => {
          Je = Pn(Je, mt, " ");
        }), F.innerHTML = Je;
      }
      if (Qe)
        for (We = Me.call(F.ownerDocument); F.firstChild; )
          We.appendChild(F.firstChild);
      else
        We = F;
      return (z.shadowroot || z.shadowrootmode) && (We = De.call(r, We, !0)), We;
    }
    let Ze = ie ? F.outerHTML : F.innerHTML;
    return ie && be["!doctype"] && F.ownerDocument && F.ownerDocument.doctype && F.ownerDocument.doctype.name && st(Rs, F.ownerDocument.doctype.name) && (Ze = "<!DOCTYPE " + F.ownerDocument.doctype.name + `>
` + Ze), ae && Zn([fe, Z, ue], (Je) => {
      Ze = Pn(Ze, Je, " ");
    }), W && Ce ? W.createHTML(Ze) : Ze;
  }, t.setConfig = function() {
    let K = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    Ht(K), Ie = !0;
  }, t.clearConfig = function() {
    vt = null, Ie = !1;
  }, t.isValidAttribute = function(K, S, F) {
    vt || Ht({});
    const Y = _e(K), Oe = _e(S);
    return Ft(Y, Oe, F);
  }, t.addHook = function(K, S) {
    typeof S == "function" && Jn(ve[K], S);
  }, t.removeHook = function(K, S) {
    if (S !== void 0) {
      const F = Za(ve[K], S);
      return F === -1 ? void 0 : Ja(ve[K], F, 1)[0];
    }
    return Io(ve[K]);
  }, t.removeHooks = function(K) {
    ve[K] = [];
  }, t.removeAllHooks = function() {
    ve = $o();
  }, t;
}
var Bo = Os();
let _r = null;
function ml() {
  return _r || (typeof window < "u" ? _r = Bo(window) : _r = Bo), _r;
}
function gl(e) {
  const t = e ? document.querySelector(e) : document;
  return t ? t.querySelector(
    'button, [href], input, select, textarea, [tabIndex]:not([tabIndex="-1"])'
  ) : null;
}
const lt = (e) => ({ __html: ml().sanitize(e) }), zo = (e, t, n) => {
  let r = e;
  const i = [];
  for (; r < t; )
    r > 0 && r <= n && i.push(r), r += 1;
  return i;
};
let yi = !1;
const Ri = (e, t) => {
  yi || (yi = !0, setTimeout(() => {
    e(), yi = !1;
  }, t));
};
let Ho;
const Oi = (e, t) => {
  window.clearTimeout(Ho), Ho = window.setTimeout(e, t);
};
function vl(e) {
  if (e && typeof e.getBoundingClientRect == "function") {
    const { bottom: t, top: n } = e.getBoundingClientRect(), { offsetTop: r } = e;
    if (n < 0 && t > 0) {
      const i = e.style;
      e.style = `${i};transition: height 0s !important; overflow:hidden; height:${t}px!important;max-height:${t}px!important`, window.scrollTo({ behavior: "instant", top: r }), setTimeout(() => {
        e.style = i, window.scrollTo({
          behavior: "smooth",
          top: e.offsetTop - t / 2
        });
      }, 50);
    }
  }
}
l.shape({
  event: l.string,
  action: l.string,
  name: l.string,
  region: l.string,
  section: l.string,
  component: l.string,
  type: l.string,
  text: l.string
});
const As = ({
  event: e = "",
  action: t = "",
  name: n = "",
  type: r = "",
  section: i = "",
  text: a = "",
  region: d = "",
  component: p = ""
}) => {
  const { dataLayer: m } = window, h = {
    event: e.toLowerCase(),
    action: t.toLowerCase(),
    name: n.toLowerCase(),
    type: r.toLowerCase(),
    region: d.toLowerCase(),
    section: i.toLowerCase(),
    text: a.toLowerCase(),
    component: p.toLowerCase()
  };
  m && m.push(h);
}, sr = ({ children: e }) => /* @__PURE__ */ f.jsx(f.Fragment, { children: e });
sr.propTypes = {
  children: l.oneOfType([
    l.arrayOf(l.node),
    l.node,
    l.string
  ])
};
var xi = { exports: {} };
var Vo;
function yl() {
  return Vo || (Vo = 1, function(e) {
    (function() {
      var t = {}.hasOwnProperty;
      function n() {
        for (var a = "", d = 0; d < arguments.length; d++) {
          var p = arguments[d];
          p && (a = i(a, r(p)));
        }
        return a;
      }
      function r(a) {
        if (typeof a == "string" || typeof a == "number")
          return a;
        if (typeof a != "object")
          return "";
        if (Array.isArray(a))
          return n.apply(null, a);
        if (a.toString !== Object.prototype.toString && !a.toString.toString().includes("[native code]"))
          return a.toString();
        var d = "";
        for (var p in a)
          t.call(a, p) && a[p] && (d = i(d, p));
        return d;
      }
      function i(a, d) {
        return d ? a ? a + " " + d : a + d : a;
      }
      e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
    })();
  }(xi)), xi.exports;
}
var xl = yl();
const xe = /* @__PURE__ */ Xi(xl);
({
  ...sr.propTypes
});
const js = ({ children: e, className: t = "container", ...n }) => /* @__PURE__ */ f.jsx("div", { className: t, ...n, children: /* @__PURE__ */ f.jsx("div", { className: "row", children: e }) });
js.propTypes = {
  children: sr.propTypes.children
};
({
  ...js.propTypes
});
sr.propTypes.children, l.oneOf(["0", "3", "4", "6", "8", "9", "12"]);
sr.propTypes.children;
const bl = l.shape({
  url: l.string,
  altText: l.string,
  cssClass: l.arrayOf(l.string),
  size: l.oneOf(["small", "medium", "large"])
}), bi = l.shape({
  text: l.string,
  maxWidth: l.string,
  cssClass: l.arrayOf(l.string),
  highlightColor: l.oneOf(["gold", "black"])
}), Ns = l.shape({
  color: l.oneOf(["gold", "maroon", "gray", "dark"]),
  content: l.shape({
    icon: l.arrayOf(l.string),
    header: l.string,
    body: l.string
  })
}), Ki = l.shape({
  text: l.string,
  name: l.string,
  event: l.string,
  action: l.string,
  type: l.string,
  region: l.string,
  section: l.string,
  component: l.string
});
var an = {}, Tn = {};
var Wo;
function wl() {
  if (Wo) return Tn;
  Wo = 1;
  var e = Ve;
  function t(o) {
    for (var u = "https://reactjs.org/docs/error-decoder.html?invariant=" + o, v = 1; v < arguments.length; v++) u += "&args[]=" + encodeURIComponent(arguments[v]);
    return "Minified React error #" + o + "; visit " + u + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var n = Object.prototype.hasOwnProperty, r = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, i = {}, a = {};
  function d(o) {
    return n.call(a, o) ? !0 : n.call(i, o) ? !1 : r.test(o) ? a[o] = !0 : (i[o] = !0, !1);
  }
  function p(o, u, v, x, O, T, P) {
    this.acceptsBooleans = u === 2 || u === 3 || u === 4, this.attributeName = x, this.attributeNamespace = O, this.mustUseProperty = v, this.propertyName = o, this.type = u, this.sanitizeURL = T, this.removeEmptyString = P;
  }
  var m = {};
  "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(o) {
    m[o] = new p(o, 0, !1, o, null, !1, !1);
  }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(o) {
    var u = o[0];
    m[u] = new p(u, 1, !1, o[1], null, !1, !1);
  }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(o) {
    m[o] = new p(o, 2, !1, o.toLowerCase(), null, !1, !1);
  }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(o) {
    m[o] = new p(o, 2, !1, o, null, !1, !1);
  }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(o) {
    m[o] = new p(o, 3, !1, o.toLowerCase(), null, !1, !1);
  }), ["checked", "multiple", "muted", "selected"].forEach(function(o) {
    m[o] = new p(o, 3, !0, o, null, !1, !1);
  }), ["capture", "download"].forEach(function(o) {
    m[o] = new p(o, 4, !1, o, null, !1, !1);
  }), ["cols", "rows", "size", "span"].forEach(function(o) {
    m[o] = new p(o, 6, !1, o, null, !1, !1);
  }), ["rowSpan", "start"].forEach(function(o) {
    m[o] = new p(o, 5, !1, o.toLowerCase(), null, !1, !1);
  });
  var h = /[\-:]([a-z])/g;
  function b(o) {
    return o[1].toUpperCase();
  }
  "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(o) {
    var u = o.replace(
      h,
      b
    );
    m[u] = new p(u, 1, !1, o, null, !1, !1);
  }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(o) {
    var u = o.replace(h, b);
    m[u] = new p(u, 1, !1, o, "http://www.w3.org/1999/xlink", !1, !1);
  }), ["xml:base", "xml:lang", "xml:space"].forEach(function(o) {
    var u = o.replace(h, b);
    m[u] = new p(u, 1, !1, o, "http://www.w3.org/XML/1998/namespace", !1, !1);
  }), ["tabIndex", "crossOrigin"].forEach(function(o) {
    m[o] = new p(o, 1, !1, o.toLowerCase(), null, !1, !1);
  }), m.xlinkHref = new p("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1), ["src", "href", "action", "formAction"].forEach(function(o) {
    m[o] = new p(o, 1, !1, o.toLowerCase(), null, !0, !0);
  });
  var k = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
  }, _ = ["Webkit", "ms", "Moz", "O"];
  Object.keys(k).forEach(function(o) {
    _.forEach(function(u) {
      u = u + o.charAt(0).toUpperCase() + o.substring(1), k[u] = k[o];
    });
  });
  var I = /["'&<>]/;
  function C(o) {
    if (typeof o == "boolean" || typeof o == "number") return "" + o;
    o = "" + o;
    var u = I.exec(o);
    if (u) {
      var v = "", x, O = 0;
      for (x = u.index; x < o.length; x++) {
        switch (o.charCodeAt(x)) {
          case 34:
            u = "&quot;";
            break;
          case 38:
            u = "&amp;";
            break;
          case 39:
            u = "&#x27;";
            break;
          case 60:
            u = "&lt;";
            break;
          case 62:
            u = "&gt;";
            break;
          default:
            continue;
        }
        O !== x && (v += o.substring(O, x)), O = x + 1, v += u;
      }
      o = O !== x ? v + o.substring(O, x) : v;
    }
    return o;
  }
  var w = /([A-Z])/g, N = /^ms-/, M = Array.isArray;
  function D(o, u) {
    return { insertionMode: o, selectedValue: u };
  }
  function V(o, u, v) {
    switch (u) {
      case "select":
        return D(1, v.value != null ? v.value : v.defaultValue);
      case "svg":
        return D(2, null);
      case "math":
        return D(3, null);
      case "foreignObject":
        return D(1, null);
      case "table":
        return D(4, null);
      case "thead":
      case "tbody":
      case "tfoot":
        return D(5, null);
      case "colgroup":
        return D(7, null);
      case "tr":
        return D(6, null);
    }
    return 4 <= o.insertionMode || o.insertionMode === 0 ? D(1, null) : o;
  }
  var W = /* @__PURE__ */ new Map();
  function A(o, u, v) {
    if (typeof v != "object") throw Error(t(62));
    u = !0;
    for (var x in v) if (n.call(v, x)) {
      var O = v[x];
      if (O != null && typeof O != "boolean" && O !== "") {
        if (x.indexOf("--") === 0) {
          var T = C(x);
          O = C(("" + O).trim());
        } else {
          T = x;
          var P = W.get(T);
          P !== void 0 || (P = C(T.replace(w, "-$1").toLowerCase().replace(N, "-ms-")), W.set(T, P)), T = P, O = typeof O == "number" ? O === 0 || n.call(k, x) ? "" + O : O + "px" : C(("" + O).trim());
        }
        u ? (u = !1, o.push(' style="', T, ":", O)) : o.push(";", T, ":", O);
      }
    }
    u || o.push('"');
  }
  function X(o, u, v, x) {
    switch (v) {
      case "style":
        A(o, u, x);
        return;
      case "defaultValue":
      case "defaultChecked":
      case "innerHTML":
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
        return;
    }
    if (!(2 < v.length) || v[0] !== "o" && v[0] !== "O" || v[1] !== "n" && v[1] !== "N") {
      if (u = m.hasOwnProperty(v) ? m[v] : null, u !== null) {
        switch (typeof x) {
          case "function":
          case "symbol":
            return;
          case "boolean":
            if (!u.acceptsBooleans) return;
        }
        switch (v = u.attributeName, u.type) {
          case 3:
            x && o.push(" ", v, '=""');
            break;
          case 4:
            x === !0 ? o.push(" ", v, '=""') : x !== !1 && o.push(" ", v, '="', C(x), '"');
            break;
          case 5:
            isNaN(x) || o.push(" ", v, '="', C(x), '"');
            break;
          case 6:
            !isNaN(x) && 1 <= x && o.push(" ", v, '="', C(x), '"');
            break;
          default:
            u.sanitizeURL && (x = "" + x), o.push(" ", v, '="', C(x), '"');
        }
      } else if (d(v)) {
        switch (typeof x) {
          case "function":
          case "symbol":
            return;
          case "boolean":
            if (u = v.toLowerCase().slice(0, 5), u !== "data-" && u !== "aria-") return;
        }
        o.push(" ", v, '="', C(x), '"');
      }
    }
  }
  function re(o, u, v) {
    if (u != null) {
      if (v != null) throw Error(t(60));
      if (typeof u != "object" || !("__html" in u)) throw Error(t(61));
      u = u.__html, u != null && o.push("" + u);
    }
  }
  function Me(o) {
    var u = "";
    return e.Children.forEach(o, function(v) {
      v != null && (u += v);
    }), u;
  }
  function Ne(o, u, v, x) {
    o.push(fe(v));
    var O = v = null, T;
    for (T in u) if (n.call(u, T)) {
      var P = u[T];
      if (P != null) switch (T) {
        case "children":
          v = P;
          break;
        case "dangerouslySetInnerHTML":
          O = P;
          break;
        default:
          X(o, x, T, P);
      }
    }
    return o.push(">"), re(o, O, v), typeof v == "string" ? (o.push(C(v)), null) : v;
  }
  var De = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, ve = /* @__PURE__ */ new Map();
  function fe(o) {
    var u = ve.get(o);
    if (u === void 0) {
      if (!De.test(o)) throw Error(t(65, o));
      u = "<" + o, ve.set(o, u);
    }
    return u;
  }
  function Z(o, u, v, x, O) {
    switch (u) {
      case "select":
        o.push(fe("select"));
        var T = null, P = null;
        for (le in v) if (n.call(v, le)) {
          var H = v[le];
          if (H != null) switch (le) {
            case "children":
              T = H;
              break;
            case "dangerouslySetInnerHTML":
              P = H;
              break;
            case "defaultValue":
            case "value":
              break;
            default:
              X(o, x, le, H);
          }
        }
        return o.push(">"), re(o, P, T), T;
      case "option":
        P = O.selectedValue, o.push(fe("option"));
        var ee = H = null, ne = null, le = null;
        for (T in v) if (n.call(v, T)) {
          var $e = v[T];
          if ($e != null) switch (T) {
            case "children":
              H = $e;
              break;
            case "selected":
              ne = $e;
              break;
            case "dangerouslySetInnerHTML":
              le = $e;
              break;
            case "value":
              ee = $e;
            default:
              X(o, x, T, $e);
          }
        }
        if (P != null) if (v = ee !== null ? "" + ee : Me(H), M(P)) {
          for (x = 0; x < P.length; x++)
            if ("" + P[x] === v) {
              o.push(' selected=""');
              break;
            }
        } else "" + P === v && o.push(' selected=""');
        else ne && o.push(' selected=""');
        return o.push(">"), re(o, le, H), H;
      case "textarea":
        o.push(fe("textarea")), le = P = T = null;
        for (H in v) if (n.call(v, H) && (ee = v[H], ee != null)) switch (H) {
          case "children":
            le = ee;
            break;
          case "value":
            T = ee;
            break;
          case "defaultValue":
            P = ee;
            break;
          case "dangerouslySetInnerHTML":
            throw Error(t(91));
          default:
            X(
              o,
              x,
              H,
              ee
            );
        }
        if (T === null && P !== null && (T = P), o.push(">"), le != null) {
          if (T != null) throw Error(t(92));
          if (M(le) && 1 < le.length) throw Error(t(93));
          T = "" + le;
        }
        return typeof T == "string" && T[0] === `
` && o.push(`
`), T !== null && o.push(C("" + T)), null;
      case "input":
        o.push(fe("input")), ee = le = H = T = null;
        for (P in v) if (n.call(v, P) && (ne = v[P], ne != null)) switch (P) {
          case "children":
          case "dangerouslySetInnerHTML":
            throw Error(t(399, "input"));
          case "defaultChecked":
            ee = ne;
            break;
          case "defaultValue":
            H = ne;
            break;
          case "checked":
            le = ne;
            break;
          case "value":
            T = ne;
            break;
          default:
            X(o, x, P, ne);
        }
        return le !== null ? X(o, x, "checked", le) : ee !== null && X(o, x, "checked", ee), T !== null ? X(o, x, "value", T) : H !== null && X(o, x, "value", H), o.push("/>"), null;
      case "menuitem":
        o.push(fe("menuitem"));
        for (var Rt in v) if (n.call(v, Rt) && (T = v[Rt], T != null)) switch (Rt) {
          case "children":
          case "dangerouslySetInnerHTML":
            throw Error(t(400));
          default:
            X(o, x, Rt, T);
        }
        return o.push(">"), null;
      case "title":
        o.push(fe("title")), T = null;
        for ($e in v) if (n.call(v, $e) && (P = v[$e], P != null)) switch ($e) {
          case "children":
            T = P;
            break;
          case "dangerouslySetInnerHTML":
            throw Error(t(434));
          default:
            X(o, x, $e, P);
        }
        return o.push(">"), T;
      case "listing":
      case "pre":
        o.push(fe(u)), P = T = null;
        for (ee in v) if (n.call(v, ee) && (H = v[ee], H != null)) switch (ee) {
          case "children":
            T = H;
            break;
          case "dangerouslySetInnerHTML":
            P = H;
            break;
          default:
            X(o, x, ee, H);
        }
        if (o.push(">"), P != null) {
          if (T != null) throw Error(t(60));
          if (typeof P != "object" || !("__html" in P)) throw Error(t(61));
          v = P.__html, v != null && (typeof v == "string" && 0 < v.length && v[0] === `
` ? o.push(`
`, v) : o.push("" + v));
        }
        return typeof T == "string" && T[0] === `
` && o.push(`
`), T;
      case "area":
      case "base":
      case "br":
      case "col":
      case "embed":
      case "hr":
      case "img":
      case "keygen":
      case "link":
      case "meta":
      case "param":
      case "source":
      case "track":
      case "wbr":
        o.push(fe(u));
        for (var Ot in v) if (n.call(v, Ot) && (T = v[Ot], T != null)) switch (Ot) {
          case "children":
          case "dangerouslySetInnerHTML":
            throw Error(t(399, u));
          default:
            X(o, x, Ot, T);
        }
        return o.push("/>"), null;
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return Ne(
          o,
          v,
          u,
          x
        );
      case "html":
        return O.insertionMode === 0 && o.push("<!DOCTYPE html>"), Ne(o, v, u, x);
      default:
        if (u.indexOf("-") === -1 && typeof v.is != "string") return Ne(o, v, u, x);
        o.push(fe(u)), P = T = null;
        for (ne in v) if (n.call(v, ne) && (H = v[ne], H != null)) switch (ne) {
          case "children":
            T = H;
            break;
          case "dangerouslySetInnerHTML":
            P = H;
            break;
          case "style":
            A(o, x, H);
            break;
          case "suppressContentEditableWarning":
          case "suppressHydrationWarning":
            break;
          default:
            d(ne) && typeof H != "function" && typeof H != "symbol" && o.push(" ", ne, '="', C(H), '"');
        }
        return o.push(">"), re(o, P, T), T;
    }
  }
  function ue(o, u, v) {
    if (o.push('<!--$?--><template id="'), v === null) throw Error(t(395));
    return o.push(v), o.push('"></template>');
  }
  function Ae(o, u, v, x) {
    switch (v.insertionMode) {
      case 0:
      case 1:
        return o.push('<div hidden id="'), o.push(u.segmentPrefix), u = x.toString(16), o.push(u), o.push('">');
      case 2:
        return o.push('<svg aria-hidden="true" style="display:none" id="'), o.push(u.segmentPrefix), u = x.toString(16), o.push(u), o.push('">');
      case 3:
        return o.push('<math aria-hidden="true" style="display:none" id="'), o.push(u.segmentPrefix), u = x.toString(16), o.push(u), o.push('">');
      case 4:
        return o.push('<table hidden id="'), o.push(u.segmentPrefix), u = x.toString(16), o.push(u), o.push('">');
      case 5:
        return o.push('<table hidden><tbody id="'), o.push(u.segmentPrefix), u = x.toString(16), o.push(u), o.push('">');
      case 6:
        return o.push('<table hidden><tr id="'), o.push(u.segmentPrefix), u = x.toString(16), o.push(u), o.push('">');
      case 7:
        return o.push('<table hidden><colgroup id="'), o.push(u.segmentPrefix), u = x.toString(16), o.push(u), o.push('">');
      default:
        throw Error(t(397));
    }
  }
  function dt(o, u) {
    switch (u.insertionMode) {
      case 0:
      case 1:
        return o.push("</div>");
      case 2:
        return o.push("</svg>");
      case 3:
        return o.push("</math>");
      case 4:
        return o.push("</table>");
      case 5:
        return o.push("</tbody></table>");
      case 6:
        return o.push("</tr></table>");
      case 7:
        return o.push("</colgroup></table>");
      default:
        throw Error(t(397));
    }
  }
  var ze = /[<\u2028\u2029]/g;
  function He(o) {
    return JSON.stringify(o).replace(ze, function(u) {
      switch (u) {
        case "<":
          return "\\u003c";
        case "\u2028":
          return "\\u2028";
        case "\u2029":
          return "\\u2029";
        default:
          throw Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
      }
    });
  }
  function Ue(o, u) {
    return u = u === void 0 ? "" : u, { bootstrapChunks: [], startInlineScript: "<script>", placeholderPrefix: u + "P:", segmentPrefix: u + "S:", boundaryPrefix: u + "B:", idPrefix: u, nextSuspenseID: 0, sentCompleteSegmentFunction: !1, sentCompleteBoundaryFunction: !1, sentClientRenderFunction: !1, generateStaticMarkup: o };
  }
  function ft(o, u, v, x) {
    return v.generateStaticMarkup ? (o.push(C(u)), !1) : (u === "" ? o = x : (x && o.push("<!-- -->"), o.push(C(u)), o = !0), o);
  }
  var be = Object.assign, G = Symbol.for("react.element"), z = Symbol.for("react.portal"), U = Symbol.for("react.fragment"), q = Symbol.for("react.strict_mode"), j = Symbol.for("react.profiler"), de = Symbol.for("react.provider"), $ = Symbol.for("react.context"), ge = Symbol.for("react.forward_ref"), oe = Symbol.for("react.suspense"), se = Symbol.for("react.suspense_list"), Q = Symbol.for("react.memo"), ae = Symbol.for("react.lazy"), Se = Symbol.for("react.scope"), ie = Symbol.for("react.debug_trace_mode"), Ie = Symbol.for("react.legacy_hidden"), he = Symbol.for("react.default_value"), ke = Symbol.iterator;
  function Qe(o) {
    if (o == null) return null;
    if (typeof o == "function") return o.displayName || o.name || null;
    if (typeof o == "string") return o;
    switch (o) {
      case U:
        return "Fragment";
      case z:
        return "Portal";
      case j:
        return "Profiler";
      case q:
        return "StrictMode";
      case oe:
        return "Suspense";
      case se:
        return "SuspenseList";
    }
    if (typeof o == "object") switch (o.$$typeof) {
      case $:
        return (o.displayName || "Context") + ".Consumer";
      case de:
        return (o._context.displayName || "Context") + ".Provider";
      case ge:
        var u = o.render;
        return o = o.displayName, o || (o = u.displayName || u.name || "", o = o !== "" ? "ForwardRef(" + o + ")" : "ForwardRef"), o;
      case Q:
        return u = o.displayName || null, u !== null ? u : Qe(o.type) || "Memo";
      case ae:
        u = o._payload, o = o._init;
        try {
          return Qe(o(u));
        } catch {
        }
    }
    return null;
  }
  var Ce = {};
  function wt(o, u) {
    if (o = o.contextTypes, !o) return Ce;
    var v = {}, x;
    for (x in o) v[x] = u[x];
    return v;
  }
  var Ge = null;
  function Re(o, u) {
    if (o !== u) {
      o.context._currentValue2 = o.parentValue, o = o.parent;
      var v = u.parent;
      if (o === null) {
        if (v !== null) throw Error(t(401));
      } else {
        if (v === null) throw Error(t(401));
        Re(o, v);
      }
      u.context._currentValue2 = u.value;
    }
  }
  function J(o) {
    o.context._currentValue2 = o.parentValue, o = o.parent, o !== null && J(o);
  }
  function we(o) {
    var u = o.parent;
    u !== null && we(u), o.context._currentValue2 = o.value;
  }
  function it(o, u) {
    if (o.context._currentValue2 = o.parentValue, o = o.parent, o === null) throw Error(t(402));
    o.depth === u.depth ? Re(o, u) : it(o, u);
  }
  function Xe(o, u) {
    var v = u.parent;
    if (v === null) throw Error(t(402));
    o.depth === v.depth ? Re(o, v) : Xe(o, v), u.context._currentValue2 = u.value;
  }
  function Ke(o) {
    var u = Ge;
    u !== o && (u === null ? we(o) : o === null ? J(u) : u.depth === o.depth ? Re(u, o) : u.depth > o.depth ? it(u, o) : Xe(u, o), Ge = o);
  }
  var dn = { isMounted: function() {
    return !1;
  }, enqueueSetState: function(o, u) {
    o = o._reactInternals, o.queue !== null && o.queue.push(u);
  }, enqueueReplaceState: function(o, u) {
    o = o._reactInternals, o.replace = !0, o.queue = [u];
  }, enqueueForceUpdate: function() {
  } };
  function fn(o, u, v, x) {
    var O = o.state !== void 0 ? o.state : null;
    o.updater = dn, o.props = v, o.state = O;
    var T = { queue: [], replace: !1 };
    o._reactInternals = T;
    var P = u.contextType;
    if (o.context = typeof P == "object" && P !== null ? P._currentValue2 : x, P = u.getDerivedStateFromProps, typeof P == "function" && (P = P(v, O), O = P == null ? O : be({}, O, P), o.state = O), typeof u.getDerivedStateFromProps != "function" && typeof o.getSnapshotBeforeUpdate != "function" && (typeof o.UNSAFE_componentWillMount == "function" || typeof o.componentWillMount == "function")) if (u = o.state, typeof o.componentWillMount == "function" && o.componentWillMount(), typeof o.UNSAFE_componentWillMount == "function" && o.UNSAFE_componentWillMount(), u !== o.state && dn.enqueueReplaceState(o, o.state, null), T.queue !== null && 0 < T.queue.length) if (u = T.queue, P = T.replace, T.queue = null, T.replace = !1, P && u.length === 1) o.state = u[0];
    else {
      for (T = P ? u[0] : o.state, O = !0, P = P ? 1 : 0; P < u.length; P++) {
        var H = u[P];
        H = typeof H == "function" ? H.call(o, T, v, x) : H, H != null && (O ? (O = !1, T = be({}, T, H)) : be(T, H));
      }
      o.state = T;
    }
    else T.queue = null;
  }
  var pn = { id: 1, overflow: "" };
  function Zt(o, u, v) {
    var x = o.id;
    o = o.overflow;
    var O = 32 - kt(x) - 1;
    x &= ~(1 << O), v += 1;
    var T = 32 - kt(u) + O;
    if (30 < T) {
      var P = O - O % 5;
      return T = (x & (1 << P) - 1).toString(32), x >>= P, O -= P, { id: 1 << 32 - kt(u) + O | v << O | x, overflow: T + o };
    }
    return { id: 1 << T | v << O | x, overflow: o };
  }
  var kt = Math.clz32 ? Math.clz32 : Lt, Jt = Math.log, pt = Math.LN2;
  function Lt(o) {
    return o >>>= 0, o === 0 ? 32 : 31 - (Jt(o) / pt | 0) | 0;
  }
  function hn(o, u) {
    return o === u && (o !== 0 || 1 / o === 1 / u) || o !== o && u !== u;
  }
  var mn = typeof Object.is == "function" ? Object.is : hn, ht = null, Mt = null, Tt = null, Te = null, gt = !1, Qt = !1, zt = 0, _e = null, vt = 0;
  function _t() {
    if (ht === null) throw Error(t(321));
    return ht;
  }
  function gn() {
    if (0 < vt) throw Error(t(312));
    return { memoizedState: null, queue: null, next: null };
  }
  function Ht() {
    return Te === null ? Tt === null ? (gt = !1, Tt = Te = gn()) : (gt = !0, Te = Tt) : Te.next === null ? (gt = !1, Te = Te.next = gn()) : (gt = !0, Te = Te.next), Te;
  }
  function en() {
    Mt = ht = null, Qt = !1, Tt = null, vt = 0, Te = _e = null;
  }
  function vn(o, u) {
    return typeof u == "function" ? u(o) : u;
  }
  function On(o, u, v) {
    if (ht = _t(), Te = Ht(), gt) {
      var x = Te.queue;
      if (u = x.dispatch, _e !== null && (v = _e.get(x), v !== void 0)) {
        _e.delete(x), x = Te.memoizedState;
        do
          x = o(x, v.action), v = v.next;
        while (v !== null);
        return Te.memoizedState = x, [x, u];
      }
      return [Te.memoizedState, u];
    }
    return o = o === vn ? typeof u == "function" ? u() : u : v !== void 0 ? v(u) : u, Te.memoizedState = o, o = Te.queue = { last: null, dispatch: null }, o = o.dispatch = Et.bind(null, ht, o), [Te.memoizedState, o];
  }
  function nt(o, u) {
    if (ht = _t(), Te = Ht(), u = u === void 0 ? null : u, Te !== null) {
      var v = Te.memoizedState;
      if (v !== null && u !== null) {
        var x = v[1];
        e: if (x === null) x = !1;
        else {
          for (var O = 0; O < x.length && O < u.length; O++) if (!mn(u[O], x[O])) {
            x = !1;
            break e;
          }
          x = !0;
        }
        if (x) return v[0];
      }
    }
    return o = o(), Te.memoizedState = [o, u], o;
  }
  function Et(o, u, v) {
    if (25 <= vt) throw Error(t(301));
    if (o === ht) if (Qt = !0, o = { action: v, next: null }, _e === null && (_e = /* @__PURE__ */ new Map()), v = _e.get(u), v === void 0) _e.set(u, o);
    else {
      for (u = v; u.next !== null; ) u = u.next;
      u.next = o;
    }
  }
  function An() {
    throw Error(t(394));
  }
  function Vt() {
  }
  var tn = { readContext: function(o) {
    return o._currentValue2;
  }, useContext: function(o) {
    return _t(), o._currentValue2;
  }, useMemo: nt, useReducer: On, useRef: function(o) {
    ht = _t(), Te = Ht();
    var u = Te.memoizedState;
    return u === null ? (o = { current: o }, Te.memoizedState = o) : u;
  }, useState: function(o) {
    return On(vn, o);
  }, useInsertionEffect: Vt, useLayoutEffect: function() {
  }, useCallback: function(o, u) {
    return nt(function() {
      return o;
    }, u);
  }, useImperativeHandle: Vt, useEffect: Vt, useDebugValue: Vt, useDeferredValue: function(o) {
    return _t(), o;
  }, useTransition: function() {
    return _t(), [
      !1,
      An
    ];
  }, useId: function() {
    var o = Mt.treeContext, u = o.overflow;
    o = o.id, o = (o & ~(1 << 32 - kt(o) - 1)).toString(32) + u;
    var v = Dt;
    if (v === null) throw Error(t(404));
    return u = zt++, o = ":" + v.idPrefix + "R" + o, 0 < u && (o += "H" + u.toString(32)), o + ":";
  }, useMutableSource: function(o, u) {
    return _t(), u(o._source);
  }, useSyncExternalStore: function(o, u, v) {
    if (v === void 0) throw Error(t(407));
    return v();
  } }, Dt = null, ot = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;
  function jn(o) {
    return console.error(o), null;
  }
  function Ft() {
  }
  function Nn(o, u, v, x, O, T, P, H, ee) {
    var ne = [], le = /* @__PURE__ */ new Set();
    return u = { destination: null, responseState: u, progressiveChunkSize: x === void 0 ? 12800 : x, status: 0, fatalError: null, nextSegmentId: 0, allPendingTasks: 0, pendingRootTasks: 0, completedRootSegment: null, abortableTasks: le, pingedTasks: ne, clientRenderedBoundaries: [], completedBoundaries: [], partialBoundaries: [], onError: O === void 0 ? jn : O, onAllReady: Ft, onShellReady: P === void 0 ? Ft : P, onShellError: Ft, onFatalError: Ft }, v = Wt(u, 0, null, v, !1, !1), v.parentFlushed = !0, o = nn(u, o, null, v, le, Ce, null, pn), ne.push(o), u;
  }
  function nn(o, u, v, x, O, T, P, H) {
    o.allPendingTasks++, v === null ? o.pendingRootTasks++ : v.pendingTasks++;
    var ee = { node: u, ping: function() {
      var ne = o.pingedTasks;
      ne.push(ee), ne.length === 1 && yn(o);
    }, blockedBoundary: v, blockedSegment: x, abortSet: O, legacyContext: T, context: P, treeContext: H };
    return O.add(ee), ee;
  }
  function Wt(o, u, v, x, O, T) {
    return { status: 0, id: -1, index: u, parentFlushed: !1, chunks: [], children: [], formatContext: x, boundary: v, lastPushedText: O, textEmbedded: T };
  }
  function K(o, u) {
    if (o = o.onError(u), o != null && typeof o != "string") throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof o + '" instead');
    return o;
  }
  function S(o, u) {
    var v = o.onShellError;
    v(u), v = o.onFatalError, v(u), o.destination !== null ? (o.status = 2, o.destination.destroy(u)) : (o.status = 1, o.fatalError = u);
  }
  function F(o, u, v, x, O) {
    for (ht = {}, Mt = u, zt = 0, o = v(x, O); Qt; ) Qt = !1, zt = 0, vt += 1, Te = null, o = v(x, O);
    return en(), o;
  }
  function Y(o, u, v, x) {
    var O = v.render(), T = x.childContextTypes;
    if (T != null) {
      var P = u.legacyContext;
      if (typeof v.getChildContext != "function") x = P;
      else {
        v = v.getChildContext();
        for (var H in v) if (!(H in T)) throw Error(t(108, Qe(x) || "Unknown", H));
        x = be({}, P, v);
      }
      u.legacyContext = x, ye(o, u, O), u.legacyContext = P;
    } else ye(o, u, O);
  }
  function Oe(o, u) {
    if (o && o.defaultProps) {
      u = be({}, u), o = o.defaultProps;
      for (var v in o) u[v] === void 0 && (u[v] = o[v]);
      return u;
    }
    return u;
  }
  function We(o, u, v, x, O) {
    if (typeof v == "function") if (v.prototype && v.prototype.isReactComponent) {
      O = wt(v, u.legacyContext);
      var T = v.contextType;
      T = new v(x, typeof T == "object" && T !== null ? T._currentValue2 : O), fn(T, v, x, O), Y(o, u, T, v);
    } else {
      T = wt(v, u.legacyContext), O = F(o, u, v, x, T);
      var P = zt !== 0;
      if (typeof O == "object" && O !== null && typeof O.render == "function" && O.$$typeof === void 0) fn(O, v, x, T), Y(o, u, O, v);
      else if (P) {
        x = u.treeContext, u.treeContext = Zt(x, 1, 0);
        try {
          ye(o, u, O);
        } finally {
          u.treeContext = x;
        }
      } else ye(o, u, O);
    }
    else if (typeof v == "string") {
      switch (O = u.blockedSegment, T = Z(O.chunks, v, x, o.responseState, O.formatContext), O.lastPushedText = !1, P = O.formatContext, O.formatContext = V(P, v, x), Je(o, u, T), O.formatContext = P, v) {
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "input":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
          break;
        default:
          O.chunks.push("</", v, ">");
      }
      O.lastPushedText = !1;
    } else {
      switch (v) {
        case Ie:
        case ie:
        case q:
        case j:
        case U:
          ye(o, u, x.children);
          return;
        case se:
          ye(o, u, x.children);
          return;
        case Se:
          throw Error(t(343));
        case oe:
          e: {
            v = u.blockedBoundary, O = u.blockedSegment, T = x.fallback, x = x.children, P = /* @__PURE__ */ new Set();
            var H = { id: null, rootSegmentID: -1, parentFlushed: !1, pendingTasks: 0, forceClientRender: !1, completedSegments: [], byteSize: 0, fallbackAbortableTasks: P, errorDigest: null }, ee = Wt(o, O.chunks.length, H, O.formatContext, !1, !1);
            O.children.push(ee), O.lastPushedText = !1;
            var ne = Wt(o, 0, null, O.formatContext, !1, !1);
            ne.parentFlushed = !0, u.blockedBoundary = H, u.blockedSegment = ne;
            try {
              if (Je(
                o,
                u,
                x
              ), o.responseState.generateStaticMarkup || ne.lastPushedText && ne.textEmbedded && ne.chunks.push("<!-- -->"), ne.status = 1, Pe(H, ne), H.pendingTasks === 0) break e;
            } catch (le) {
              ne.status = 4, H.forceClientRender = !0, H.errorDigest = K(o, le);
            } finally {
              u.blockedBoundary = v, u.blockedSegment = O;
            }
            u = nn(o, T, v, ee, P, u.legacyContext, u.context, u.treeContext), o.pingedTasks.push(u);
          }
          return;
      }
      if (typeof v == "object" && v !== null) switch (v.$$typeof) {
        case ge:
          if (x = F(o, u, v.render, x, O), zt !== 0) {
            v = u.treeContext, u.treeContext = Zt(v, 1, 0);
            try {
              ye(o, u, x);
            } finally {
              u.treeContext = v;
            }
          } else ye(o, u, x);
          return;
        case Q:
          v = v.type, x = Oe(v, x), We(o, u, v, x, O);
          return;
        case de:
          if (O = x.children, v = v._context, x = x.value, T = v._currentValue2, v._currentValue2 = x, P = Ge, Ge = x = { parent: P, depth: P === null ? 0 : P.depth + 1, context: v, parentValue: T, value: x }, u.context = x, ye(o, u, O), o = Ge, o === null) throw Error(t(403));
          x = o.parentValue, o.context._currentValue2 = x === he ? o.context._defaultValue : x, o = Ge = o.parent, u.context = o;
          return;
        case $:
          x = x.children, x = x(v._currentValue2), ye(o, u, x);
          return;
        case ae:
          O = v._init, v = O(v._payload), x = Oe(v, x), We(
            o,
            u,
            v,
            x,
            void 0
          );
          return;
      }
      throw Error(t(130, v == null ? v : typeof v, ""));
    }
  }
  function ye(o, u, v) {
    if (u.node = v, typeof v == "object" && v !== null) {
      switch (v.$$typeof) {
        case G:
          We(o, u, v.type, v.props, v.ref);
          return;
        case z:
          throw Error(t(257));
        case ae:
          var x = v._init;
          v = x(v._payload), ye(o, u, v);
          return;
      }
      if (M(v)) {
        Ze(o, u, v);
        return;
      }
      if (v === null || typeof v != "object" ? x = null : (x = ke && v[ke] || v["@@iterator"], x = typeof x == "function" ? x : null), x && (x = x.call(v))) {
        if (v = x.next(), !v.done) {
          var O = [];
          do
            O.push(v.value), v = x.next();
          while (!v.done);
          Ze(o, u, O);
        }
        return;
      }
      throw o = Object.prototype.toString.call(v), Error(t(31, o === "[object Object]" ? "object with keys {" + Object.keys(v).join(", ") + "}" : o));
    }
    typeof v == "string" ? (x = u.blockedSegment, x.lastPushedText = ft(u.blockedSegment.chunks, v, o.responseState, x.lastPushedText)) : typeof v == "number" && (x = u.blockedSegment, x.lastPushedText = ft(u.blockedSegment.chunks, "" + v, o.responseState, x.lastPushedText));
  }
  function Ze(o, u, v) {
    for (var x = v.length, O = 0; O < x; O++) {
      var T = u.treeContext;
      u.treeContext = Zt(T, x, O);
      try {
        Je(o, u, v[O]);
      } finally {
        u.treeContext = T;
      }
    }
  }
  function Je(o, u, v) {
    var x = u.blockedSegment.formatContext, O = u.legacyContext, T = u.context;
    try {
      return ye(o, u, v);
    } catch (ee) {
      if (en(), typeof ee == "object" && ee !== null && typeof ee.then == "function") {
        v = ee;
        var P = u.blockedSegment, H = Wt(o, P.chunks.length, null, P.formatContext, P.lastPushedText, !0);
        P.children.push(H), P.lastPushedText = !1, o = nn(o, u.node, u.blockedBoundary, H, u.abortSet, u.legacyContext, u.context, u.treeContext).ping, v.then(o, o), u.blockedSegment.formatContext = x, u.legacyContext = O, u.context = T, Ke(T);
      } else throw u.blockedSegment.formatContext = x, u.legacyContext = O, u.context = T, Ke(T), ee;
    }
  }
  function mt(o) {
    var u = o.blockedBoundary;
    o = o.blockedSegment, o.status = 3, Ct(this, u, o);
  }
  function rn(o, u, v) {
    var x = o.blockedBoundary;
    o.blockedSegment.status = 3, x === null ? (u.allPendingTasks--, u.status !== 2 && (u.status = 2, u.destination !== null && u.destination.push(null))) : (x.pendingTasks--, x.forceClientRender || (x.forceClientRender = !0, o = v === void 0 ? Error(t(432)) : v, x.errorDigest = u.onError(o), x.parentFlushed && u.clientRenderedBoundaries.push(x)), x.fallbackAbortableTasks.forEach(function(O) {
      return rn(O, u, v);
    }), x.fallbackAbortableTasks.clear(), u.allPendingTasks--, u.allPendingTasks === 0 && (x = u.onAllReady, x()));
  }
  function Pe(o, u) {
    if (u.chunks.length === 0 && u.children.length === 1 && u.children[0].boundary === null) {
      var v = u.children[0];
      v.id = u.id, v.parentFlushed = !0, v.status === 1 && Pe(o, v);
    } else o.completedSegments.push(u);
  }
  function Ct(o, u, v) {
    if (u === null) {
      if (v.parentFlushed) {
        if (o.completedRootSegment !== null) throw Error(t(389));
        o.completedRootSegment = v;
      }
      o.pendingRootTasks--, o.pendingRootTasks === 0 && (o.onShellError = Ft, u = o.onShellReady, u());
    } else u.pendingTasks--, u.forceClientRender || (u.pendingTasks === 0 ? (v.parentFlushed && v.status === 1 && Pe(u, v), u.parentFlushed && o.completedBoundaries.push(u), u.fallbackAbortableTasks.forEach(mt, o), u.fallbackAbortableTasks.clear()) : v.parentFlushed && v.status === 1 && (Pe(u, v), u.completedSegments.length === 1 && u.parentFlushed && o.partialBoundaries.push(u)));
    o.allPendingTasks--, o.allPendingTasks === 0 && (o = o.onAllReady, o());
  }
  function yn(o) {
    if (o.status !== 2) {
      var u = Ge, v = ot.current;
      ot.current = tn;
      var x = Dt;
      Dt = o.responseState;
      try {
        var O = o.pingedTasks, T;
        for (T = 0; T < O.length; T++) {
          var P = O[T], H = o, ee = P.blockedSegment;
          if (ee.status === 0) {
            Ke(P.context);
            try {
              ye(H, P, P.node), H.responseState.generateStaticMarkup || ee.lastPushedText && ee.textEmbedded && ee.chunks.push("<!-- -->"), P.abortSet.delete(P), ee.status = 1, Ct(H, P.blockedBoundary, ee);
            } catch (yt) {
              if (en(), typeof yt == "object" && yt !== null && typeof yt.then == "function") {
                var ne = P.ping;
                yt.then(ne, ne);
              } else {
                P.abortSet.delete(P), ee.status = 4;
                var le = P.blockedBoundary, $e = yt, Rt = K(H, $e);
                if (le === null ? S(H, $e) : (le.pendingTasks--, le.forceClientRender || (le.forceClientRender = !0, le.errorDigest = Rt, le.parentFlushed && H.clientRenderedBoundaries.push(le))), H.allPendingTasks--, H.allPendingTasks === 0) {
                  var Ot = H.onAllReady;
                  Ot();
                }
              }
            } finally {
            }
          }
        }
        O.splice(0, T), o.destination !== null && In(o, o.destination);
      } catch (yt) {
        K(o, yt), S(o, yt);
      } finally {
        Dt = x, ot.current = v, v === tn && Ke(u);
      }
    }
  }
  function xn(o, u, v) {
    switch (v.parentFlushed = !0, v.status) {
      case 0:
        var x = v.id = o.nextSegmentId++;
        return v.lastPushedText = !1, v.textEmbedded = !1, o = o.responseState, u.push('<template id="'), u.push(o.placeholderPrefix), o = x.toString(16), u.push(o), u.push('"></template>');
      case 1:
        v.status = 2;
        var O = !0;
        x = v.chunks;
        var T = 0;
        v = v.children;
        for (var P = 0; P < v.length; P++) {
          for (O = v[P]; T < O.index; T++) u.push(x[T]);
          O = bn(o, u, O);
        }
        for (; T < x.length - 1; T++) u.push(x[T]);
        return T < x.length && (O = u.push(x[T])), O;
      default:
        throw Error(t(390));
    }
  }
  function bn(o, u, v) {
    var x = v.boundary;
    if (x === null) return xn(o, u, v);
    if (x.parentFlushed = !0, x.forceClientRender) return o.responseState.generateStaticMarkup || (x = x.errorDigest, u.push("<!--$!-->"), u.push("<template"), x && (u.push(' data-dgst="'), x = C(x), u.push(x), u.push('"')), u.push("></template>")), xn(o, u, v), o = o.responseState.generateStaticMarkup ? !0 : u.push("<!--/$-->"), o;
    if (0 < x.pendingTasks) {
      x.rootSegmentID = o.nextSegmentId++, 0 < x.completedSegments.length && o.partialBoundaries.push(x);
      var O = o.responseState, T = O.nextSuspenseID++;
      return O = O.boundaryPrefix + T.toString(16), x = x.id = O, ue(u, o.responseState, x), xn(o, u, v), u.push("<!--/$-->");
    }
    if (x.byteSize > o.progressiveChunkSize) return x.rootSegmentID = o.nextSegmentId++, o.completedBoundaries.push(x), ue(u, o.responseState, x.id), xn(o, u, v), u.push("<!--/$-->");
    if (o.responseState.generateStaticMarkup || u.push("<!--$-->"), v = x.completedSegments, v.length !== 1) throw Error(t(391));
    return bn(o, u, v[0]), o = o.responseState.generateStaticMarkup ? !0 : u.push("<!--/$-->"), o;
  }
  function zn(o, u, v) {
    return Ae(u, o.responseState, v.formatContext, v.id), bn(o, u, v), dt(u, v.formatContext);
  }
  function Hn(o, u, v) {
    for (var x = v.completedSegments, O = 0; O < x.length; O++) Vn(o, u, v, x[O]);
    if (x.length = 0, o = o.responseState, x = v.id, v = v.rootSegmentID, u.push(o.startInlineScript), o.sentCompleteBoundaryFunction ? u.push('$RC("') : (o.sentCompleteBoundaryFunction = !0, u.push('function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}};$RC("')), x === null) throw Error(t(395));
    return v = v.toString(16), u.push(x), u.push('","'), u.push(o.segmentPrefix), u.push(v), u.push('")<\/script>');
  }
  function Vn(o, u, v, x) {
    if (x.status === 2) return !0;
    var O = x.id;
    if (O === -1) {
      if ((x.id = v.rootSegmentID) === -1) throw Error(t(392));
      return zn(o, u, x);
    }
    return zn(o, u, x), o = o.responseState, u.push(o.startInlineScript), o.sentCompleteSegmentFunction ? u.push('$RS("') : (o.sentCompleteSegmentFunction = !0, u.push('function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("')), u.push(o.segmentPrefix), O = O.toString(16), u.push(O), u.push('","'), u.push(o.placeholderPrefix), u.push(O), u.push('")<\/script>');
  }
  function In(o, u) {
    try {
      var v = o.completedRootSegment;
      if (v !== null && o.pendingRootTasks === 0) {
        bn(o, u, v), o.completedRootSegment = null;
        var x = o.responseState.bootstrapChunks;
        for (v = 0; v < x.length - 1; v++) u.push(x[v]);
        v < x.length && u.push(x[v]);
      }
      var O = o.clientRenderedBoundaries, T;
      for (T = 0; T < O.length; T++) {
        var P = O[T];
        x = u;
        var H = o.responseState, ee = P.id, ne = P.errorDigest, le = P.errorMessage, $e = P.errorComponentStack;
        if (x.push(H.startInlineScript), H.sentClientRenderFunction ? x.push('$RX("') : (H.sentClientRenderFunction = !0, x.push('function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())};$RX("')), ee === null) throw Error(t(395));
        if (x.push(ee), x.push('"'), ne || le || $e) {
          x.push(",");
          var Rt = He(ne || "");
          x.push(Rt);
        }
        if (le || $e) {
          x.push(",");
          var Ot = He(le || "");
          x.push(Ot);
        }
        if ($e) {
          x.push(",");
          var yt = He($e);
          x.push(yt);
        }
        if (!x.push(")<\/script>")) {
          o.destination = null, T++, O.splice(0, T);
          return;
        }
      }
      O.splice(0, T);
      var wn = o.completedBoundaries;
      for (T = 0; T < wn.length; T++) if (!Hn(o, u, wn[T])) {
        o.destination = null, T++, wn.splice(0, T);
        return;
      }
      wn.splice(0, T);
      var qt = o.partialBoundaries;
      for (T = 0; T < qt.length; T++) {
        var qn = qt[T];
        e: {
          O = o, P = u;
          var Sn = qn.completedSegments;
          for (H = 0; H < Sn.length; H++) if (!Vn(O, P, qn, Sn[H])) {
            H++, Sn.splice(0, H);
            var dr = !1;
            break e;
          }
          Sn.splice(0, H), dr = !0;
        }
        if (!dr) {
          o.destination = null, T++, qt.splice(0, T);
          return;
        }
      }
      qt.splice(0, T);
      var on = o.completedBoundaries;
      for (T = 0; T < on.length; T++) if (!Hn(o, u, on[T])) {
        o.destination = null, T++, on.splice(0, T);
        return;
      }
      on.splice(0, T);
    } finally {
      o.allPendingTasks === 0 && o.pingedTasks.length === 0 && o.clientRenderedBoundaries.length === 0 && o.completedBoundaries.length === 0 && u.push(null);
    }
  }
  function cr(o, u) {
    try {
      var v = o.abortableTasks;
      v.forEach(function(x) {
        return rn(x, o, u);
      }), v.clear(), o.destination !== null && In(o, o.destination);
    } catch (x) {
      K(o, x), S(o, x);
    }
  }
  function ur() {
  }
  function Wn(o, u, v, x) {
    var O = !1, T = null, P = "", H = { push: function(ne) {
      return ne !== null && (P += ne), !0;
    }, destroy: function(ne) {
      O = !0, T = ne;
    } }, ee = !1;
    if (o = Nn(o, Ue(v, u ? u.identifierPrefix : void 0), { insertionMode: 1, selectedValue: null }, 1 / 0, ur, void 0, function() {
      ee = !0;
    }), yn(o), cr(o, x), o.status === 1) o.status = 2, H.destroy(o.fatalError);
    else if (o.status !== 2 && o.destination === null) {
      o.destination = H;
      try {
        In(o, H);
      } catch (ne) {
        K(o, ne), S(o, ne);
      }
    }
    if (O) throw T;
    if (!ee) throw Error(t(426));
    return P;
  }
  return Tn.renderToNodeStream = function() {
    throw Error(t(207));
  }, Tn.renderToStaticMarkup = function(o, u) {
    return Wn(o, u, !0, 'The server used "renderToStaticMarkup" which does not support Suspense. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
  }, Tn.renderToStaticNodeStream = function() {
    throw Error(t(208));
  }, Tn.renderToString = function(o, u) {
    return Wn(o, u, !1, 'The server used "renderToString" which does not support Suspense. If you intended for this Suspense boundary to render the fallback content on the server consider throwing an Error somewhere within the Suspense boundary. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
  }, Tn.version = "18.3.1", Tn;
}
var Er = {};
var qo;
function Sl() {
  if (qo) return Er;
  qo = 1;
  var e = Ve;
  function t(s) {
    for (var c = "https://reactjs.org/docs/error-decoder.html?invariant=" + s, g = 1; g < arguments.length; g++) c += "&args[]=" + encodeURIComponent(arguments[g]);
    return "Minified React error #" + s + "; visit " + c + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var n = null, r = 0;
  function i(s, c) {
    if (c.length !== 0) if (512 < c.length) 0 < r && (s.enqueue(new Uint8Array(n.buffer, 0, r)), n = new Uint8Array(512), r = 0), s.enqueue(c);
    else {
      var g = n.length - r;
      g < c.length && (g === 0 ? s.enqueue(n) : (n.set(c.subarray(0, g), r), s.enqueue(n), c = c.subarray(g)), n = new Uint8Array(512), r = 0), n.set(c, r), r += c.length;
    }
  }
  function a(s, c) {
    return i(s, c), !0;
  }
  function d(s) {
    n && 0 < r && (s.enqueue(new Uint8Array(n.buffer, 0, r)), n = null, r = 0);
  }
  var p = new TextEncoder();
  function m(s) {
    return p.encode(s);
  }
  function h(s) {
    return p.encode(s);
  }
  function b(s, c) {
    typeof s.error == "function" ? s.error(c) : s.close();
  }
  var k = Object.prototype.hasOwnProperty, _ = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, I = {}, C = {};
  function w(s) {
    return k.call(C, s) ? !0 : k.call(I, s) ? !1 : _.test(s) ? C[s] = !0 : (I[s] = !0, !1);
  }
  function N(s, c, g, y, R, E, L) {
    this.acceptsBooleans = c === 2 || c === 3 || c === 4, this.attributeName = y, this.attributeNamespace = R, this.mustUseProperty = g, this.propertyName = s, this.type = c, this.sanitizeURL = E, this.removeEmptyString = L;
  }
  var M = {};
  "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(s) {
    M[s] = new N(s, 0, !1, s, null, !1, !1);
  }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(s) {
    var c = s[0];
    M[c] = new N(c, 1, !1, s[1], null, !1, !1);
  }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(s) {
    M[s] = new N(s, 2, !1, s.toLowerCase(), null, !1, !1);
  }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(s) {
    M[s] = new N(s, 2, !1, s, null, !1, !1);
  }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(s) {
    M[s] = new N(s, 3, !1, s.toLowerCase(), null, !1, !1);
  }), ["checked", "multiple", "muted", "selected"].forEach(function(s) {
    M[s] = new N(s, 3, !0, s, null, !1, !1);
  }), ["capture", "download"].forEach(function(s) {
    M[s] = new N(s, 4, !1, s, null, !1, !1);
  }), ["cols", "rows", "size", "span"].forEach(function(s) {
    M[s] = new N(s, 6, !1, s, null, !1, !1);
  }), ["rowSpan", "start"].forEach(function(s) {
    M[s] = new N(s, 5, !1, s.toLowerCase(), null, !1, !1);
  });
  var D = /[\-:]([a-z])/g;
  function V(s) {
    return s[1].toUpperCase();
  }
  "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(s) {
    var c = s.replace(
      D,
      V
    );
    M[c] = new N(c, 1, !1, s, null, !1, !1);
  }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(s) {
    var c = s.replace(D, V);
    M[c] = new N(c, 1, !1, s, "http://www.w3.org/1999/xlink", !1, !1);
  }), ["xml:base", "xml:lang", "xml:space"].forEach(function(s) {
    var c = s.replace(D, V);
    M[c] = new N(c, 1, !1, s, "http://www.w3.org/XML/1998/namespace", !1, !1);
  }), ["tabIndex", "crossOrigin"].forEach(function(s) {
    M[s] = new N(s, 1, !1, s.toLowerCase(), null, !1, !1);
  }), M.xlinkHref = new N("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1), ["src", "href", "action", "formAction"].forEach(function(s) {
    M[s] = new N(s, 1, !1, s.toLowerCase(), null, !0, !0);
  });
  var W = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
  }, A = ["Webkit", "ms", "Moz", "O"];
  Object.keys(W).forEach(function(s) {
    A.forEach(function(c) {
      c = c + s.charAt(0).toUpperCase() + s.substring(1), W[c] = W[s];
    });
  });
  var X = /["'&<>]/;
  function re(s) {
    if (typeof s == "boolean" || typeof s == "number") return "" + s;
    s = "" + s;
    var c = X.exec(s);
    if (c) {
      var g = "", y, R = 0;
      for (y = c.index; y < s.length; y++) {
        switch (s.charCodeAt(y)) {
          case 34:
            c = "&quot;";
            break;
          case 38:
            c = "&amp;";
            break;
          case 39:
            c = "&#x27;";
            break;
          case 60:
            c = "&lt;";
            break;
          case 62:
            c = "&gt;";
            break;
          default:
            continue;
        }
        R !== y && (g += s.substring(R, y)), R = y + 1, g += c;
      }
      s = R !== y ? g + s.substring(R, y) : g;
    }
    return s;
  }
  var Me = /([A-Z])/g, Ne = /^ms-/, De = Array.isArray, ve = h("<script>"), fe = h("<\/script>"), Z = h('<script src="'), ue = h('<script type="module" src="'), Ae = h('" async=""><\/script>'), dt = /(<\/|<)(s)(cript)/gi;
  function ze(s, c, g, y) {
    return "" + c + (g === "s" ? "\\u0073" : "\\u0053") + y;
  }
  function He(s, c, g, y, R) {
    s = s === void 0 ? "" : s, c = c === void 0 ? ve : h('<script nonce="' + re(c) + '">');
    var E = [];
    if (g !== void 0 && E.push(c, m(("" + g).replace(dt, ze)), fe), y !== void 0) for (g = 0; g < y.length; g++) E.push(Z, m(re(y[g])), Ae);
    if (R !== void 0) for (y = 0; y < R.length; y++) E.push(ue, m(re(R[y])), Ae);
    return { bootstrapChunks: E, startInlineScript: c, placeholderPrefix: h(s + "P:"), segmentPrefix: h(s + "S:"), boundaryPrefix: s + "B:", idPrefix: s, nextSuspenseID: 0, sentCompleteSegmentFunction: !1, sentCompleteBoundaryFunction: !1, sentClientRenderFunction: !1 };
  }
  function Ue(s, c) {
    return { insertionMode: s, selectedValue: c };
  }
  function ft(s) {
    return Ue(s === "http://www.w3.org/2000/svg" ? 2 : s === "http://www.w3.org/1998/Math/MathML" ? 3 : 0, null);
  }
  function be(s, c, g) {
    switch (c) {
      case "select":
        return Ue(1, g.value != null ? g.value : g.defaultValue);
      case "svg":
        return Ue(2, null);
      case "math":
        return Ue(3, null);
      case "foreignObject":
        return Ue(1, null);
      case "table":
        return Ue(4, null);
      case "thead":
      case "tbody":
      case "tfoot":
        return Ue(5, null);
      case "colgroup":
        return Ue(7, null);
      case "tr":
        return Ue(6, null);
    }
    return 4 <= s.insertionMode || s.insertionMode === 0 ? Ue(1, null) : s;
  }
  var G = h("<!-- -->");
  function z(s, c, g, y) {
    return c === "" ? y : (y && s.push(G), s.push(m(re(c))), !0);
  }
  var U = /* @__PURE__ */ new Map(), q = h(' style="'), j = h(":"), de = h(";");
  function $(s, c, g) {
    if (typeof g != "object") throw Error(t(62));
    c = !0;
    for (var y in g) if (k.call(g, y)) {
      var R = g[y];
      if (R != null && typeof R != "boolean" && R !== "") {
        if (y.indexOf("--") === 0) {
          var E = m(re(y));
          R = m(re(("" + R).trim()));
        } else {
          E = y;
          var L = U.get(E);
          L !== void 0 || (L = h(re(E.replace(Me, "-$1").toLowerCase().replace(Ne, "-ms-"))), U.set(E, L)), E = L, R = typeof R == "number" ? R === 0 || k.call(W, y) ? m("" + R) : m(R + "px") : m(re(("" + R).trim()));
        }
        c ? (c = !1, s.push(q, E, j, R)) : s.push(de, E, j, R);
      }
    }
    c || s.push(se);
  }
  var ge = h(" "), oe = h('="'), se = h('"'), Q = h('=""');
  function ae(s, c, g, y) {
    switch (g) {
      case "style":
        $(s, c, y);
        return;
      case "defaultValue":
      case "defaultChecked":
      case "innerHTML":
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
        return;
    }
    if (!(2 < g.length) || g[0] !== "o" && g[0] !== "O" || g[1] !== "n" && g[1] !== "N") {
      if (c = M.hasOwnProperty(g) ? M[g] : null, c !== null) {
        switch (typeof y) {
          case "function":
          case "symbol":
            return;
          case "boolean":
            if (!c.acceptsBooleans) return;
        }
        switch (g = m(c.attributeName), c.type) {
          case 3:
            y && s.push(ge, g, Q);
            break;
          case 4:
            y === !0 ? s.push(ge, g, Q) : y !== !1 && s.push(ge, g, oe, m(re(y)), se);
            break;
          case 5:
            isNaN(y) || s.push(ge, g, oe, m(re(y)), se);
            break;
          case 6:
            !isNaN(y) && 1 <= y && s.push(ge, g, oe, m(re(y)), se);
            break;
          default:
            c.sanitizeURL && (y = "" + y), s.push(ge, g, oe, m(re(y)), se);
        }
      } else if (w(g)) {
        switch (typeof y) {
          case "function":
          case "symbol":
            return;
          case "boolean":
            if (c = g.toLowerCase().slice(0, 5), c !== "data-" && c !== "aria-") return;
        }
        s.push(ge, m(g), oe, m(re(y)), se);
      }
    }
  }
  var Se = h(">"), ie = h("/>");
  function Ie(s, c, g) {
    if (c != null) {
      if (g != null) throw Error(t(60));
      if (typeof c != "object" || !("__html" in c)) throw Error(t(61));
      c = c.__html, c != null && s.push(m("" + c));
    }
  }
  function he(s) {
    var c = "";
    return e.Children.forEach(s, function(g) {
      g != null && (c += g);
    }), c;
  }
  var ke = h(' selected=""');
  function Qe(s, c, g, y) {
    s.push(Re(g));
    var R = g = null, E;
    for (E in c) if (k.call(c, E)) {
      var L = c[E];
      if (L != null) switch (E) {
        case "children":
          g = L;
          break;
        case "dangerouslySetInnerHTML":
          R = L;
          break;
        default:
          ae(s, y, E, L);
      }
    }
    return s.push(Se), Ie(s, R, g), typeof g == "string" ? (s.push(m(re(g))), null) : g;
  }
  var Ce = h(`
`), wt = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, Ge = /* @__PURE__ */ new Map();
  function Re(s) {
    var c = Ge.get(s);
    if (c === void 0) {
      if (!wt.test(s)) throw Error(t(65, s));
      c = h("<" + s), Ge.set(s, c);
    }
    return c;
  }
  var J = h("<!DOCTYPE html>");
  function we(s, c, g, y, R) {
    switch (c) {
      case "select":
        s.push(Re("select"));
        var E = null, L = null;
        for (ce in g) if (k.call(g, ce)) {
          var B = g[ce];
          if (B != null) switch (ce) {
            case "children":
              E = B;
              break;
            case "dangerouslySetInnerHTML":
              L = B;
              break;
            case "defaultValue":
            case "value":
              break;
            default:
              ae(s, y, ce, B);
          }
        }
        return s.push(Se), Ie(s, L, E), E;
      case "option":
        L = R.selectedValue, s.push(Re("option"));
        var te = B = null, pe = null, ce = null;
        for (E in g) if (k.call(g, E)) {
          var Fe = g[E];
          if (Fe != null) switch (E) {
            case "children":
              B = Fe;
              break;
            case "selected":
              pe = Fe;
              break;
            case "dangerouslySetInnerHTML":
              ce = Fe;
              break;
            case "value":
              te = Fe;
            default:
              ae(s, y, E, Fe);
          }
        }
        if (L != null) if (g = te !== null ? "" + te : he(B), De(L)) {
          for (y = 0; y < L.length; y++)
            if ("" + L[y] === g) {
              s.push(ke);
              break;
            }
        } else "" + L === g && s.push(ke);
        else pe && s.push(ke);
        return s.push(Se), Ie(s, ce, B), B;
      case "textarea":
        s.push(Re("textarea")), ce = L = E = null;
        for (B in g) if (k.call(g, B) && (te = g[B], te != null)) switch (B) {
          case "children":
            ce = te;
            break;
          case "value":
            E = te;
            break;
          case "defaultValue":
            L = te;
            break;
          case "dangerouslySetInnerHTML":
            throw Error(t(91));
          default:
            ae(s, y, B, te);
        }
        if (E === null && L !== null && (E = L), s.push(Se), ce != null) {
          if (E != null) throw Error(t(92));
          if (De(ce) && 1 < ce.length) throw Error(t(93));
          E = "" + ce;
        }
        return typeof E == "string" && E[0] === `
` && s.push(Ce), E !== null && s.push(m(re("" + E))), null;
      case "input":
        s.push(Re("input")), te = ce = B = E = null;
        for (L in g) if (k.call(g, L) && (pe = g[L], pe != null)) switch (L) {
          case "children":
          case "dangerouslySetInnerHTML":
            throw Error(t(399, "input"));
          case "defaultChecked":
            te = pe;
            break;
          case "defaultValue":
            B = pe;
            break;
          case "checked":
            ce = pe;
            break;
          case "value":
            E = pe;
            break;
          default:
            ae(s, y, L, pe);
        }
        return ce !== null ? ae(
          s,
          y,
          "checked",
          ce
        ) : te !== null && ae(s, y, "checked", te), E !== null ? ae(s, y, "value", E) : B !== null && ae(s, y, "value", B), s.push(ie), null;
      case "menuitem":
        s.push(Re("menuitem"));
        for (var bt in g) if (k.call(g, bt) && (E = g[bt], E != null)) switch (bt) {
          case "children":
          case "dangerouslySetInnerHTML":
            throw Error(t(400));
          default:
            ae(s, y, bt, E);
        }
        return s.push(Se), null;
      case "title":
        s.push(Re("title")), E = null;
        for (Fe in g) if (k.call(g, Fe) && (L = g[Fe], L != null)) switch (Fe) {
          case "children":
            E = L;
            break;
          case "dangerouslySetInnerHTML":
            throw Error(t(434));
          default:
            ae(s, y, Fe, L);
        }
        return s.push(Se), E;
      case "listing":
      case "pre":
        s.push(Re(c)), L = E = null;
        for (te in g) if (k.call(g, te) && (B = g[te], B != null)) switch (te) {
          case "children":
            E = B;
            break;
          case "dangerouslySetInnerHTML":
            L = B;
            break;
          default:
            ae(s, y, te, B);
        }
        if (s.push(Se), L != null) {
          if (E != null) throw Error(t(60));
          if (typeof L != "object" || !("__html" in L)) throw Error(t(61));
          g = L.__html, g != null && (typeof g == "string" && 0 < g.length && g[0] === `
` ? s.push(Ce, m(g)) : s.push(m("" + g)));
        }
        return typeof E == "string" && E[0] === `
` && s.push(Ce), E;
      case "area":
      case "base":
      case "br":
      case "col":
      case "embed":
      case "hr":
      case "img":
      case "keygen":
      case "link":
      case "meta":
      case "param":
      case "source":
      case "track":
      case "wbr":
        s.push(Re(c));
        for (var At in g) if (k.call(g, At) && (E = g[At], E != null)) switch (At) {
          case "children":
          case "dangerouslySetInnerHTML":
            throw Error(t(399, c));
          default:
            ae(s, y, At, E);
        }
        return s.push(ie), null;
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return Qe(s, g, c, y);
      case "html":
        return R.insertionMode === 0 && s.push(J), Qe(s, g, c, y);
      default:
        if (c.indexOf("-") === -1 && typeof g.is != "string") return Qe(s, g, c, y);
        s.push(Re(c)), L = E = null;
        for (pe in g) if (k.call(g, pe) && (B = g[pe], B != null)) switch (pe) {
          case "children":
            E = B;
            break;
          case "dangerouslySetInnerHTML":
            L = B;
            break;
          case "style":
            $(s, y, B);
            break;
          case "suppressContentEditableWarning":
          case "suppressHydrationWarning":
            break;
          default:
            w(pe) && typeof B != "function" && typeof B != "symbol" && s.push(ge, m(pe), oe, m(re(B)), se);
        }
        return s.push(Se), Ie(s, L, E), E;
    }
  }
  var it = h("</"), Xe = h(">"), Ke = h('<template id="'), dn = h('"></template>'), fn = h("<!--$-->"), pn = h('<!--$?--><template id="'), Zt = h('"></template>'), kt = h("<!--$!-->"), Jt = h("<!--/$-->"), pt = h("<template"), Lt = h('"'), hn = h(' data-dgst="');
  h(' data-msg="'), h(' data-stck="');
  var mn = h("></template>");
  function ht(s, c, g) {
    if (i(s, pn), g === null) throw Error(t(395));
    return i(s, g), a(s, Zt);
  }
  var Mt = h('<div hidden id="'), Tt = h('">'), Te = h("</div>"), gt = h('<svg aria-hidden="true" style="display:none" id="'), Qt = h('">'), zt = h("</svg>"), _e = h('<math aria-hidden="true" style="display:none" id="'), vt = h('">'), _t = h("</math>"), gn = h('<table hidden id="'), Ht = h('">'), en = h("</table>"), vn = h('<table hidden><tbody id="'), On = h('">'), nt = h("</tbody></table>"), Et = h('<table hidden><tr id="'), An = h('">'), Vt = h("</tr></table>"), tn = h('<table hidden><colgroup id="'), Dt = h('">'), ot = h("</colgroup></table>");
  function jn(s, c, g, y) {
    switch (g.insertionMode) {
      case 0:
      case 1:
        return i(s, Mt), i(s, c.segmentPrefix), i(s, m(y.toString(16))), a(s, Tt);
      case 2:
        return i(s, gt), i(s, c.segmentPrefix), i(s, m(y.toString(16))), a(s, Qt);
      case 3:
        return i(s, _e), i(s, c.segmentPrefix), i(s, m(y.toString(16))), a(s, vt);
      case 4:
        return i(s, gn), i(s, c.segmentPrefix), i(s, m(y.toString(16))), a(s, Ht);
      case 5:
        return i(s, vn), i(s, c.segmentPrefix), i(s, m(y.toString(16))), a(s, On);
      case 6:
        return i(s, Et), i(s, c.segmentPrefix), i(s, m(y.toString(16))), a(s, An);
      case 7:
        return i(
          s,
          tn
        ), i(s, c.segmentPrefix), i(s, m(y.toString(16))), a(s, Dt);
      default:
        throw Error(t(397));
    }
  }
  function Ft(s, c) {
    switch (c.insertionMode) {
      case 0:
      case 1:
        return a(s, Te);
      case 2:
        return a(s, zt);
      case 3:
        return a(s, _t);
      case 4:
        return a(s, en);
      case 5:
        return a(s, nt);
      case 6:
        return a(s, Vt);
      case 7:
        return a(s, ot);
      default:
        throw Error(t(397));
    }
  }
  var Nn = h('function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("'), nn = h('$RS("'), Wt = h('","'), K = h('")<\/script>'), S = h('function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}};$RC("'), F = h('$RC("'), Y = h('","'), Oe = h('")<\/script>'), We = h('function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())};$RX("'), ye = h('$RX("'), Ze = h('"'), Je = h(")<\/script>"), mt = h(","), rn = /[<\u2028\u2029]/g;
  function Pe(s) {
    return JSON.stringify(s).replace(rn, function(c) {
      switch (c) {
        case "<":
          return "\\u003c";
        case "\u2028":
          return "\\u2028";
        case "\u2029":
          return "\\u2029";
        default:
          throw Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
      }
    });
  }
  var Ct = Object.assign, yn = Symbol.for("react.element"), xn = Symbol.for("react.portal"), bn = Symbol.for("react.fragment"), zn = Symbol.for("react.strict_mode"), Hn = Symbol.for("react.profiler"), Vn = Symbol.for("react.provider"), In = Symbol.for("react.context"), cr = Symbol.for("react.forward_ref"), ur = Symbol.for("react.suspense"), Wn = Symbol.for("react.suspense_list"), o = Symbol.for("react.memo"), u = Symbol.for("react.lazy"), v = Symbol.for("react.scope"), x = Symbol.for("react.debug_trace_mode"), O = Symbol.for("react.legacy_hidden"), T = Symbol.for("react.default_value"), P = Symbol.iterator;
  function H(s) {
    if (s == null) return null;
    if (typeof s == "function") return s.displayName || s.name || null;
    if (typeof s == "string") return s;
    switch (s) {
      case bn:
        return "Fragment";
      case xn:
        return "Portal";
      case Hn:
        return "Profiler";
      case zn:
        return "StrictMode";
      case ur:
        return "Suspense";
      case Wn:
        return "SuspenseList";
    }
    if (typeof s == "object") switch (s.$$typeof) {
      case In:
        return (s.displayName || "Context") + ".Consumer";
      case Vn:
        return (s._context.displayName || "Context") + ".Provider";
      case cr:
        var c = s.render;
        return s = s.displayName, s || (s = c.displayName || c.name || "", s = s !== "" ? "ForwardRef(" + s + ")" : "ForwardRef"), s;
      case o:
        return c = s.displayName || null, c !== null ? c : H(s.type) || "Memo";
      case u:
        c = s._payload, s = s._init;
        try {
          return H(s(c));
        } catch {
        }
    }
    return null;
  }
  var ee = {};
  function ne(s, c) {
    if (s = s.contextTypes, !s) return ee;
    var g = {}, y;
    for (y in s) g[y] = c[y];
    return g;
  }
  var le = null;
  function $e(s, c) {
    if (s !== c) {
      s.context._currentValue = s.parentValue, s = s.parent;
      var g = c.parent;
      if (s === null) {
        if (g !== null) throw Error(t(401));
      } else {
        if (g === null) throw Error(t(401));
        $e(s, g);
      }
      c.context._currentValue = c.value;
    }
  }
  function Rt(s) {
    s.context._currentValue = s.parentValue, s = s.parent, s !== null && Rt(s);
  }
  function Ot(s) {
    var c = s.parent;
    c !== null && Ot(c), s.context._currentValue = s.value;
  }
  function yt(s, c) {
    if (s.context._currentValue = s.parentValue, s = s.parent, s === null) throw Error(t(402));
    s.depth === c.depth ? $e(s, c) : yt(s, c);
  }
  function wn(s, c) {
    var g = c.parent;
    if (g === null) throw Error(t(402));
    s.depth === g.depth ? $e(s, g) : wn(s, g), c.context._currentValue = c.value;
  }
  function qt(s) {
    var c = le;
    c !== s && (c === null ? Ot(s) : s === null ? Rt(c) : c.depth === s.depth ? $e(c, s) : c.depth > s.depth ? yt(c, s) : wn(c, s), le = s);
  }
  var qn = { isMounted: function() {
    return !1;
  }, enqueueSetState: function(s, c) {
    s = s._reactInternals, s.queue !== null && s.queue.push(c);
  }, enqueueReplaceState: function(s, c) {
    s = s._reactInternals, s.replace = !0, s.queue = [c];
  }, enqueueForceUpdate: function() {
  } };
  function Sn(s, c, g, y) {
    var R = s.state !== void 0 ? s.state : null;
    s.updater = qn, s.props = g, s.state = R;
    var E = { queue: [], replace: !1 };
    s._reactInternals = E;
    var L = c.contextType;
    if (s.context = typeof L == "object" && L !== null ? L._currentValue : y, L = c.getDerivedStateFromProps, typeof L == "function" && (L = L(g, R), R = L == null ? R : Ct({}, R, L), s.state = R), typeof c.getDerivedStateFromProps != "function" && typeof s.getSnapshotBeforeUpdate != "function" && (typeof s.UNSAFE_componentWillMount == "function" || typeof s.componentWillMount == "function")) if (c = s.state, typeof s.componentWillMount == "function" && s.componentWillMount(), typeof s.UNSAFE_componentWillMount == "function" && s.UNSAFE_componentWillMount(), c !== s.state && qn.enqueueReplaceState(s, s.state, null), E.queue !== null && 0 < E.queue.length) if (c = E.queue, L = E.replace, E.queue = null, E.replace = !1, L && c.length === 1) s.state = c[0];
    else {
      for (E = L ? c[0] : s.state, R = !0, L = L ? 1 : 0; L < c.length; L++) {
        var B = c[L];
        B = typeof B == "function" ? B.call(s, E, g, y) : B, B != null && (R ? (R = !1, E = Ct({}, E, B)) : Ct(E, B));
      }
      s.state = E;
    }
    else E.queue = null;
  }
  var dr = { id: 1, overflow: "" };
  function on(s, c, g) {
    var y = s.id;
    s = s.overflow;
    var R = 32 - fr(y) - 1;
    y &= ~(1 << R), g += 1;
    var E = 32 - fr(c) + R;
    if (30 < E) {
      var L = R - R % 5;
      return E = (y & (1 << L) - 1).toString(32), y >>= L, R -= L, { id: 1 << 32 - fr(c) + R | g << R | y, overflow: E + s };
    }
    return { id: 1 << E | g << R | y, overflow: s };
  }
  var fr = Math.clz32 ? Math.clz32 : Ca, _a = Math.log, Ea = Math.LN2;
  function Ca(s) {
    return s >>>= 0, s === 0 ? 32 : 31 - (_a(s) / Ea | 0) | 0;
  }
  function Ra(s, c) {
    return s === c && (s !== 0 || 1 / s === 1 / c) || s !== s && c !== c;
  }
  var Oa = typeof Object.is == "function" ? Object.is : Ra, Ut = null, Qr = null, pr = null, Le = null, Un = !1, hr = !1, Yn = 0, sn = null, mr = 0;
  function kn() {
    if (Ut === null) throw Error(t(321));
    return Ut;
  }
  function lo() {
    if (0 < mr) throw Error(t(312));
    return { memoizedState: null, queue: null, next: null };
  }
  function ei() {
    return Le === null ? pr === null ? (Un = !1, pr = Le = lo()) : (Un = !0, Le = pr) : Le.next === null ? (Un = !1, Le = Le.next = lo()) : (Un = !0, Le = Le.next), Le;
  }
  function ti() {
    Qr = Ut = null, hr = !1, pr = null, mr = 0, Le = sn = null;
  }
  function co(s, c) {
    return typeof c == "function" ? c(s) : c;
  }
  function uo(s, c, g) {
    if (Ut = kn(), Le = ei(), Un) {
      var y = Le.queue;
      if (c = y.dispatch, sn !== null && (g = sn.get(y), g !== void 0)) {
        sn.delete(y), y = Le.memoizedState;
        do
          y = s(y, g.action), g = g.next;
        while (g !== null);
        return Le.memoizedState = y, [y, c];
      }
      return [Le.memoizedState, c];
    }
    return s = s === co ? typeof c == "function" ? c() : c : g !== void 0 ? g(c) : c, Le.memoizedState = s, s = Le.queue = { last: null, dispatch: null }, s = s.dispatch = Aa.bind(null, Ut, s), [Le.memoizedState, s];
  }
  function fo(s, c) {
    if (Ut = kn(), Le = ei(), c = c === void 0 ? null : c, Le !== null) {
      var g = Le.memoizedState;
      if (g !== null && c !== null) {
        var y = g[1];
        e: if (y === null) y = !1;
        else {
          for (var R = 0; R < y.length && R < c.length; R++) if (!Oa(c[R], y[R])) {
            y = !1;
            break e;
          }
          y = !0;
        }
        if (y) return g[0];
      }
    }
    return s = s(), Le.memoizedState = [s, c], s;
  }
  function Aa(s, c, g) {
    if (25 <= mr) throw Error(t(301));
    if (s === Ut) if (hr = !0, s = { action: g, next: null }, sn === null && (sn = /* @__PURE__ */ new Map()), g = sn.get(c), g === void 0) sn.set(c, s);
    else {
      for (c = g; c.next !== null; ) c = c.next;
      c.next = s;
    }
  }
  function ja() {
    throw Error(t(394));
  }
  function gr() {
  }
  var po = { readContext: function(s) {
    return s._currentValue;
  }, useContext: function(s) {
    return kn(), s._currentValue;
  }, useMemo: fo, useReducer: uo, useRef: function(s) {
    Ut = kn(), Le = ei();
    var c = Le.memoizedState;
    return c === null ? (s = { current: s }, Le.memoizedState = s) : c;
  }, useState: function(s) {
    return uo(co, s);
  }, useInsertionEffect: gr, useLayoutEffect: function() {
  }, useCallback: function(s, c) {
    return fo(function() {
      return s;
    }, c);
  }, useImperativeHandle: gr, useEffect: gr, useDebugValue: gr, useDeferredValue: function(s) {
    return kn(), s;
  }, useTransition: function() {
    return kn(), [!1, ja];
  }, useId: function() {
    var s = Qr.treeContext, c = s.overflow;
    s = s.id, s = (s & ~(1 << 32 - fr(s) - 1)).toString(32) + c;
    var g = vr;
    if (g === null) throw Error(t(404));
    return c = Yn++, s = ":" + g.idPrefix + "R" + s, 0 < c && (s += "H" + c.toString(32)), s + ":";
  }, useMutableSource: function(s, c) {
    return kn(), c(s._source);
  }, useSyncExternalStore: function(s, c, g) {
    if (g === void 0) throw Error(t(407));
    return g();
  } }, vr = null, ni = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;
  function Na(s) {
    return console.error(s), null;
  }
  function Gn() {
  }
  function Ia(s, c, g, y, R, E, L, B, te) {
    var pe = [], ce = /* @__PURE__ */ new Set();
    return c = { destination: null, responseState: c, progressiveChunkSize: y === void 0 ? 12800 : y, status: 0, fatalError: null, nextSegmentId: 0, allPendingTasks: 0, pendingRootTasks: 0, completedRootSegment: null, abortableTasks: ce, pingedTasks: pe, clientRenderedBoundaries: [], completedBoundaries: [], partialBoundaries: [], onError: R === void 0 ? Na : R, onAllReady: E === void 0 ? Gn : E, onShellReady: L === void 0 ? Gn : L, onShellError: B === void 0 ? Gn : B, onFatalError: te === void 0 ? Gn : te }, g = yr(c, 0, null, g, !1, !1), g.parentFlushed = !0, s = ri(c, s, null, g, ce, ee, null, dr), pe.push(s), c;
  }
  function ri(s, c, g, y, R, E, L, B) {
    s.allPendingTasks++, g === null ? s.pendingRootTasks++ : g.pendingTasks++;
    var te = { node: c, ping: function() {
      var pe = s.pingedTasks;
      pe.push(te), pe.length === 1 && bo(s);
    }, blockedBoundary: g, blockedSegment: y, abortSet: R, legacyContext: E, context: L, treeContext: B };
    return R.add(te), te;
  }
  function yr(s, c, g, y, R, E) {
    return { status: 0, id: -1, index: c, parentFlushed: !1, chunks: [], children: [], formatContext: y, boundary: g, lastPushedText: R, textEmbedded: E };
  }
  function Xn(s, c) {
    if (s = s.onError(c), s != null && typeof s != "string") throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof s + '" instead');
    return s;
  }
  function xr(s, c) {
    var g = s.onShellError;
    g(c), g = s.onFatalError, g(c), s.destination !== null ? (s.status = 2, b(s.destination, c)) : (s.status = 1, s.fatalError = c);
  }
  function ho(s, c, g, y, R) {
    for (Ut = {}, Qr = c, Yn = 0, s = g(y, R); hr; ) hr = !1, Yn = 0, mr += 1, Le = null, s = g(y, R);
    return ti(), s;
  }
  function mo(s, c, g, y) {
    var R = g.render(), E = y.childContextTypes;
    if (E != null) {
      var L = c.legacyContext;
      if (typeof g.getChildContext != "function") y = L;
      else {
        g = g.getChildContext();
        for (var B in g) if (!(B in E)) throw Error(t(108, H(y) || "Unknown", B));
        y = Ct({}, L, g);
      }
      c.legacyContext = y, xt(s, c, R), c.legacyContext = L;
    } else xt(s, c, R);
  }
  function go(s, c) {
    if (s && s.defaultProps) {
      c = Ct({}, c), s = s.defaultProps;
      for (var g in s) c[g] === void 0 && (c[g] = s[g]);
      return c;
    }
    return c;
  }
  function ii(s, c, g, y, R) {
    if (typeof g == "function") if (g.prototype && g.prototype.isReactComponent) {
      R = ne(g, c.legacyContext);
      var E = g.contextType;
      E = new g(y, typeof E == "object" && E !== null ? E._currentValue : R), Sn(E, g, y, R), mo(s, c, E, g);
    } else {
      E = ne(g, c.legacyContext), R = ho(s, c, g, y, E);
      var L = Yn !== 0;
      if (typeof R == "object" && R !== null && typeof R.render == "function" && R.$$typeof === void 0) Sn(R, g, y, E), mo(s, c, R, g);
      else if (L) {
        y = c.treeContext, c.treeContext = on(y, 1, 0);
        try {
          xt(s, c, R);
        } finally {
          c.treeContext = y;
        }
      } else xt(s, c, R);
    }
    else if (typeof g == "string") {
      switch (R = c.blockedSegment, E = we(R.chunks, g, y, s.responseState, R.formatContext), R.lastPushedText = !1, L = R.formatContext, R.formatContext = be(L, g, y), oi(s, c, E), R.formatContext = L, g) {
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "input":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
          break;
        default:
          R.chunks.push(it, m(g), Xe);
      }
      R.lastPushedText = !1;
    } else {
      switch (g) {
        case O:
        case x:
        case zn:
        case Hn:
        case bn:
          xt(s, c, y.children);
          return;
        case Wn:
          xt(s, c, y.children);
          return;
        case v:
          throw Error(t(343));
        case ur:
          e: {
            g = c.blockedBoundary, R = c.blockedSegment, E = y.fallback, y = y.children, L = /* @__PURE__ */ new Set();
            var B = { id: null, rootSegmentID: -1, parentFlushed: !1, pendingTasks: 0, forceClientRender: !1, completedSegments: [], byteSize: 0, fallbackAbortableTasks: L, errorDigest: null }, te = yr(s, R.chunks.length, B, R.formatContext, !1, !1);
            R.children.push(te), R.lastPushedText = !1;
            var pe = yr(s, 0, null, R.formatContext, !1, !1);
            pe.parentFlushed = !0, c.blockedBoundary = B, c.blockedSegment = pe;
            try {
              if (oi(
                s,
                c,
                y
              ), pe.lastPushedText && pe.textEmbedded && pe.chunks.push(G), pe.status = 1, br(B, pe), B.pendingTasks === 0) break e;
            } catch (ce) {
              pe.status = 4, B.forceClientRender = !0, B.errorDigest = Xn(s, ce);
            } finally {
              c.blockedBoundary = g, c.blockedSegment = R;
            }
            c = ri(s, E, g, te, L, c.legacyContext, c.context, c.treeContext), s.pingedTasks.push(c);
          }
          return;
      }
      if (typeof g == "object" && g !== null) switch (g.$$typeof) {
        case cr:
          if (y = ho(s, c, g.render, y, R), Yn !== 0) {
            g = c.treeContext, c.treeContext = on(g, 1, 0);
            try {
              xt(s, c, y);
            } finally {
              c.treeContext = g;
            }
          } else xt(s, c, y);
          return;
        case o:
          g = g.type, y = go(g, y), ii(s, c, g, y, R);
          return;
        case Vn:
          if (R = y.children, g = g._context, y = y.value, E = g._currentValue, g._currentValue = y, L = le, le = y = { parent: L, depth: L === null ? 0 : L.depth + 1, context: g, parentValue: E, value: y }, c.context = y, xt(s, c, R), s = le, s === null) throw Error(t(403));
          y = s.parentValue, s.context._currentValue = y === T ? s.context._defaultValue : y, s = le = s.parent, c.context = s;
          return;
        case In:
          y = y.children, y = y(g._currentValue), xt(s, c, y);
          return;
        case u:
          R = g._init, g = R(g._payload), y = go(g, y), ii(s, c, g, y, void 0);
          return;
      }
      throw Error(t(
        130,
        g == null ? g : typeof g,
        ""
      ));
    }
  }
  function xt(s, c, g) {
    if (c.node = g, typeof g == "object" && g !== null) {
      switch (g.$$typeof) {
        case yn:
          ii(s, c, g.type, g.props, g.ref);
          return;
        case xn:
          throw Error(t(257));
        case u:
          var y = g._init;
          g = y(g._payload), xt(s, c, g);
          return;
      }
      if (De(g)) {
        vo(s, c, g);
        return;
      }
      if (g === null || typeof g != "object" ? y = null : (y = P && g[P] || g["@@iterator"], y = typeof y == "function" ? y : null), y && (y = y.call(g))) {
        if (g = y.next(), !g.done) {
          var R = [];
          do
            R.push(g.value), g = y.next();
          while (!g.done);
          vo(s, c, R);
        }
        return;
      }
      throw s = Object.prototype.toString.call(g), Error(t(31, s === "[object Object]" ? "object with keys {" + Object.keys(g).join(", ") + "}" : s));
    }
    typeof g == "string" ? (y = c.blockedSegment, y.lastPushedText = z(c.blockedSegment.chunks, g, s.responseState, y.lastPushedText)) : typeof g == "number" && (y = c.blockedSegment, y.lastPushedText = z(c.blockedSegment.chunks, "" + g, s.responseState, y.lastPushedText));
  }
  function vo(s, c, g) {
    for (var y = g.length, R = 0; R < y; R++) {
      var E = c.treeContext;
      c.treeContext = on(E, y, R);
      try {
        oi(s, c, g[R]);
      } finally {
        c.treeContext = E;
      }
    }
  }
  function oi(s, c, g) {
    var y = c.blockedSegment.formatContext, R = c.legacyContext, E = c.context;
    try {
      return xt(s, c, g);
    } catch (te) {
      if (ti(), typeof te == "object" && te !== null && typeof te.then == "function") {
        g = te;
        var L = c.blockedSegment, B = yr(s, L.chunks.length, null, L.formatContext, L.lastPushedText, !0);
        L.children.push(B), L.lastPushedText = !1, s = ri(s, c.node, c.blockedBoundary, B, c.abortSet, c.legacyContext, c.context, c.treeContext).ping, g.then(s, s), c.blockedSegment.formatContext = y, c.legacyContext = R, c.context = E, qt(E);
      } else throw c.blockedSegment.formatContext = y, c.legacyContext = R, c.context = E, qt(E), te;
    }
  }
  function Pa(s) {
    var c = s.blockedBoundary;
    s = s.blockedSegment, s.status = 3, xo(this, c, s);
  }
  function yo(s, c, g) {
    var y = s.blockedBoundary;
    s.blockedSegment.status = 3, y === null ? (c.allPendingTasks--, c.status !== 2 && (c.status = 2, c.destination !== null && c.destination.close())) : (y.pendingTasks--, y.forceClientRender || (y.forceClientRender = !0, s = g === void 0 ? Error(t(432)) : g, y.errorDigest = c.onError(s), y.parentFlushed && c.clientRenderedBoundaries.push(y)), y.fallbackAbortableTasks.forEach(function(R) {
      return yo(R, c, g);
    }), y.fallbackAbortableTasks.clear(), c.allPendingTasks--, c.allPendingTasks === 0 && (y = c.onAllReady, y()));
  }
  function br(s, c) {
    if (c.chunks.length === 0 && c.children.length === 1 && c.children[0].boundary === null) {
      var g = c.children[0];
      g.id = c.id, g.parentFlushed = !0, g.status === 1 && br(s, g);
    } else s.completedSegments.push(c);
  }
  function xo(s, c, g) {
    if (c === null) {
      if (g.parentFlushed) {
        if (s.completedRootSegment !== null) throw Error(t(389));
        s.completedRootSegment = g;
      }
      s.pendingRootTasks--, s.pendingRootTasks === 0 && (s.onShellError = Gn, c = s.onShellReady, c());
    } else c.pendingTasks--, c.forceClientRender || (c.pendingTasks === 0 ? (g.parentFlushed && g.status === 1 && br(c, g), c.parentFlushed && s.completedBoundaries.push(c), c.fallbackAbortableTasks.forEach(Pa, s), c.fallbackAbortableTasks.clear()) : g.parentFlushed && g.status === 1 && (br(c, g), c.completedSegments.length === 1 && c.parentFlushed && s.partialBoundaries.push(c)));
    s.allPendingTasks--, s.allPendingTasks === 0 && (s = s.onAllReady, s());
  }
  function bo(s) {
    if (s.status !== 2) {
      var c = le, g = ni.current;
      ni.current = po;
      var y = vr;
      vr = s.responseState;
      try {
        var R = s.pingedTasks, E;
        for (E = 0; E < R.length; E++) {
          var L = R[E], B = s, te = L.blockedSegment;
          if (te.status === 0) {
            qt(L.context);
            try {
              xt(B, L, L.node), te.lastPushedText && te.textEmbedded && te.chunks.push(G), L.abortSet.delete(L), te.status = 1, xo(B, L.blockedBoundary, te);
            } catch (jt) {
              if (ti(), typeof jt == "object" && jt !== null && typeof jt.then == "function") {
                var pe = L.ping;
                jt.then(pe, pe);
              } else {
                L.abortSet.delete(L), te.status = 4;
                var ce = L.blockedBoundary, Fe = jt, bt = Xn(B, Fe);
                if (ce === null ? xr(B, Fe) : (ce.pendingTasks--, ce.forceClientRender || (ce.forceClientRender = !0, ce.errorDigest = bt, ce.parentFlushed && B.clientRenderedBoundaries.push(ce))), B.allPendingTasks--, B.allPendingTasks === 0) {
                  var At = B.onAllReady;
                  At();
                }
              }
            } finally {
            }
          }
        }
        R.splice(0, E), s.destination !== null && si(s, s.destination);
      } catch (jt) {
        Xn(s, jt), xr(s, jt);
      } finally {
        vr = y, ni.current = g, g === po && qt(c);
      }
    }
  }
  function wr(s, c, g) {
    switch (g.parentFlushed = !0, g.status) {
      case 0:
        var y = g.id = s.nextSegmentId++;
        return g.lastPushedText = !1, g.textEmbedded = !1, s = s.responseState, i(c, Ke), i(c, s.placeholderPrefix), s = m(y.toString(16)), i(c, s), a(c, dn);
      case 1:
        g.status = 2;
        var R = !0;
        y = g.chunks;
        var E = 0;
        g = g.children;
        for (var L = 0; L < g.length; L++) {
          for (R = g[L]; E < R.index; E++) i(c, y[E]);
          R = Sr(s, c, R);
        }
        for (; E < y.length - 1; E++) i(c, y[E]);
        return E < y.length && (R = a(c, y[E])), R;
      default:
        throw Error(t(390));
    }
  }
  function Sr(s, c, g) {
    var y = g.boundary;
    if (y === null) return wr(s, c, g);
    if (y.parentFlushed = !0, y.forceClientRender) y = y.errorDigest, a(c, kt), i(c, pt), y && (i(c, hn), i(c, m(re(y))), i(c, Lt)), a(c, mn), wr(s, c, g);
    else if (0 < y.pendingTasks) {
      y.rootSegmentID = s.nextSegmentId++, 0 < y.completedSegments.length && s.partialBoundaries.push(y);
      var R = s.responseState, E = R.nextSuspenseID++;
      R = h(R.boundaryPrefix + E.toString(16)), y = y.id = R, ht(c, s.responseState, y), wr(s, c, g);
    } else if (y.byteSize > s.progressiveChunkSize) y.rootSegmentID = s.nextSegmentId++, s.completedBoundaries.push(y), ht(c, s.responseState, y.id), wr(s, c, g);
    else {
      if (a(c, fn), g = y.completedSegments, g.length !== 1) throw Error(t(391));
      Sr(s, c, g[0]);
    }
    return a(c, Jt);
  }
  function wo(s, c, g) {
    return jn(c, s.responseState, g.formatContext, g.id), Sr(s, c, g), Ft(c, g.formatContext);
  }
  function So(s, c, g) {
    for (var y = g.completedSegments, R = 0; R < y.length; R++) ko(s, c, g, y[R]);
    if (y.length = 0, s = s.responseState, y = g.id, g = g.rootSegmentID, i(c, s.startInlineScript), s.sentCompleteBoundaryFunction ? i(c, F) : (s.sentCompleteBoundaryFunction = !0, i(c, S)), y === null) throw Error(t(395));
    return g = m(g.toString(16)), i(c, y), i(c, Y), i(c, s.segmentPrefix), i(c, g), a(c, Oe);
  }
  function ko(s, c, g, y) {
    if (y.status === 2) return !0;
    var R = y.id;
    if (R === -1) {
      if ((y.id = g.rootSegmentID) === -1) throw Error(t(392));
      return wo(s, c, y);
    }
    return wo(s, c, y), s = s.responseState, i(c, s.startInlineScript), s.sentCompleteSegmentFunction ? i(c, nn) : (s.sentCompleteSegmentFunction = !0, i(c, Nn)), i(c, s.segmentPrefix), R = m(R.toString(16)), i(c, R), i(c, Wt), i(c, s.placeholderPrefix), i(c, R), a(c, K);
  }
  function si(s, c) {
    n = new Uint8Array(512), r = 0;
    try {
      var g = s.completedRootSegment;
      if (g !== null && s.pendingRootTasks === 0) {
        Sr(s, c, g), s.completedRootSegment = null;
        var y = s.responseState.bootstrapChunks;
        for (g = 0; g < y.length - 1; g++) i(c, y[g]);
        g < y.length && a(c, y[g]);
      }
      var R = s.clientRenderedBoundaries, E;
      for (E = 0; E < R.length; E++) {
        var L = R[E];
        y = c;
        var B = s.responseState, te = L.id, pe = L.errorDigest, ce = L.errorMessage, Fe = L.errorComponentStack;
        if (i(y, B.startInlineScript), B.sentClientRenderFunction ? i(y, ye) : (B.sentClientRenderFunction = !0, i(
          y,
          We
        )), te === null) throw Error(t(395));
        i(y, te), i(y, Ze), (pe || ce || Fe) && (i(y, mt), i(y, m(Pe(pe || "")))), (ce || Fe) && (i(y, mt), i(y, m(Pe(ce || "")))), Fe && (i(y, mt), i(y, m(Pe(Fe)))), a(y, Je);
      }
      R.splice(0, E);
      var bt = s.completedBoundaries;
      for (E = 0; E < bt.length; E++) So(s, c, bt[E]);
      bt.splice(0, E), d(c), n = new Uint8Array(512), r = 0;
      var At = s.partialBoundaries;
      for (E = 0; E < At.length; E++) {
        var jt = At[E];
        e: {
          R = s, L = c;
          var kr = jt.completedSegments;
          for (B = 0; B < kr.length; B++) if (!ko(
            R,
            L,
            jt,
            kr[B]
          )) {
            B++, kr.splice(0, B);
            var _o = !1;
            break e;
          }
          kr.splice(0, B), _o = !0;
        }
        if (!_o) {
          s.destination = null, E++, At.splice(0, E);
          return;
        }
      }
      At.splice(0, E);
      var ai = s.completedBoundaries;
      for (E = 0; E < ai.length; E++) So(s, c, ai[E]);
      ai.splice(0, E);
    } finally {
      d(c), s.allPendingTasks === 0 && s.pingedTasks.length === 0 && s.clientRenderedBoundaries.length === 0 && s.completedBoundaries.length === 0 && c.close();
    }
  }
  function To(s, c) {
    try {
      var g = s.abortableTasks;
      g.forEach(function(y) {
        return yo(y, s, c);
      }), g.clear(), s.destination !== null && si(s, s.destination);
    } catch (y) {
      Xn(s, y), xr(s, y);
    }
  }
  return Er.renderToReadableStream = function(s, c) {
    return new Promise(function(g, y) {
      var R, E, L = new Promise(function(ce, Fe) {
        E = ce, R = Fe;
      }), B = Ia(s, He(c ? c.identifierPrefix : void 0, c ? c.nonce : void 0, c ? c.bootstrapScriptContent : void 0, c ? c.bootstrapScripts : void 0, c ? c.bootstrapModules : void 0), ft(c ? c.namespaceURI : void 0), c ? c.progressiveChunkSize : void 0, c ? c.onError : void 0, E, function() {
        var ce = new ReadableStream({ type: "bytes", pull: function(Fe) {
          if (B.status === 1) B.status = 2, b(Fe, B.fatalError);
          else if (B.status !== 2 && B.destination === null) {
            B.destination = Fe;
            try {
              si(B, Fe);
            } catch (bt) {
              Xn(B, bt), xr(B, bt);
            }
          }
        }, cancel: function() {
          To(B);
        } }, { highWaterMark: 0 });
        ce.allReady = L, g(ce);
      }, function(ce) {
        L.catch(function() {
        }), y(ce);
      }, R);
      if (c && c.signal) {
        var te = c.signal, pe = function() {
          To(B, te.reason), te.removeEventListener("abort", pe);
        };
        te.addEventListener("abort", pe);
      }
      bo(B);
    });
  }, Er.version = "18.3.1", Er;
}
var Uo;
function kl() {
  if (Uo) return an;
  Uo = 1;
  var e, t;
  return e = wl(), t = Sl(), an.version = e.version, an.renderToString = e.renderToString, an.renderToStaticMarkup = e.renderToStaticMarkup, an.renderToNodeStream = e.renderToNodeStream, an.renderToStaticNodeStream = e.renderToStaticNodeStream, an.renderToReadableStream = t.renderToReadableStream, an;
}
kl();
const Tl = "staticMarkup";
function Rn() {
  const t = qr().indexOf(Tl) > -1 ? !0 : void 0;
  return {
    isBootstrap: t,
    isReact: t ? void 0 : !0
  };
}
const Ye = ({ gaData: e, prefix: t = "", children: n }) => {
  const { isReact: r } = Rn(), { onClick: i, ...a } = n.props;
  if (r)
    return Ve.cloneElement(n, {
      ...a,
      onClick: (m) => (e && e.event && e.action && As(e), i ? i(m) : !0)
    });
  let d = "";
  ["input", "header", "header-input"].includes(t) && (d = `-${t}`);
  const p = {
    [`data-ga${d}`]: e.text,
    [`data-ga${d}-name`]: e.name,
    [`data-ga${d}-event`]: e.event,
    [`data-ga${d}-action`]: e.action,
    [`data-ga${d}-type`]: e.type,
    [`data-ga${d}-region`]: e.region,
    [`data-ga${d}-section`]: e.section,
    [`data-ga${d}-component`]: e.component
  };
  return Ve.cloneElement(n, {
    ...a,
    onClick: i,
    ...p
  });
}, Is = Yi(
  ({
    id: e,
    parentId: t,
    /** @type {AccordionCard} */
    item: n,
    openCard: r,
    onClick: i,
    gaData: a
  }, d) => {
    var h, b, k, _, I, C;
    const p = e === r, m = p ? "open" : "close";
    return /* @__PURE__ */ f.jsxs(
      "div",
      {
        ref: d,
        className: xe("accordion-item", "mt-3", {
          [`accordion-item-${n.color}`]: n.color,
          "accordion-header-icon": (h = n.content) == null ? void 0 : h.icon
        }),
        children: [
          /* @__PURE__ */ f.jsx("div", { className: "accordion-header", children: /* @__PURE__ */ f.jsx("h4", { children: /* @__PURE__ */ f.jsx(
            Ye,
            {
              gaData: {
                ...a,
                action: m,
                text: n.content.header
              },
              children: /* @__PURE__ */ f.jsxs(
                "button",
                {
                  "data-testid": "accordion-opener",
                  className: xe({ collapsed: !p }),
                  "data-bs-toggle": "collapse",
                  href: `#card-body-${e}`,
                  type: "button",
                  "aria-expanded": p,
                  "aria-controls": `card-body-${e}`,
                  onClick: (w) => i(w, e),
                  children: [
                    (b = n.content) != null && b.icon ? /* @__PURE__ */ f.jsxs("span", { className: "accordion-icon", children: [
                      /* @__PURE__ */ f.jsx(
                        "i",
                        {
                          className: `${(k = n.content.icon) == null ? void 0 : k[0]} fa-${(_ = n.content.icon) == null ? void 0 : _[1]} me-2`
                        }
                      ),
                      n.content.header
                    ] }) : (I = n.content) == null ? void 0 : I.header,
                    /* @__PURE__ */ f.jsx("i", { className: "fas fa-chevron-up" })
                  ]
                }
              )
            }
          ) }) }),
          ((C = n.content) == null ? void 0 : C.body) && /* @__PURE__ */ f.jsx(
            "div",
            {
              "data-bs-parent": `#${t}`,
              id: `card-body-${e}`,
              className: xe("collapse", { show: p }),
              children: /* @__PURE__ */ f.jsx(
                "div",
                {
                  className: "accordion-body",
                  dangerouslySetInnerHTML: lt(
                    n.content.body
                  )
                }
              )
            }
          )
        ]
      }
    );
  }
);
Is.propTypes = {
  id: l.number,
  // @ts-ignore a technical type mismatch between PropTypes definition and your TypeScript
  item: Ns,
  parentId: l.string,
  openCard: l.number,
  onClick: l.func,
  gaData: l.object
};
const _l = {
  event: "collapse",
  name: "onclick",
  type: "click",
  region: "main content"
}, Ps = ({ cards: e, openedCard: t }) => {
  const [n, r] = tt(t), i = `accordion-${qr()}`, a = En(
    /** @type { HTMLDivElement[]} */
    []
  ), d = (p, m) => {
    if (p.preventDefault(), n !== m) {
      const h = a.current[n - 1], b = h == null ? void 0 : h.lastElementChild;
      vl(b), r(m);
    } else
      r(null);
  };
  return /* @__PURE__ */ f.jsx("div", { className: "accordion", id: i, children: e == null ? void 0 : e.map(
    (p, m) => p.content.body && p.content.header && /* @__PURE__ */ f.jsx(
      Is,
      {
        ref: (h) => {
          a.current[m] = h;
        },
        id: m + 1,
        parentId: i,
        item: p,
        openCard: n,
        onClick: d,
        gaData: _l
      },
      m + 1
    )
  ) });
};
Ps.propTypes = {
  /**
   * Cards to show in the accordion component
   */
  cards: l.arrayOf(Ns).isRequired,
  /**
   * Opened card based on rendered card position
   */
  openedCard: l.number
};
const Yo = {
  name: "onclick",
  event: "link",
  action: "click",
  type: "internal link",
  region: "main content"
}, ln = ({
  label: e = "",
  cardTitle: t = "",
  gaData: n,
  ariaLabel: r,
  block: i,
  color: a = "gray",
  disabled: d,
  element: p = "button",
  href: m,
  icon: h,
  innerRef: b,
  onClick: k,
  size: _ = "default",
  variant: I,
  classes: C,
  target: w = "_self",
  ...N
}) => {
  if (I) {
    const V = {
      borderless: "borderless",
      outline: "outline",
      filled: "filled"
    }, W = xe("btn", V[I], {
      [`btn-${V[I]}-${a}`]: !0,
      "btn-medium": _ === "medium",
      "btn-small": _ === "small",
      "btn-large": _ === "large" || _ === "default",
      disabled: d
    });
    let A = p;
    return m && p === "button" && (A = "a"), /* @__PURE__ */ f.jsx(
      Ye,
      {
        gaData: {
          ...Yo,
          section: t,
          ...n,
          text: e
        },
        children: /* @__PURE__ */ f.jsxs(
          A,
          {
            type: A === "button" && k ? "button" : void 0,
            ...N,
            className: xe(C) || W,
            href: m,
            ref: b,
            onClick: k,
            "aria-label": r,
            target: A === "a" ? w : null,
            disabled: d,
            children: [
              h && /* @__PURE__ */ f.jsx("i", { className: `${h == null ? void 0 : h[0]} fa-${h == null ? void 0 : h[1]} me-1` }),
              e
            ]
          }
        )
      }
    );
  }
  const M = xe("btn", {
    [`btn-${a}`]: !0,
    "btn-md": _ === "small",
    "btn-sm": _ === "xsmall",
    "btn-block": i,
    disabled: d
  });
  let D = p;
  return m && p === "button" && (D = "a"), /* @__PURE__ */ f.jsx(
    Ye,
    {
      gaData: {
        ...Yo,
        section: t,
        // @deprecated - remove at some point
        ...n,
        text: e
      },
      children: /* @__PURE__ */ f.jsxs(
        D,
        {
          type: D === "button" && k ? "button" : void 0,
          ...N,
          className: xe(C) || M,
          href: m,
          ref: b,
          onClick: k,
          "aria-label": r,
          target: D === "a" ? w : null,
          children: [
            h && /* @__PURE__ */ f.jsx("i", { className: `${h == null ? void 0 : h[0]} fa-${h == null ? void 0 : h[1]} me-1` }),
            e
          ]
        }
      )
    }
  );
};
ln.propTypes = {
  /**
   * Button label
   */
  label: l.string,
  /**
   * @deprecated
   * Card title, use `gaData.section` instead
   */
  cardTitle: l.string,
  /**
   * Google Analytics event data
   */
  gaData: Ki,
  /**
    ARIA label for accessibility
  */
  ariaLabel: l.string,
  /**
    Render button as a block-button?
  */
  block: l.bool,
  /**
    Button background color
  */
  color: l.oneOf(["gold", "maroon", "gray", "dark"]),
  /**
    Disable the button?
  */
  disabled: l.bool,
  /**
    Pass in a Component to override default button element.
    For example: react-router Link
  */
  element: l.oneOfType([
    l.func,
    l.string,
    l.shape({ $$typeof: l.symbol, render: l.func }),
    l.arrayOf(
      l.oneOfType([
        l.func,
        l.string,
        l.shape({ $$typeof: l.symbol, render: l.func })
      ])
    )
  ]),
  /**
    Link target url; will cause button to be rendered as `<a>` link
  */
  href: l.string,
  /**
    React Font Awesome icon prefix and name string to be rendered in button label. Ex: ['fab', 'drupal']
  */
  icon: l.arrayOf(l.string),
  /**
   * ref will only get you a reference to the Button component, use innerRef to
   * get a reference to the DOM element (for things like focus management).
   */
  innerRef: l.oneOfType([
    l.object,
    l.func,
    l.string
  ]),
  /**
    Event handler function for `<button>`
  */
  onClick: l.func,
  /**
    Button size. Legacy sizes (default, small, xsmall) or new sizes (large, medium, small) when used with variant prop.
  */
  size: l.oneOf(["default", "small", "xsmall", "large", "medium"]),
  /**
    Button style variant (borderless, outline, filled). When provided, uses new UDS button styles.
  */
  variant: l.oneOf(["borderless", "outline", "filled"]),
  /**
    Classes to add to button
  */
  classes: l.arrayOf(l.string),
  /**
   Link target type
   */
  target: l.oneOf(["_blank", "_self", "_top", "_parent"])
};
var wi = { exports: {} }, je = {};
var Go;
function El() {
  if (Go) return je;
  Go = 1;
  var e = Symbol.for("react.transitional.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), a = Symbol.for("react.consumer"), d = Symbol.for("react.context"), p = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), h = Symbol.for("react.suspense_list"), b = Symbol.for("react.memo"), k = Symbol.for("react.lazy"), _ = Symbol.for("react.offscreen"), I = Symbol.for("react.client.reference");
  function C(w) {
    if (typeof w == "object" && w !== null) {
      var N = w.$$typeof;
      switch (N) {
        case e:
          switch (w = w.type, w) {
            case n:
            case i:
            case r:
            case m:
            case h:
              return w;
            default:
              switch (w = w && w.$$typeof, w) {
                case d:
                case p:
                case k:
                case b:
                  return w;
                case a:
                  return w;
                default:
                  return N;
              }
          }
        case t:
          return N;
      }
    }
  }
  return je.ContextConsumer = a, je.ContextProvider = d, je.Element = e, je.ForwardRef = p, je.Fragment = n, je.Lazy = k, je.Memo = b, je.Portal = t, je.Profiler = i, je.StrictMode = r, je.Suspense = m, je.SuspenseList = h, je.isContextConsumer = function(w) {
    return C(w) === a;
  }, je.isContextProvider = function(w) {
    return C(w) === d;
  }, je.isElement = function(w) {
    return typeof w == "object" && w !== null && w.$$typeof === e;
  }, je.isForwardRef = function(w) {
    return C(w) === p;
  }, je.isFragment = function(w) {
    return C(w) === n;
  }, je.isLazy = function(w) {
    return C(w) === k;
  }, je.isMemo = function(w) {
    return C(w) === b;
  }, je.isPortal = function(w) {
    return C(w) === t;
  }, je.isProfiler = function(w) {
    return C(w) === i;
  }, je.isStrictMode = function(w) {
    return C(w) === r;
  }, je.isSuspense = function(w) {
    return C(w) === m;
  }, je.isSuspenseList = function(w) {
    return C(w) === h;
  }, je.isValidElementType = function(w) {
    return typeof w == "string" || typeof w == "function" || w === n || w === i || w === r || w === m || w === h || w === _ || typeof w == "object" && w !== null && (w.$$typeof === k || w.$$typeof === b || w.$$typeof === d || w.$$typeof === a || w.$$typeof === p || w.$$typeof === I || w.getModuleId !== void 0);
  }, je.typeOf = C, je;
}
var Xo;
function Cl() {
  return Xo || (Xo = 1, wi.exports = /* @__PURE__ */ El()), wi.exports;
}
var Ls = /* @__PURE__ */ Cl();
function Rl(e) {
  function t(G, z, U, q, j) {
    for (var de = 0, $ = 0, ge = 0, oe = 0, se, Q, ae = 0, Se = 0, ie, Ie = ie = se = 0, he = 0, ke = 0, Qe = 0, Ce = 0, wt = U.length, Ge = wt - 1, Re, J = "", we = "", it = "", Xe = "", Ke; he < wt; ) {
      if (Q = U.charCodeAt(he), he === Ge && $ + oe + ge + de !== 0 && ($ !== 0 && (Q = $ === 47 ? 10 : 47), oe = ge = de = 0, wt++, Ge++), $ + oe + ge + de === 0) {
        if (he === Ge && (0 < ke && (J = J.replace(_, "")), 0 < J.trim().length)) {
          switch (Q) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;
            default:
              J += U.charAt(he);
          }
          Q = 59;
        }
        switch (Q) {
          case 123:
            for (J = J.trim(), se = J.charCodeAt(0), ie = 1, Ce = ++he; he < wt; ) {
              switch (Q = U.charCodeAt(he)) {
                case 123:
                  ie++;
                  break;
                case 125:
                  ie--;
                  break;
                case 47:
                  switch (Q = U.charCodeAt(he + 1)) {
                    case 42:
                    case 47:
                      e: {
                        for (Ie = he + 1; Ie < Ge; ++Ie)
                          switch (U.charCodeAt(Ie)) {
                            case 47:
                              if (Q === 42 && U.charCodeAt(Ie - 1) === 42 && he + 2 !== Ie) {
                                he = Ie + 1;
                                break e;
                              }
                              break;
                            case 10:
                              if (Q === 47) {
                                he = Ie + 1;
                                break e;
                              }
                          }
                        he = Ie;
                      }
                  }
                  break;
                case 91:
                  Q++;
                case 40:
                  Q++;
                case 34:
                case 39:
                  for (; he++ < Ge && U.charCodeAt(he) !== Q; )
                    ;
              }
              if (ie === 0) break;
              he++;
            }
            switch (ie = U.substring(Ce, he), se === 0 && (se = (J = J.replace(k, "").trim()).charCodeAt(0)), se) {
              case 64:
                switch (0 < ke && (J = J.replace(_, "")), Q = J.charCodeAt(1), Q) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    ke = z;
                    break;
                  default:
                    ke = dt;
                }
                if (ie = t(z, ke, ie, Q, j + 1), Ce = ie.length, 0 < He && (ke = n(dt, J, Qe), Ke = p(3, ie, ke, z, Z, fe, Ce, Q, j, q), J = ke.join(""), Ke !== void 0 && (Ce = (ie = Ke.trim()).length) === 0 && (Q = 0, ie = "")), 0 < Ce) switch (Q) {
                  case 115:
                    J = J.replace(X, d);
                  case 100:
                  case 109:
                  case 45:
                    ie = J + "{" + ie + "}";
                    break;
                  case 107:
                    J = J.replace(D, "$1 $2"), ie = J + "{" + ie + "}", ie = Ae === 1 || Ae === 2 && a("@" + ie, 3) ? "@-webkit-" + ie + "@" + ie : "@" + ie;
                    break;
                  default:
                    ie = J + ie, q === 112 && (ie = (we += ie, ""));
                }
                else ie = "";
                break;
              default:
                ie = t(z, n(z, J, Qe), ie, q, j + 1);
            }
            it += ie, ie = Qe = ke = Ie = se = 0, J = "", Q = U.charCodeAt(++he);
            break;
          case 125:
          case 59:
            if (J = (0 < ke ? J.replace(_, "") : J).trim(), 1 < (Ce = J.length)) switch (Ie === 0 && (se = J.charCodeAt(0), se === 45 || 96 < se && 123 > se) && (Ce = (J = J.replace(" ", ":")).length), 0 < He && (Ke = p(1, J, z, G, Z, fe, we.length, q, j, q)) !== void 0 && (Ce = (J = Ke.trim()).length) === 0 && (J = "\0\0"), se = J.charCodeAt(0), Q = J.charCodeAt(1), se) {
              case 0:
                break;
              case 64:
                if (Q === 105 || Q === 99) {
                  Xe += J + U.charAt(he);
                  break;
                }
              default:
                J.charCodeAt(Ce - 1) !== 58 && (we += i(J, se, Q, J.charCodeAt(2)));
            }
            Qe = ke = Ie = se = 0, J = "", Q = U.charCodeAt(++he);
        }
      }
      switch (Q) {
        case 13:
        case 10:
          $ === 47 ? $ = 0 : 1 + se === 0 && q !== 107 && 0 < J.length && (ke = 1, J += "\0"), 0 < He * ft && p(0, J, z, G, Z, fe, we.length, q, j, q), fe = 1, Z++;
          break;
        case 59:
        case 125:
          if ($ + oe + ge + de === 0) {
            fe++;
            break;
          }
        default:
          switch (fe++, Re = U.charAt(he), Q) {
            case 9:
            case 32:
              if (oe + de + $ === 0) switch (ae) {
                case 44:
                case 58:
                case 9:
                case 32:
                  Re = "";
                  break;
                default:
                  Q !== 32 && (Re = " ");
              }
              break;
            case 0:
              Re = "\\0";
              break;
            case 12:
              Re = "\\f";
              break;
            case 11:
              Re = "\\v";
              break;
            case 38:
              oe + $ + de === 0 && (ke = Qe = 1, Re = "\f" + Re);
              break;
            case 108:
              if (oe + $ + de + ue === 0 && 0 < Ie) switch (he - Ie) {
                case 2:
                  ae === 112 && U.charCodeAt(he - 3) === 58 && (ue = ae);
                case 8:
                  Se === 111 && (ue = Se);
              }
              break;
            case 58:
              oe + $ + de === 0 && (Ie = he);
              break;
            case 44:
              $ + ge + oe + de === 0 && (ke = 1, Re += "\r");
              break;
            case 34:
            case 39:
              $ === 0 && (oe = oe === Q ? 0 : oe === 0 ? Q : oe);
              break;
            case 91:
              oe + $ + ge === 0 && de++;
              break;
            case 93:
              oe + $ + ge === 0 && de--;
              break;
            case 41:
              oe + $ + de === 0 && ge--;
              break;
            case 40:
              if (oe + $ + de === 0) {
                if (se === 0) switch (2 * ae + 3 * Se) {
                  case 533:
                    break;
                  default:
                    se = 1;
                }
                ge++;
              }
              break;
            case 64:
              $ + ge + oe + de + Ie + ie === 0 && (ie = 1);
              break;
            case 42:
            case 47:
              if (!(0 < oe + de + ge)) switch ($) {
                case 0:
                  switch (2 * Q + 3 * U.charCodeAt(he + 1)) {
                    case 235:
                      $ = 47;
                      break;
                    case 220:
                      Ce = he, $ = 42;
                  }
                  break;
                case 42:
                  Q === 47 && ae === 42 && Ce + 2 !== he && (U.charCodeAt(Ce + 2) === 33 && (we += U.substring(Ce, he + 1)), Re = "", $ = 0);
              }
          }
          $ === 0 && (J += Re);
      }
      Se = ae, ae = Q, he++;
    }
    if (Ce = we.length, 0 < Ce) {
      if (ke = z, 0 < He && (Ke = p(2, we, ke, G, Z, fe, Ce, q, j, q), Ke !== void 0 && (we = Ke).length === 0)) return Xe + we + it;
      if (we = ke.join(",") + "{" + we + "}", Ae * ue !== 0) {
        switch (Ae !== 2 || a(we, 2) || (ue = 0), ue) {
          case 111:
            we = we.replace(W, ":-moz-$1") + we;
            break;
          case 112:
            we = we.replace(V, "::-webkit-input-$1") + we.replace(V, "::-moz-$1") + we.replace(V, ":-ms-input-$1") + we;
        }
        ue = 0;
      }
    }
    return Xe + we + it;
  }
  function n(G, z, U) {
    var q = z.trim().split(N);
    z = q;
    var j = q.length, de = G.length;
    switch (de) {
      case 0:
      case 1:
        var $ = 0;
        for (G = de === 0 ? "" : G[0] + " "; $ < j; ++$)
          z[$] = r(G, z[$], U).trim();
        break;
      default:
        var ge = $ = 0;
        for (z = []; $ < j; ++$)
          for (var oe = 0; oe < de; ++oe)
            z[ge++] = r(G[oe] + " ", q[$], U).trim();
    }
    return z;
  }
  function r(G, z, U) {
    var q = z.charCodeAt(0);
    switch (33 > q && (q = (z = z.trim()).charCodeAt(0)), q) {
      case 38:
        return z.replace(M, "$1" + G.trim());
      case 58:
        return G.trim() + z.replace(M, "$1" + G.trim());
      default:
        if (0 < 1 * U && 0 < z.indexOf("\f")) return z.replace(M, (G.charCodeAt(0) === 58 ? "" : "$1") + G.trim());
    }
    return G + z;
  }
  function i(G, z, U, q) {
    var j = G + ";", de = 2 * z + 3 * U + 4 * q;
    if (de === 944) {
      G = j.indexOf(":", 9) + 1;
      var $ = j.substring(G, j.length - 1).trim();
      return $ = j.substring(0, G).trim() + $ + ";", Ae === 1 || Ae === 2 && a($, 1) ? "-webkit-" + $ + $ : $;
    }
    if (Ae === 0 || Ae === 2 && !a(j, 1)) return j;
    switch (de) {
      case 1015:
        return j.charCodeAt(10) === 97 ? "-webkit-" + j + j : j;
      case 951:
        return j.charCodeAt(3) === 116 ? "-webkit-" + j + j : j;
      case 963:
        return j.charCodeAt(5) === 110 ? "-webkit-" + j + j : j;
      case 1009:
        if (j.charCodeAt(4) !== 100) break;
      case 969:
      case 942:
        return "-webkit-" + j + j;
      case 978:
        return "-webkit-" + j + "-moz-" + j + j;
      case 1019:
      case 983:
        return "-webkit-" + j + "-moz-" + j + "-ms-" + j + j;
      case 883:
        if (j.charCodeAt(8) === 45) return "-webkit-" + j + j;
        if (0 < j.indexOf("image-set(", 11)) return j.replace(ve, "$1-webkit-$2") + j;
        break;
      case 932:
        if (j.charCodeAt(4) === 45) switch (j.charCodeAt(5)) {
          case 103:
            return "-webkit-box-" + j.replace("-grow", "") + "-webkit-" + j + "-ms-" + j.replace("grow", "positive") + j;
          case 115:
            return "-webkit-" + j + "-ms-" + j.replace("shrink", "negative") + j;
          case 98:
            return "-webkit-" + j + "-ms-" + j.replace("basis", "preferred-size") + j;
        }
        return "-webkit-" + j + "-ms-" + j + j;
      case 964:
        return "-webkit-" + j + "-ms-flex-" + j + j;
      case 1023:
        if (j.charCodeAt(8) !== 99) break;
        return $ = j.substring(j.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify"), "-webkit-box-pack" + $ + "-webkit-" + j + "-ms-flex-pack" + $ + j;
      case 1005:
        return C.test(j) ? j.replace(I, ":-webkit-") + j.replace(I, ":-moz-") + j : j;
      case 1e3:
        switch ($ = j.substring(13).trim(), z = $.indexOf("-") + 1, $.charCodeAt(0) + $.charCodeAt(z)) {
          case 226:
            $ = j.replace(A, "tb");
            break;
          case 232:
            $ = j.replace(A, "tb-rl");
            break;
          case 220:
            $ = j.replace(A, "lr");
            break;
          default:
            return j;
        }
        return "-webkit-" + j + "-ms-" + $ + j;
      case 1017:
        if (j.indexOf("sticky", 9) === -1) break;
      case 975:
        switch (z = (j = G).length - 10, $ = (j.charCodeAt(z) === 33 ? j.substring(0, z) : j).substring(G.indexOf(":", 7) + 1).trim(), de = $.charCodeAt(0) + ($.charCodeAt(7) | 0)) {
          case 203:
            if (111 > $.charCodeAt(8)) break;
          case 115:
            j = j.replace($, "-webkit-" + $) + ";" + j;
            break;
          case 207:
          case 102:
            j = j.replace($, "-webkit-" + (102 < de ? "inline-" : "") + "box") + ";" + j.replace($, "-webkit-" + $) + ";" + j.replace($, "-ms-" + $ + "box") + ";" + j;
        }
        return j + ";";
      case 938:
        if (j.charCodeAt(5) === 45) switch (j.charCodeAt(6)) {
          case 105:
            return $ = j.replace("-items", ""), "-webkit-" + j + "-webkit-box-" + $ + "-ms-flex-" + $ + j;
          case 115:
            return "-webkit-" + j + "-ms-flex-item-" + j.replace(Me, "") + j;
          default:
            return "-webkit-" + j + "-ms-flex-line-pack" + j.replace("align-content", "").replace(Me, "") + j;
        }
        break;
      case 973:
      case 989:
        if (j.charCodeAt(3) !== 45 || j.charCodeAt(4) === 122) break;
      case 931:
      case 953:
        if (De.test(G) === !0) return ($ = G.substring(G.indexOf(":") + 1)).charCodeAt(0) === 115 ? i(G.replace("stretch", "fill-available"), z, U, q).replace(":fill-available", ":stretch") : j.replace($, "-webkit-" + $) + j.replace($, "-moz-" + $.replace("fill-", "")) + j;
        break;
      case 962:
        if (j = "-webkit-" + j + (j.charCodeAt(5) === 102 ? "-ms-" + j : "") + j, U + q === 211 && j.charCodeAt(13) === 105 && 0 < j.indexOf("transform", 10)) return j.substring(0, j.indexOf(";", 27) + 1).replace(w, "$1-webkit-$2") + j;
    }
    return j;
  }
  function a(G, z) {
    var U = G.indexOf(z === 1 ? ":" : "{"), q = G.substring(0, z !== 3 ? U : 10);
    return U = G.substring(U + 1, G.length - 1), Ue(z !== 2 ? q : q.replace(Ne, "$1"), U, z);
  }
  function d(G, z) {
    var U = i(z, z.charCodeAt(0), z.charCodeAt(1), z.charCodeAt(2));
    return U !== z + ";" ? U.replace(re, " or ($1)").substring(4) : "(" + z + ")";
  }
  function p(G, z, U, q, j, de, $, ge, oe, se) {
    for (var Q = 0, ae = z, Se; Q < He; ++Q)
      switch (Se = ze[Q].call(b, G, ae, U, q, j, de, $, ge, oe, se)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;
        default:
          ae = Se;
      }
    if (ae !== z) return ae;
  }
  function m(G) {
    switch (G) {
      case void 0:
      case null:
        He = ze.length = 0;
        break;
      default:
        if (typeof G == "function") ze[He++] = G;
        else if (typeof G == "object") for (var z = 0, U = G.length; z < U; ++z)
          m(G[z]);
        else ft = !!G | 0;
    }
    return m;
  }
  function h(G) {
    return G = G.prefix, G !== void 0 && (Ue = null, G ? typeof G != "function" ? Ae = 1 : (Ae = 2, Ue = G) : Ae = 0), h;
  }
  function b(G, z) {
    var U = G;
    if (33 > U.charCodeAt(0) && (U = U.trim()), be = U, U = [be], 0 < He) {
      var q = p(-1, z, U, U, Z, fe, 0, 0, 0, 0);
      q !== void 0 && typeof q == "string" && (z = q);
    }
    var j = t(dt, U, z, 0, 0);
    return 0 < He && (q = p(-2, j, U, U, Z, fe, j.length, 0, 0, 0), q !== void 0 && (j = q)), be = "", ue = 0, fe = Z = 1, j;
  }
  var k = /^\0+/g, _ = /[\0\r\f]/g, I = /: */g, C = /zoo|gra/, w = /([,: ])(transform)/g, N = /,\r+?/g, M = /([\t\r\n ])*\f?&/g, D = /@(k\w+)\s*(\S*)\s*/, V = /::(place)/g, W = /:(read-only)/g, A = /[svh]\w+-[tblr]{2}/, X = /\(\s*(.*)\s*\)/g, re = /([\s\S]*?);/g, Me = /-self|flex-/g, Ne = /[^]*?(:[rp][el]a[\w-]+)[^]*/, De = /stretch|:\s*\w+\-(?:conte|avail)/, ve = /([^-])(image-set\()/, fe = 1, Z = 1, ue = 0, Ae = 1, dt = [], ze = [], He = 0, Ue = null, ft = 0, be = "";
  return b.use = m, b.set = h, e !== void 0 && h(e), b;
}
var Ol = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};
function Al(e) {
  var t = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return t[n] === void 0 && (t[n] = e(n)), t[n];
  };
}
var jl = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, Ko = /* @__PURE__ */ Al(
  function(e) {
    return jl.test(e) || e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) < 91;
  }
  /* Z+1 */
), Si = { exports: {} }, Ee = {};
var Zo;
function Nl() {
  if (Zo) return Ee;
  Zo = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, d = e ? Symbol.for("react.provider") : 60109, p = e ? Symbol.for("react.context") : 60110, m = e ? Symbol.for("react.async_mode") : 60111, h = e ? Symbol.for("react.concurrent_mode") : 60111, b = e ? Symbol.for("react.forward_ref") : 60112, k = e ? Symbol.for("react.suspense") : 60113, _ = e ? Symbol.for("react.suspense_list") : 60120, I = e ? Symbol.for("react.memo") : 60115, C = e ? Symbol.for("react.lazy") : 60116, w = e ? Symbol.for("react.block") : 60121, N = e ? Symbol.for("react.fundamental") : 60117, M = e ? Symbol.for("react.responder") : 60118, D = e ? Symbol.for("react.scope") : 60119;
  function V(A) {
    if (typeof A == "object" && A !== null) {
      var X = A.$$typeof;
      switch (X) {
        case t:
          switch (A = A.type, A) {
            case m:
            case h:
            case r:
            case a:
            case i:
            case k:
              return A;
            default:
              switch (A = A && A.$$typeof, A) {
                case p:
                case b:
                case C:
                case I:
                case d:
                  return A;
                default:
                  return X;
              }
          }
        case n:
          return X;
      }
    }
  }
  function W(A) {
    return V(A) === h;
  }
  return Ee.AsyncMode = m, Ee.ConcurrentMode = h, Ee.ContextConsumer = p, Ee.ContextProvider = d, Ee.Element = t, Ee.ForwardRef = b, Ee.Fragment = r, Ee.Lazy = C, Ee.Memo = I, Ee.Portal = n, Ee.Profiler = a, Ee.StrictMode = i, Ee.Suspense = k, Ee.isAsyncMode = function(A) {
    return W(A) || V(A) === m;
  }, Ee.isConcurrentMode = W, Ee.isContextConsumer = function(A) {
    return V(A) === p;
  }, Ee.isContextProvider = function(A) {
    return V(A) === d;
  }, Ee.isElement = function(A) {
    return typeof A == "object" && A !== null && A.$$typeof === t;
  }, Ee.isForwardRef = function(A) {
    return V(A) === b;
  }, Ee.isFragment = function(A) {
    return V(A) === r;
  }, Ee.isLazy = function(A) {
    return V(A) === C;
  }, Ee.isMemo = function(A) {
    return V(A) === I;
  }, Ee.isPortal = function(A) {
    return V(A) === n;
  }, Ee.isProfiler = function(A) {
    return V(A) === a;
  }, Ee.isStrictMode = function(A) {
    return V(A) === i;
  }, Ee.isSuspense = function(A) {
    return V(A) === k;
  }, Ee.isValidElementType = function(A) {
    return typeof A == "string" || typeof A == "function" || A === r || A === h || A === a || A === i || A === k || A === _ || typeof A == "object" && A !== null && (A.$$typeof === C || A.$$typeof === I || A.$$typeof === d || A.$$typeof === p || A.$$typeof === b || A.$$typeof === N || A.$$typeof === M || A.$$typeof === D || A.$$typeof === w);
  }, Ee.typeOf = V, Ee;
}
var Jo;
function Il() {
  return Jo || (Jo = 1, Si.exports = Nl()), Si.exports;
}
var ki, Qo;
function Pl() {
  if (Qo) return ki;
  Qo = 1;
  var e = Il(), t = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
  }, n = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
  }, r = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
  }, i = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
  }, a = {};
  a[e.ForwardRef] = r, a[e.Memo] = i;
  function d(C) {
    return e.isMemo(C) ? i : a[C.$$typeof] || t;
  }
  var p = Object.defineProperty, m = Object.getOwnPropertyNames, h = Object.getOwnPropertySymbols, b = Object.getOwnPropertyDescriptor, k = Object.getPrototypeOf, _ = Object.prototype;
  function I(C, w, N) {
    if (typeof w != "string") {
      if (_) {
        var M = k(w);
        M && M !== _ && I(C, M, N);
      }
      var D = m(w);
      h && (D = D.concat(h(w)));
      for (var V = d(C), W = d(w), A = 0; A < D.length; ++A) {
        var X = D[A];
        if (!n[X] && !(N && N[X]) && !(W && W[X]) && !(V && V[X])) {
          var re = b(w, X);
          try {
            p(C, X, re);
          } catch {
          }
        }
      }
    }
    return C;
  }
  return ki = I, ki;
}
var Ll = Pl();
const Ml = /* @__PURE__ */ Xi(Ll);
var rt = { env: { NODE_ENV: "production" } };
function Xt() {
  return (Xt = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }).apply(this, arguments);
}
var es = function(e, t) {
  for (var n = [e[0]], r = 0, i = t.length; r < i; r += 1) n.push(t[r], e[r + 1]);
  return n;
}, Ai = function(e) {
  return e !== null && typeof e == "object" && (e.toString ? e.toString() : Object.prototype.toString.call(e)) === "[object Object]" && !Ls.typeOf(e);
}, Br = Object.freeze([]), cn = Object.freeze({});
function or(e) {
  return typeof e == "function";
}
function ts(e) {
  return e.displayName || e.name || "Component";
}
function Zi(e) {
  return e && typeof e.styledComponentId == "string";
}
var Dn = typeof rt < "u" && rt.env !== void 0 && (rt.env.REACT_APP_SC_ATTR || rt.env.SC_ATTR) || "data-styled", Ji = typeof window < "u" && "HTMLElement" in window, Dl = !!(typeof SC_DISABLE_SPEEDY == "boolean" ? SC_DISABLE_SPEEDY : typeof rt < "u" && rt.env !== void 0 && (rt.env.REACT_APP_SC_DISABLE_SPEEDY !== void 0 && rt.env.REACT_APP_SC_DISABLE_SPEEDY !== "" ? rt.env.REACT_APP_SC_DISABLE_SPEEDY !== "false" && rt.env.REACT_APP_SC_DISABLE_SPEEDY : rt.env.SC_DISABLE_SPEEDY !== void 0 && rt.env.SC_DISABLE_SPEEDY !== "" ? rt.env.SC_DISABLE_SPEEDY !== "false" && rt.env.SC_DISABLE_SPEEDY : rt.env.NODE_ENV !== "production"));
function ar(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) n[r - 1] = arguments[r];
  throw new Error("An error occurred. See https://git.io/JUIaE#" + e + " for more information." + (n.length > 0 ? " Args: " + n.join(", ") : ""));
}
var Fl = function() {
  function e(n) {
    this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = n;
  }
  var t = e.prototype;
  return t.indexOfGroup = function(n) {
    for (var r = 0, i = 0; i < n; i++) r += this.groupSizes[i];
    return r;
  }, t.insertRules = function(n, r) {
    if (n >= this.groupSizes.length) {
      for (var i = this.groupSizes, a = i.length, d = a; n >= d; ) (d <<= 1) < 0 && ar(16, "" + n);
      this.groupSizes = new Uint32Array(d), this.groupSizes.set(i), this.length = d;
      for (var p = a; p < d; p++) this.groupSizes[p] = 0;
    }
    for (var m = this.indexOfGroup(n + 1), h = 0, b = r.length; h < b; h++) this.tag.insertRule(m, r[h]) && (this.groupSizes[n]++, m++);
  }, t.clearGroup = function(n) {
    if (n < this.length) {
      var r = this.groupSizes[n], i = this.indexOfGroup(n), a = i + r;
      this.groupSizes[n] = 0;
      for (var d = i; d < a; d++) this.tag.deleteRule(i);
    }
  }, t.getGroup = function(n) {
    var r = "";
    if (n >= this.length || this.groupSizes[n] === 0) return r;
    for (var i = this.groupSizes[n], a = this.indexOfGroup(n), d = a + i, p = a; p < d; p++) r += this.tag.getRule(p) + `/*!sc*/
`;
    return r;
  }, e;
}(), Pr = /* @__PURE__ */ new Map(), zr = /* @__PURE__ */ new Map(), rr = 1, Cr = function(e) {
  if (Pr.has(e)) return Pr.get(e);
  for (; zr.has(rr); ) rr++;
  var t = rr++;
  return Pr.set(e, t), zr.set(t, e), t;
}, $l = function(e) {
  return zr.get(e);
}, Bl = function(e, t) {
  t >= rr && (rr = t + 1), Pr.set(e, t), zr.set(t, e);
}, zl = "style[" + Dn + '][data-styled-version="5.3.11"]', Hl = new RegExp("^" + Dn + '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'), Vl = function(e, t, n) {
  for (var r, i = n.split(","), a = 0, d = i.length; a < d; a++) (r = i[a]) && e.registerName(t, r);
}, Wl = function(e, t) {
  for (var n = (t.textContent || "").split(`/*!sc*/
`), r = [], i = 0, a = n.length; i < a; i++) {
    var d = n[i].trim();
    if (d) {
      var p = d.match(Hl);
      if (p) {
        var m = 0 | parseInt(p[1], 10), h = p[2];
        m !== 0 && (Bl(h, m), Vl(e, h, p[3]), e.getTag().insertRules(m, r)), r.length = 0;
      } else r.push(d);
    }
  }
}, ql = function() {
  return typeof __webpack_nonce__ < "u" ? __webpack_nonce__ : null;
}, Ms = function(e) {
  var t = document.head, n = e || t, r = document.createElement("style"), i = function(p) {
    for (var m = p.childNodes, h = m.length; h >= 0; h--) {
      var b = m[h];
      if (b && b.nodeType === 1 && b.hasAttribute(Dn)) return b;
    }
  }(n), a = i !== void 0 ? i.nextSibling : null;
  r.setAttribute(Dn, "active"), r.setAttribute("data-styled-version", "5.3.11");
  var d = ql();
  return d && r.setAttribute("nonce", d), n.insertBefore(r, a), r;
}, Ul = function() {
  function e(n) {
    var r = this.element = Ms(n);
    r.appendChild(document.createTextNode("")), this.sheet = function(i) {
      if (i.sheet) return i.sheet;
      for (var a = document.styleSheets, d = 0, p = a.length; d < p; d++) {
        var m = a[d];
        if (m.ownerNode === i) return m;
      }
      ar(17);
    }(r), this.length = 0;
  }
  var t = e.prototype;
  return t.insertRule = function(n, r) {
    try {
      return this.sheet.insertRule(r, n), this.length++, !0;
    } catch {
      return !1;
    }
  }, t.deleteRule = function(n) {
    this.sheet.deleteRule(n), this.length--;
  }, t.getRule = function(n) {
    var r = this.sheet.cssRules[n];
    return r !== void 0 && typeof r.cssText == "string" ? r.cssText : "";
  }, e;
}(), Yl = function() {
  function e(n) {
    var r = this.element = Ms(n);
    this.nodes = r.childNodes, this.length = 0;
  }
  var t = e.prototype;
  return t.insertRule = function(n, r) {
    if (n <= this.length && n >= 0) {
      var i = document.createTextNode(r), a = this.nodes[n];
      return this.element.insertBefore(i, a || null), this.length++, !0;
    }
    return !1;
  }, t.deleteRule = function(n) {
    this.element.removeChild(this.nodes[n]), this.length--;
  }, t.getRule = function(n) {
    return n < this.length ? this.nodes[n].textContent : "";
  }, e;
}(), Gl = function() {
  function e(n) {
    this.rules = [], this.length = 0;
  }
  var t = e.prototype;
  return t.insertRule = function(n, r) {
    return n <= this.length && (this.rules.splice(n, 0, r), this.length++, !0);
  }, t.deleteRule = function(n) {
    this.rules.splice(n, 1), this.length--;
  }, t.getRule = function(n) {
    return n < this.length ? this.rules[n] : "";
  }, e;
}(), ns = Ji, Xl = { isServer: !Ji, useCSSOMInjection: !Dl }, Ds = function() {
  function e(n, r, i) {
    n === void 0 && (n = cn), r === void 0 && (r = {}), this.options = Xt({}, Xl, {}, n), this.gs = r, this.names = new Map(i), this.server = !!n.isServer, !this.server && Ji && ns && (ns = !1, function(a) {
      for (var d = document.querySelectorAll(zl), p = 0, m = d.length; p < m; p++) {
        var h = d[p];
        h && h.getAttribute(Dn) !== "active" && (Wl(a, h), h.parentNode && h.parentNode.removeChild(h));
      }
    }(this));
  }
  e.registerId = function(n) {
    return Cr(n);
  };
  var t = e.prototype;
  return t.reconstructWithOptions = function(n, r) {
    return r === void 0 && (r = !0), new e(Xt({}, this.options, {}, n), this.gs, r && this.names || void 0);
  }, t.allocateGSInstance = function(n) {
    return this.gs[n] = (this.gs[n] || 0) + 1;
  }, t.getTag = function() {
    return this.tag || (this.tag = (i = (r = this.options).isServer, a = r.useCSSOMInjection, d = r.target, n = i ? new Gl(d) : a ? new Ul(d) : new Yl(d), new Fl(n)));
    var n, r, i, a, d;
  }, t.hasNameForId = function(n, r) {
    return this.names.has(n) && this.names.get(n).has(r);
  }, t.registerName = function(n, r) {
    if (Cr(n), this.names.has(n)) this.names.get(n).add(r);
    else {
      var i = /* @__PURE__ */ new Set();
      i.add(r), this.names.set(n, i);
    }
  }, t.insertRules = function(n, r, i) {
    this.registerName(n, r), this.getTag().insertRules(Cr(n), i);
  }, t.clearNames = function(n) {
    this.names.has(n) && this.names.get(n).clear();
  }, t.clearRules = function(n) {
    this.getTag().clearGroup(Cr(n)), this.clearNames(n);
  }, t.clearTag = function() {
    this.tag = void 0;
  }, t.toString = function() {
    return function(n) {
      for (var r = n.getTag(), i = r.length, a = "", d = 0; d < i; d++) {
        var p = $l(d);
        if (p !== void 0) {
          var m = n.names.get(p), h = r.getGroup(d);
          if (m && h && m.size) {
            var b = Dn + ".g" + d + '[id="' + p + '"]', k = "";
            m !== void 0 && m.forEach(function(_) {
              _.length > 0 && (k += _ + ",");
            }), a += "" + h + b + '{content:"' + k + `"}/*!sc*/
`;
          }
        }
      }
      return a;
    }(this);
  }, e;
}(), Kl = /(a)(d)/gi, rs = function(e) {
  return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function ji(e) {
  var t, n = "";
  for (t = Math.abs(e); t > 52; t = t / 52 | 0) n = rs(t % 52) + n;
  return (rs(t % 52) + n).replace(Kl, "$1-$2");
}
var Mn = function(e, t) {
  for (var n = t.length; n; ) e = 33 * e ^ t.charCodeAt(--n);
  return e;
}, Fs = function(e) {
  return Mn(5381, e);
};
function Zl(e) {
  for (var t = 0; t < e.length; t += 1) {
    var n = e[t];
    if (or(n) && !Zi(n)) return !1;
  }
  return !0;
}
var Jl = Fs("5.3.11"), Ql = function() {
  function e(t, n, r) {
    this.rules = t, this.staticRulesId = "", this.isStatic = (r === void 0 || r.isStatic) && Zl(t), this.componentId = n, this.baseHash = Mn(Jl, n), this.baseStyle = r, Ds.registerId(n);
  }
  return e.prototype.generateAndInjectStyles = function(t, n, r) {
    var i = this.componentId, a = [];
    if (this.baseStyle && a.push(this.baseStyle.generateAndInjectStyles(t, n, r)), this.isStatic && !r.hash) if (this.staticRulesId && n.hasNameForId(i, this.staticRulesId)) a.push(this.staticRulesId);
    else {
      var d = Fn(this.rules, t, n, r).join(""), p = ji(Mn(this.baseHash, d) >>> 0);
      if (!n.hasNameForId(i, p)) {
        var m = r(d, "." + p, void 0, i);
        n.insertRules(i, p, m);
      }
      a.push(p), this.staticRulesId = p;
    }
    else {
      for (var h = this.rules.length, b = Mn(this.baseHash, r.hash), k = "", _ = 0; _ < h; _++) {
        var I = this.rules[_];
        if (typeof I == "string") k += I;
        else if (I) {
          var C = Fn(I, t, n, r), w = Array.isArray(C) ? C.join("") : C;
          b = Mn(b, w + _), k += w;
        }
      }
      if (k) {
        var N = ji(b >>> 0);
        if (!n.hasNameForId(i, N)) {
          var M = r(k, "." + N, void 0, i);
          n.insertRules(i, N, M);
        }
        a.push(N);
      }
    }
    return a.join(" ");
  }, e;
}(), ec = /^\s*\/\/.*$/gm, tc = [":", "[", ".", "#"];
function nc(e) {
  var t, n, r, i, a = cn, d = a.options, p = d === void 0 ? cn : d, m = a.plugins, h = m === void 0 ? Br : m, b = new Rl(p), k = [], _ = /* @__PURE__ */ function(w) {
    function N(M) {
      if (M) try {
        w(M + "}");
      } catch {
      }
    }
    return function(M, D, V, W, A, X, re, Me, Ne, De) {
      switch (M) {
        case 1:
          if (Ne === 0 && D.charCodeAt(0) === 64) return w(D + ";"), "";
          break;
        case 2:
          if (Me === 0) return D + "/*|*/";
          break;
        case 3:
          switch (Me) {
            case 102:
            case 112:
              return w(V[0] + D), "";
            default:
              return D + (De === 0 ? "/*|*/" : "");
          }
        case -2:
          D.split("/*|*/}").forEach(N);
      }
    };
  }(function(w) {
    k.push(w);
  }), I = function(w, N, M) {
    return N === 0 && tc.indexOf(M[n.length]) !== -1 || M.match(i) ? w : "." + t;
  };
  function C(w, N, M, D) {
    D === void 0 && (D = "&");
    var V = w.replace(ec, ""), W = N && M ? M + " " + N + " { " + V + " }" : V;
    return t = D, n = N, r = new RegExp("\\" + n + "\\b", "g"), i = new RegExp("(\\" + n + "\\b){2,}"), b(M || !N ? "" : N, W);
  }
  return b.use([].concat(h, [function(w, N, M) {
    w === 2 && M.length && M[0].lastIndexOf(n) > 0 && (M[0] = M[0].replace(r, I));
  }, _, function(w) {
    if (w === -2) {
      var N = k;
      return k = [], N;
    }
  }])), C.hash = h.length ? h.reduce(function(w, N) {
    return N.name || ar(15), Mn(w, N.name);
  }, 5381).toString() : "", C;
}
var $s = Ve.createContext();
$s.Consumer;
var Bs = Ve.createContext(), rc = (Bs.Consumer, new Ds()), Ni = nc();
function ic() {
  return Gi($s) || rc;
}
function oc() {
  return Gi(Bs) || Ni;
}
var sc = function() {
  function e(t, n) {
    var r = this;
    this.inject = function(i, a) {
      a === void 0 && (a = Ni);
      var d = r.name + a.hash;
      i.hasNameForId(r.id, d) || i.insertRules(r.id, d, a(r.rules, d, "@keyframes"));
    }, this.toString = function() {
      return ar(12, String(r.name));
    }, this.name = t, this.id = "sc-keyframes-" + t, this.rules = n;
  }
  return e.prototype.getName = function(t) {
    return t === void 0 && (t = Ni), this.name + t.hash;
  }, e;
}(), ac = /([A-Z])/, lc = /([A-Z])/g, cc = /^ms-/, uc = function(e) {
  return "-" + e.toLowerCase();
};
function is(e) {
  return ac.test(e) ? e.replace(lc, uc).replace(cc, "-ms-") : e;
}
var os = function(e) {
  return e == null || e === !1 || e === "";
};
function Fn(e, t, n, r) {
  if (Array.isArray(e)) {
    for (var i, a = [], d = 0, p = e.length; d < p; d += 1) (i = Fn(e[d], t, n, r)) !== "" && (Array.isArray(i) ? a.push.apply(a, i) : a.push(i));
    return a;
  }
  if (os(e)) return "";
  if (Zi(e)) return "." + e.styledComponentId;
  if (or(e)) {
    if (typeof (h = e) != "function" || h.prototype && h.prototype.isReactComponent || !t) return e;
    var m = e(t);
    return Fn(m, t, n, r);
  }
  var h;
  return e instanceof sc ? n ? (e.inject(n, r), e.getName(r)) : e : Ai(e) ? function b(k, _) {
    var I, C, w = [];
    for (var N in k) k.hasOwnProperty(N) && !os(k[N]) && (Array.isArray(k[N]) && k[N].isCss || or(k[N]) ? w.push(is(N) + ":", k[N], ";") : Ai(k[N]) ? w.push.apply(w, b(k[N], N)) : w.push(is(N) + ": " + (I = N, (C = k[N]) == null || typeof C == "boolean" || C === "" ? "" : typeof C != "number" || C === 0 || I in Ol || I.startsWith("--") ? String(C).trim() : C + "px") + ";"));
    return _ ? [_ + " {"].concat(w, ["}"]) : w;
  }(e) : e.toString();
}
var ss = function(e) {
  return Array.isArray(e) && (e.isCss = !0), e;
};
function dc(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) n[r - 1] = arguments[r];
  return or(e) || Ai(e) ? ss(Fn(es(Br, [e].concat(n)))) : n.length === 0 && e.length === 1 && typeof e[0] == "string" ? e : ss(Fn(es(e, n)));
}
var fc = function(e, t, n) {
  return n === void 0 && (n = cn), e.theme !== n.theme && e.theme || t || n.theme;
}, pc = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, hc = /(^-|-$)/g;
function Ti(e) {
  return e.replace(pc, "-").replace(hc, "");
}
var mc = function(e) {
  return ji(Fs(e) >>> 0);
};
function Rr(e) {
  return typeof e == "string" && rt.env.NODE_ENV === "production";
}
var Ii = function(e) {
  return typeof e == "function" || typeof e == "object" && e !== null && !Array.isArray(e);
}, gc = function(e) {
  return e !== "__proto__" && e !== "constructor" && e !== "prototype";
};
function vc(e, t, n) {
  var r = e[n];
  Ii(t) && Ii(r) ? zs(r, t) : e[n] = t;
}
function zs(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) n[r - 1] = arguments[r];
  for (var i = 0, a = n; i < a.length; i++) {
    var d = a[i];
    if (Ii(d)) for (var p in d) gc(p) && vc(e, d[p], p);
  }
  return e;
}
var Hs = Ve.createContext();
Hs.Consumer;
var _i = {};
function Vs(e, t, n) {
  var r = Zi(e), i = !Rr(e), a = t.attrs, d = a === void 0 ? Br : a, p = t.componentId, m = p === void 0 ? function(D, V) {
    var W = typeof D != "string" ? "sc" : Ti(D);
    _i[W] = (_i[W] || 0) + 1;
    var A = W + "-" + mc("5.3.11" + W + _i[W]);
    return V ? V + "-" + A : A;
  }(t.displayName, t.parentComponentId) : p, h = t.displayName, b = h === void 0 ? function(D) {
    return Rr(D) ? "styled." + D : "Styled(" + ts(D) + ")";
  }(e) : h, k = t.displayName && t.componentId ? Ti(t.displayName) + "-" + t.componentId : t.componentId || m, _ = r && e.attrs ? Array.prototype.concat(e.attrs, d).filter(Boolean) : d, I = t.shouldForwardProp;
  r && e.shouldForwardProp && (I = t.shouldForwardProp ? function(D, V, W) {
    return e.shouldForwardProp(D, V, W) && t.shouldForwardProp(D, V, W);
  } : e.shouldForwardProp);
  var C, w = new Ql(n, k, r ? e.componentStyle : void 0), N = w.isStatic && d.length === 0, M = function(D, V) {
    return function(W, A, X, re) {
      var Me = W.attrs, Ne = W.componentStyle, De = W.defaultProps, ve = W.foldedComponentIds, fe = W.shouldForwardProp, Z = W.styledComponentId, ue = W.target, Ae = function(q, j, de) {
        q === void 0 && (q = cn);
        var $ = Xt({}, j, { theme: q }), ge = {};
        return de.forEach(function(oe) {
          var se, Q, ae, Se = oe;
          for (se in or(Se) && (Se = Se($)), Se) $[se] = ge[se] = se === "className" ? (Q = ge[se], ae = Se[se], Q && ae ? Q + " " + ae : Q || ae) : Se[se];
        }), [$, ge];
      }(fc(A, Gi(Hs), De) || cn, A, Me), dt = Ae[0], ze = Ae[1], He = function(q, j, de, $) {
        var ge = ic(), oe = oc(), se = j ? q.generateAndInjectStyles(cn, ge, oe) : q.generateAndInjectStyles(de, ge, oe);
        return se;
      }(Ne, re, dt), Ue = X, ft = ze.$as || A.$as || ze.as || A.as || ue, be = Rr(ft), G = ze !== A ? Xt({}, A, {}, ze) : A, z = {};
      for (var U in G) U[0] !== "$" && U !== "as" && (U === "forwardedAs" ? z.as = G[U] : (fe ? fe(U, Ko, ft) : !be || Ko(U)) && (z[U] = G[U]));
      return A.style && ze.style !== A.style && (z.style = Xt({}, A.style, {}, ze.style)), z.className = Array.prototype.concat(ve, Z, He !== Z ? He : null, A.className, ze.className).filter(Boolean).join(" "), z.ref = Ue, La(ft, z);
    }(C, D, V, N);
  };
  return M.displayName = b, (C = Ve.forwardRef(M)).attrs = _, C.componentStyle = w, C.displayName = b, C.shouldForwardProp = I, C.foldedComponentIds = r ? Array.prototype.concat(e.foldedComponentIds, e.styledComponentId) : Br, C.styledComponentId = k, C.target = r ? e.target : e, C.withComponent = function(D) {
    var V = t.componentId, W = function(X, re) {
      if (X == null) return {};
      var Me, Ne, De = {}, ve = Object.keys(X);
      for (Ne = 0; Ne < ve.length; Ne++) Me = ve[Ne], re.indexOf(Me) >= 0 || (De[Me] = X[Me]);
      return De;
    }(t, ["componentId"]), A = V && V + "-" + (Rr(D) ? D : Ti(ts(D)));
    return Vs(D, Xt({}, W, { attrs: _, componentId: A }), n);
  }, Object.defineProperty(C, "defaultProps", { get: function() {
    return this._foldedDefaultProps;
  }, set: function(D) {
    this._foldedDefaultProps = r ? zs({}, e.defaultProps, D) : D;
  } }), Object.defineProperty(C, "toString", { value: function() {
    return "." + C.styledComponentId;
  } }), i && Ml(C, e, { attrs: !0, componentStyle: !0, displayName: !0, foldedComponentIds: !0, shouldForwardProp: !0, styledComponentId: !0, target: !0, withComponent: !0 }), C;
}
var Pt = function(e) {
  return function t(n, r, i) {
    if (i === void 0 && (i = cn), !Ls.isValidElementType(r)) return ar(1, String(r));
    var a = function() {
      return n(r, i, dc.apply(void 0, arguments));
    };
    return a.withConfig = function(d) {
      return t(n, r, Xt({}, i, {}, d));
    }, a.attrs = function(d) {
      return t(n, r, Xt({}, i, { attrs: Array.prototype.concat(i.attrs, d).filter(Boolean) }));
    }, a;
  }(Vs, e);
};
["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "marquee", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "u", "ul", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "foreignObject", "g", "image", "line", "linearGradient", "marker", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "text", "textPath", "tspan"].forEach(function(e) {
  Pt[e] = Pt(e);
});
const yc = Pt.div`
  &.sticky {
    position: fixed;
    top: var(--uds-anchor-menu-top, 0px);
    left: 0;
    width: 100%;
  }
  .mobile-menu-toggler {
    background-color: transparent;
    border: none;
    cursor: default;
    h4,
    h2 {
      align-items: center;
    }
    i {
      transition: all 0.3s;
    }
  }
  .show-menu i {
    transform: rotate(-180deg);
  }
  .nav-link {
    border: none;
    background-color: #ffffff;
    i {
      width: 2rem !important;
      text-align: center !important;
    }
  }
`, Lr = "On This Page", xc = {
  event: "collapse",
  name: "onclick",
  type: "click",
  text: Lr
}, Ws = ({
  items: e,
  firstElementId: t,
  focusFirstFocusableElement: n = !1
}) => {
  const { isReact: r, isBootstrap: i } = Rn(), a = En(null), d = Ya("(max-width: 991px)"), [p, m] = tt({
    hasHeader: !1,
    hasAltMenuSpacing: !1,
    containerClass: "container-xl",
    activeContainer: "",
    showMenu: !1,
    sticky: !1
  }), h = () => document.getElementById("asu-header") || document.getElementById("headerContainer") || document.getElementById("asuHeader"), b = () => {
    const A = h();
    return Math.max((A == null ? void 0 : A.getBoundingClientRect().bottom) || 0, 0);
  }, k = () => {
    var ve;
    const A = {}, X = window.scrollY, re = b(), Me = (ve = document.getElementById(t)) == null ? void 0 : ve.getBoundingClientRect().top, Ne = 103;
    Me >= 0 && (A.sticky = !1, A.activeContainer = ""), X > a.current.getBoundingClientRect().top && (A.sticky = !0);
    const De = p.hasHeader ? re + Ne : Ne;
    e == null || e.forEach(({ targetIdName: fe }) => {
      const Z = document.getElementById(fe), ue = (Z == null ? void 0 : Z.getBoundingClientRect().top) - De, Ae = (Z == null ? void 0 : Z.getBoundingClientRect().bottom) - De;
      ue < 0 && Ae > 0 && (A.activeContainer = fe);
    }), m((fe) => ({
      ...fe,
      ...A
    }));
  }, _ = () => {
    Ri(k, 150), Oi(k, 150);
  }, I = () => !!h(), C = () => !!document.getElementById(
    "degreeDetailPageContainer"
  );
  function w(A = null) {
    if (A === null) return p.containerClass;
    const X = Object.values(A.classList).filter(
      (re) => [
        "container-sm",
        "container-md",
        "container",
        "container-lg",
        "container-xl",
        "container-fluid"
      ].includes(re)
    );
    return X.length > 0 ? X.join(" ") : w(A.parentElement);
  }
  at(() => {
    const A = document.getElementById(t) || null, X = {
      hasHeader: I(),
      hasAltMenuSpacing: C(),
      containerClass: w(A)
    };
    m((re) => ({
      ...re,
      ...X
    }));
  }, []), at(() => (window == null || window.addEventListener("scroll", _), () => window.removeEventListener("scroll", _)), [p.hasHeader]);
  const N = (A) => {
    var De, ve;
    const X = b(), re = window.scrollY - (p.hasHeader ? X + 100 : 100), Me = d ? 410 : 90;
    let Ne = ((De = document.getElementById(A)) == null ? void 0 : De.getBoundingClientRect().top) + re;
    a.current.classList.contains("sticky") || (Ne -= Me), n && ((ve = gl(`#${A}`)) == null || ve.focus()), window.scrollTo({ top: Ne, behavior: "smooth" });
  }, M = () => {
    m((A) => ({
      ...A,
      showMenu: !A.showMenu
    }));
  }, D = p.hasHeader ? b() : 0, V = i ? "div" : yc, W = i ? {} : {
    // @ts-ignore
    requiresAltMenuSpacing: p.hasAltMenuSpacing
  };
  return (e == null ? void 0 : e.length) > 0 && /* @__PURE__ */ f.jsx(
    V,
    {
      ...W,
      ref: a,
      id: "uds-anchor-menu",
      className: xe(
        "uds-anchor-menu",
        "uds-anchor-menu-expanded-lg",
        "mb-4",
        {
          sticky: p.sticky,
          "with-header": p.hasHeader
        }
      ),
      style: {
        ...p.showMenu ? { borderBottom: 0 } : {},
        "--uds-anchor-menu-top": `${D}px`
      },
      children: /* @__PURE__ */ f.jsxs("div", { className: `${p.containerClass} uds-anchor-menu-wrapper`, children: [
        d ? /* @__PURE__ */ f.jsx(
          Ye,
          {
            gaData: {
              ...xc,
              action: p.showMenu ? "close" : "open"
            },
            children: /* @__PURE__ */ f.jsx(
              "button",
              {
                className: xe("mobile-menu-toggler", {
                  "show-menu": p.showMenu
                }),
                type: "button",
                onClick: M,
                "data-bs-toggle": "collapse",
                "data-bs-target": "#collapseAnchorMenu",
                "aria-controls": "collapseAnchorMenu",
                children: /* @__PURE__ */ f.jsxs("h2", { children: [
                  Lr,
                  ":",
                  /* @__PURE__ */ f.jsx("i", { className: "fas fa-chevron-down" })
                ] })
              }
            )
          }
        ) : /* @__PURE__ */ f.jsxs("h2", { children: [
          Lr,
          ":"
        ] }),
        /* @__PURE__ */ f.jsx(
          "div",
          {
            "data-testid": "anchor-menu-container",
            id: "collapseAnchorMenu",
            className: xe("card", "card-body", "collapse", {
              show: p.showMenu
            }),
            children: /* @__PURE__ */ f.jsx(
              "nav",
              {
                "data-testid": "anchor-menu",
                className: "nav",
                "aria-label": Lr,
                children: e == null ? void 0 : e.map((A) => (
                  // Use this package button
                  // @ts-ignore
                  /* @__PURE__ */ f.jsx(
                    ln,
                    {
                      "data-testid": `anchor-item-${A.targetIdName}`,
                      classes: xe("nav-link", {
                        active: p.activeContainer === A.targetIdName
                      }).split(" "),
                      ariaLabel: A.text,
                      label: A.text,
                      icon: A.icon,
                      onClick: r && (() => N(A.targetIdName)),
                      href: i && `#${A.targetIdName}`
                    },
                    A.targetIdName
                  )
                ))
              }
            )
          }
        )
      ] })
    }
  );
};
Ws.propTypes = {
  /**
   * Anchor menu items
   */
  items: l.arrayOf(
    l.shape({
      text: l.string.isRequired,
      targetIdName: l.string.isRequired,
      icon: l.arrayOf(l.string)
    })
  ).isRequired,
  /**
   * First next sibling element of the anchor menu
   */
  firstElementId: l.string.isRequired,
  /**
   * If true it focus the first focusable element into the section
   * If false it focus the next menu item into the nav bar
   */
  focusFirstFocusableElement: l.bool
};
var Pi = function() {
  return Pi = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, Pi.apply(this, arguments);
}, bc = function(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
function Ur(e) {
  var t = function(n) {
    var r = n.bgStyle, i = n.borderRadius, a = n.iconFillColor, d = n.round, p = n.size, m = bc(n, ["bgStyle", "borderRadius", "iconFillColor", "round", "size"]);
    return Ve.createElement(
      "svg",
      Pi({ viewBox: "0 0 64 64", width: p, height: p }, m),
      d ? Ve.createElement("circle", { cx: "32", cy: "32", r: "31", fill: e.color, style: r }) : Ve.createElement("rect", { width: "64", height: "64", rx: i, ry: i, fill: e.color, style: r }),
      Ve.createElement("path", { d: e.path, fill: a })
    );
  };
  return t.defaultProps = {
    bgStyle: {},
    borderRadius: 0,
    iconFillColor: "white",
    size: 64
  }, t;
}
var wc = Ur({
  color: "#7f7f7f",
  path: "M17,22v20h30V22H17z M41.1,25L32,32.1L22.9,25H41.1z M20,39V26.6l12,9.3l12-9.3V39H20z"
});
function Yr(e) {
  var t = Object.entries(e).filter(function(n) {
    var r = n[1];
    return r != null;
  }).map(function(n) {
    var r = n[0], i = n[1];
    return "".concat(encodeURIComponent(r), "=").concat(encodeURIComponent(String(i)));
  });
  return t.length > 0 ? "?".concat(t.join("&")) : "";
}
var Sc = /* @__PURE__ */ function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var a in i) Object.prototype.hasOwnProperty.call(i, a) && (r[a] = i[a]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), Yt = function() {
  return Yt = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, Yt.apply(this, arguments);
}, kc = function(e, t, n, r) {
  function i(a) {
    return a instanceof n ? a : new n(function(d) {
      d(a);
    });
  }
  return new (n || (n = Promise))(function(a, d) {
    function p(b) {
      try {
        h(r.next(b));
      } catch (k) {
        d(k);
      }
    }
    function m(b) {
      try {
        h(r.throw(b));
      } catch (k) {
        d(k);
      }
    }
    function h(b) {
      b.done ? a(b.value) : i(b.value).then(p, m);
    }
    h((r = r.apply(e, t || [])).next());
  });
}, Tc = function(e, t) {
  var n = { label: 0, sent: function() {
    if (a[0] & 1) throw a[1];
    return a[1];
  }, trys: [], ops: [] }, r, i, a, d;
  return d = { next: p(0), throw: p(1), return: p(2) }, typeof Symbol == "function" && (d[Symbol.iterator] = function() {
    return this;
  }), d;
  function p(h) {
    return function(b) {
      return m([h, b]);
    };
  }
  function m(h) {
    if (r) throw new TypeError("Generator is already executing.");
    for (; n; ) try {
      if (r = 1, i && (a = h[0] & 2 ? i.return : h[0] ? i.throw || ((a = i.return) && a.call(i), 0) : i.next) && !(a = a.call(i, h[1])).done) return a;
      switch (i = 0, a && (h = [h[0] & 2, a.value]), h[0]) {
        case 0:
        case 1:
          a = h;
          break;
        case 4:
          return n.label++, { value: h[1], done: !1 };
        case 5:
          n.label++, i = h[1], h = [0];
          continue;
        case 7:
          h = n.ops.pop(), n.trys.pop();
          continue;
        default:
          if (a = n.trys, !(a = a.length > 0 && a[a.length - 1]) && (h[0] === 6 || h[0] === 2)) {
            n = 0;
            continue;
          }
          if (h[0] === 3 && (!a || h[1] > a[0] && h[1] < a[3])) {
            n.label = h[1];
            break;
          }
          if (h[0] === 6 && n.label < a[1]) {
            n.label = a[1], a = h;
            break;
          }
          if (a && n.label < a[2]) {
            n.label = a[2], n.ops.push(h);
            break;
          }
          a[2] && n.ops.pop(), n.trys.pop();
          continue;
      }
      h = t.call(e, n);
    } catch (b) {
      h = [6, b], i = 0;
    } finally {
      r = a = 0;
    }
    if (h[0] & 5) throw h[1];
    return { value: h[0] ? h[1] : void 0, done: !0 };
  }
}, qs = function(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
}, _c = function(e) {
  return !!e && (typeof e == "object" || typeof e == "function") && typeof e.then == "function";
}, Ec = function(e, t) {
  return {
    left: window.outerWidth / 2 + (window.screenX || window.screenLeft || 0) - e / 2,
    top: window.outerHeight / 2 + (window.screenY || window.screenTop || 0) - t / 2
  };
}, Cc = function(e, t) {
  return {
    top: (window.screen.height - t) / 2,
    left: (window.screen.width - e) / 2
  };
};
function Rc(e, t, n) {
  var r = t.height, i = t.width, a = qs(t, ["height", "width"]), d = Yt({ height: r, width: i, location: "no", toolbar: "no", status: "no", directories: "no", menubar: "no", scrollbars: "yes", resizable: "no", centerscreen: "yes", chrome: "yes" }, a), p = window.open(e, "", Object.keys(d).map(function(h) {
    return "".concat(h, "=").concat(d[h]);
  }).join(", "));
  if (n)
    var m = window.setInterval(function() {
      try {
        (p === null || p.closed) && (window.clearInterval(m), n(p));
      } catch (h) {
        console.error(h);
      }
    }, 1e3);
  return p;
}
var Oc = (
  /** @class */
  function(e) {
    Sc(t, e);
    function t() {
      var n = e !== null && e.apply(this, arguments) || this;
      return n.openShareDialog = function(r) {
        var i = n.props, a = i.onShareWindowClose, d = i.windowHeight, p = d === void 0 ? 400 : d, m = i.windowPosition, h = m === void 0 ? "windowCenter" : m, b = i.windowWidth, k = b === void 0 ? 550 : b, _ = Yt({ height: p, width: k }, h === "windowCenter" ? Ec(k, p) : Cc(k, p));
        Rc(r, _, a);
      }, n.handleClick = function(r) {
        return kc(n, void 0, void 0, function() {
          var i, a, d, p, m, h, b, k, _, I;
          return Tc(this, function(C) {
            switch (C.label) {
              case 0:
                return i = this.props, a = i.beforeOnClick, d = i.disabled, p = i.networkLink, m = i.onClick, h = i.url, b = i.openShareDialogOnClick, k = i.opts, _ = p(h, k), d ? [
                  2
                  /*return*/
                ] : (r.preventDefault(), a ? (I = a(), _c(I) ? [4, I] : [3, 2]) : [3, 2]);
              case 1:
                C.sent(), C.label = 2;
              case 2:
                return b && this.openShareDialog(_), m && m(r, _), [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, n;
    }
    return t.prototype.render = function() {
      var n = this.props;
      n.beforeOnClick;
      var r = n.children, i = n.className, a = n.disabled, d = n.disabledStyle, p = n.forwardedRef;
      n.networkLink;
      var m = n.networkName;
      n.onShareWindowClose, n.openShareDialogOnClick, n.opts;
      var h = n.resetButtonStyle, b = n.style;
      n.url, n.windowHeight, n.windowPosition, n.windowWidth;
      var k = qs(n, ["beforeOnClick", "children", "className", "disabled", "disabledStyle", "forwardedRef", "networkLink", "networkName", "onShareWindowClose", "openShareDialogOnClick", "opts", "resetButtonStyle", "style", "url", "windowHeight", "windowPosition", "windowWidth"]), _ = xe("react-share__ShareButton", {
        "react-share__ShareButton--disabled": !!a,
        disabled: !!a
      }, i), I = Yt(Yt(h ? { backgroundColor: "transparent", border: "none", padding: 0, font: "inherit", color: "inherit", cursor: "pointer" } : {}, b), a && d);
      return Ve.createElement("button", Yt({}, k, { "aria-label": k["aria-label"] || m, className: _, onClick: this.handleClick, ref: p, style: I }), r);
    }, t.defaultProps = {
      disabledStyle: { opacity: 0.6 },
      openShareDialogOnClick: !0,
      resetButtonStyle: !0
    }, t;
  }(Ma)
), Hr = function() {
  return Hr = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, Hr.apply(this, arguments);
};
function Gr(e, t, n, r) {
  function i(a, d) {
    var p = n(a), m = Hr({}, a), h = Object.keys(p);
    return h.forEach(function(b) {
      delete m[b];
    }), Ve.createElement(Oc, Hr({}, r, m, { forwardedRef: d, networkName: e, networkLink: t, opts: n(a) }));
  }
  return i.displayName = "ShareButton-".concat(e), Yi(i);
}
function Ac(e, t) {
  var n = t.subject, r = t.body, i = t.separator;
  return "mailto:" + Yr({ subject: n, body: r ? r + i + e : e });
}
var jc = Gr("email", Ac, function(e) {
  return {
    subject: e.subject,
    body: e.body,
    separator: e.separator || " "
  };
}, {
  openShareDialogOnClick: !1,
  onClick: function(e, t) {
    window.location.href = t;
  }
}), as = Ur({
  color: "#3b5998",
  path: "M34.1,47V33.3h4.6l0.7-5.3h-5.3v-3.4c0-1.5,0.4-2.6,2.6-2.6l2.8,0v-4.8c-0.5-0.1-2.2-0.2-4.1-0.2 c-4.1,0-6.9,2.5-6.9,7V28H24v5.3h4.6V47H34.1z"
}), Nc = /* @__PURE__ */ function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var a in i) Object.prototype.hasOwnProperty.call(i, a) && (r[a] = i[a]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), Ic = (
  /** @class */
  function(e) {
    Nc(t, e);
    function t(n) {
      var r = e.call(this, n) || this;
      return r.name = "AssertionError", r;
    }
    return t;
  }(Error)
);
function ir(e, t) {
  if (!e)
    throw new Ic(t);
}
function Pc(e, t) {
  var n = t.quote, r = t.hashtag;
  return ir(e, "facebook.url"), "https://www.facebook.com/sharer/sharer.php" + Yr({
    u: e,
    quote: n,
    hashtag: r
  });
}
var ls = Gr("facebook", Pc, function(e) {
  return {
    quote: e.quote,
    hashtag: e.hashtag
  };
}, {
  windowWidth: 550,
  windowHeight: 400
}), cs = Ur({
  color: "#007fb1",
  path: "M20.4,44h5.4V26.6h-5.4V44z M23.1,18c-1.7,0-3.1,1.4-3.1,3.1c0,1.7,1.4,3.1,3.1,3.1 c1.7,0,3.1-1.4,3.1-3.1C26.2,19.4,24.8,18,23.1,18z M39.5,26.2c-2.6,0-4.4,1.4-5.1,2.8h-0.1v-2.4h-5.2V44h5.4v-8.6 c0-2.3,0.4-4.5,3.2-4.5c2.8,0,2.8,2.6,2.8,4.6V44H46v-9.5C46,29.8,45,26.2,39.5,26.2z"
});
function Lc(e, t) {
  var n = t.title, r = t.summary, i = t.source;
  return ir(e, "linkedin.url"), "https://linkedin.com/shareArticle" + Yr({ url: e, mini: "true", title: n, summary: r, source: i });
}
var us = Gr("linkedin", Lc, function(e) {
  var t = e.title, n = e.summary, r = e.source;
  return { title: t, summary: n, source: r };
}, {
  windowWidth: 750,
  windowHeight: 600
}), ds = Ur({
  color: "#00aced",
  path: "M48,22.1c-1.2,0.5-2.4,0.9-3.8,1c1.4-0.8,2.4-2.1,2.9-3.6c-1.3,0.8-2.7,1.3-4.2,1.6 C41.7,19.8,40,19,38.2,19c-3.6,0-6.6,2.9-6.6,6.6c0,0.5,0.1,1,0.2,1.5c-5.5-0.3-10.3-2.9-13.5-6.9c-0.6,1-0.9,2.1-0.9,3.3 c0,2.3,1.2,4.3,2.9,5.5c-1.1,0-2.1-0.3-3-0.8c0,0,0,0.1,0,0.1c0,3.2,2.3,5.8,5.3,6.4c-0.6,0.1-1.1,0.2-1.7,0.2c-0.4,0-0.8,0-1.2-0.1 c0.8,2.6,3.3,4.5,6.1,4.6c-2.2,1.8-5.1,2.8-8.2,2.8c-0.5,0-1.1,0-1.6-0.1c2.9,1.9,6.4,2.9,10.1,2.9c12.1,0,18.7-10,18.7-18.7 c0-0.3,0-0.6,0-0.8C46,24.5,47.1,23.4,48,22.1z"
});
function Mc(e, t) {
  var n = t.title, r = t.via, i = t.hashtags, a = i === void 0 ? [] : i, d = t.related, p = d === void 0 ? [] : d;
  return ir(e, "twitter.url"), ir(Array.isArray(a), "twitter.hashtags is not an array"), ir(Array.isArray(p), "twitter.related is not an array"), "https://twitter.com/share" + Yr({
    url: e,
    text: n,
    via: r,
    hashtags: a.length > 0 ? a.join(",") : void 0,
    related: p.length > 0 ? p.join(",") : void 0
  });
}
var fs = Gr("twitter", Mc, function(e) {
  return {
    hashtags: e.hashtags,
    title: e.title,
    via: e.via,
    related: e.related
  };
}, {
  windowWidth: 550,
  windowHeight: 400
});
function Li(e) {
  "@babel/helpers - typeof";
  return Li = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Li(e);
}
var Dc;
function Mi() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Dc;
  return t ? e.split(" ").map(function(n) {
    return t[n] || n;
  }).join(" ") : e;
}
var Fc = (typeof window > "u" ? "undefined" : Li(window)) === "object" && window.Element || function() {
};
function $c(e, t, n) {
  if (!(e[t] instanceof Fc))
    return new Error("Invalid prop `" + t + "` supplied to `" + n + "`. Expected prop to be an instance of Element. Validation failed.");
}
l.oneOfType([l.string, l.func, $c, l.shape({
  current: l.any
})]);
var Di = l.oneOfType([l.func, l.string, l.shape({
  $$typeof: l.symbol,
  render: l.func
}), l.arrayOf(l.oneOfType([l.func, l.string, l.shape({
  $$typeof: l.symbol,
  render: l.func
})]))]), Bc = ["className", "listClassName", "cssModule", "children", "tag", "listTag", "aria-label"];
function Fi() {
  return Fi = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Fi.apply(this, arguments);
}
function zc(e, t) {
  if (e == null) return {};
  var n = Hc(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      r = a[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function Hc(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), i, a;
  for (a = 0; a < r.length; a++)
    i = r[a], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
var Vc = {
  /** Aria label */
  "aria-label": l.string,
  /** Pass children so this component can wrap them */
  children: l.node,
  /** Add custom class */
  className: l.string,
  /** Change existing className with a new className */
  cssModule: l.object,
  /** Add custom class to list tag */
  listClassName: l.string,
  /** Set a custom element for list tag */
  listTag: Di,
  /** Set a custom element for this component */
  tag: Di
};
function Us(e) {
  var t = e.className, n = e.listClassName, r = e.cssModule, i = e.children, a = e.tag, d = a === void 0 ? "nav" : a, p = e.listTag, m = p === void 0 ? "ol" : p, h = e["aria-label"], b = h === void 0 ? "breadcrumb" : h, k = zc(e, Bc), _ = Mi(xe(t), r), I = Mi(xe("breadcrumb", n), r);
  return /* @__PURE__ */ Ve.createElement(d, Fi({}, k, {
    className: _,
    "aria-label": b
  }), /* @__PURE__ */ Ve.createElement(m, {
    className: I
  }, i));
}
Us.propTypes = Vc;
var Wc = ["className", "cssModule", "active", "tag"];
function $i() {
  return $i = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, $i.apply(this, arguments);
}
function qc(e, t) {
  if (e == null) return {};
  var n = Uc(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      r = a[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function Uc(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), i, a;
  for (a = 0; a < r.length; a++)
    i = r[a], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
var Yc = {
  /** Adds a visual "active" state to a Breadcrumb Item */
  active: l.bool,
  /** Add custom class to the element */
  className: l.string,
  /** Change existing className with a new className */
  cssModule: l.object,
  /** Set a custom element for this component */
  tag: Di
};
function Bi(e) {
  var t = e.className, n = e.cssModule, r = e.active, i = e.tag, a = i === void 0 ? "li" : i, d = qc(e, Wc), p = Mi(xe(t, r ? "active" : !1, "breadcrumb-item"), n);
  return /* @__PURE__ */ Ve.createElement(a, $i({}, d, {
    className: p,
    "aria-current": r ? "page" : void 0
  }));
}
Bi.propTypes = Yc;
const Gc = Pt.div`
  &.news-container h2 {
    font-size: 48px;
  }

  &.event-container h2 {
    font-size: 40px;
  }

  &.news-container img,
  &.event-container img {
    width: 100%;
    max-width: fit-content;
  }

  &.wrapper-container h4 {
    margin-top: 0;
  }

  &.wrapper-container {
    max-width: 1300px;
    margin: 0 auto;
    padding: 0 10%;
  }

  &.event-container.wrapper-container {
    max-width: 1500px;
  }

  &.news-container {
    background: #fff;
  }

  ol.breadcrumb {
    padding: 0;
    margin: 0;
  }

  ol.breadcrumb > li {
    margin-bottom: 0;
  }

  .article-social-media {
    margin-bottom: 24px;
  }

  .react-share__ShareButton {
    margin-right: 12px;
  }

  i.news-date {
    display: inline-block;
    margin-bottom: 24px;
  }

  .highlight-gold {
    box-shadow:
      -0.15em 0 0 #ffc627,
      0.15em 0 0 #ffc627;
    background: #ffc627;
  }

  .author {
    display: inline-block;
    margin-top: 30px;
    margin-left: -7px;
    padding: 0 6px;
    font-size: 16px;
    font-weight: 600;
    line-height: 16px;
  }

  .icon-bg {
    display: inline-block;
    position: relative;
    padding: 1px 3.5px;
    background-color: maroon;
    margin-right: 4px;
    border-radius: 4px;
    color: white;
    font-size: 0.65rem;
  }

  .uds-button {
    margin-top: 17px;
    padding: 0;
  }

  .author-title {
    max-width: 250px;
    margin-top: 10px;
    margin-bottom: 11px;
    font-size: 16px;
  }

  .author-contact {
    margin-top: 4px;
    font-size: 14px;
    font-weight: 500;
  }

  ol.breadcrumb a {
    text-decoration: none;
  }

  i.fa-calendar,
  i.fa-map-marker-alt {
    font-size: 1.17rem;
    margin-right: 8px;
  }

  .event-author {
    font-size: 16px;
    font-weight: 600;
    line-height: 16px;
  }

  .event-author-title {
    margin-top: 4px;
  }

  .event-author-info {
    margin-top: 24px;
  }
`, Xc = Pt.div`
  border-top: 1px solid black;
  h4 {
    margin-top: 0;
  }
  .react-share__ShareButton {
    margin-right: 24px;
  }
`, Ys = ({
  type: e = "news",
  articleUrl: t,
  publicationDate: n,
  title: r,
  body: i,
  authorEmail: a,
  authorName: d,
  authorPhone: p,
  authorTitle: m,
  breadcrumbs: h,
  calendarUrl: b,
  eventLocation: k,
  eventTime: _,
  headerImageUrl: I,
  registrationUrl: C,
  zoomUrl: w
}) => {
  const N = xe("col", "col-12", {
    "col-lg-8": e === "event" && (C || w || b)
  }), M = () => C ? /* @__PURE__ */ f.jsx("div", { className: "card-button uds-button", children: /* @__PURE__ */ f.jsx(ln, { color: "maroon", href: C, label: "Register" }) }) : /* @__PURE__ */ f.jsx("div", { className: "card-button uds-button", children: /* @__PURE__ */ f.jsx(ln, { color: "maroon", href: w, label: "Attend on Zoom" }) }), D = () => /* @__PURE__ */ f.jsx("div", { className: "row pb-2", "data-testid": "author-info", children: /* @__PURE__ */ f.jsxs("div", { className: "col col-12", children: [
    /* @__PURE__ */ f.jsx("div", { className: "author highlight-gold", children: d }),
    m && /* @__PURE__ */ f.jsx("div", { className: "author-title", children: m }),
    a && /* @__PURE__ */ f.jsxs("div", { className: "author-contact", children: [
      /* @__PURE__ */ f.jsx("span", { className: "icon-bg", children: /* @__PURE__ */ f.jsx("i", { className: "fas fa-envelope" }) }),
      /* @__PURE__ */ f.jsx("a", { href: `mailto: ${a}`, children: a })
    ] }),
    p && /* @__PURE__ */ f.jsxs("div", { className: "author-contact", children: [
      /* @__PURE__ */ f.jsx("span", { className: "icon-bg", children: /* @__PURE__ */ f.jsx("i", { className: "fas fa-phone" }) }),
      /* @__PURE__ */ f.jsx("a", { href: `tel: ${p}`, children: p })
    ] })
  ] }) }), V = () => /* @__PURE__ */ f.jsxs(
    Xc,
    {
      className: "row row-spaced mt-3 pt-6 pb-2 event-info",
      "data-testid": "event-info",
      children: [
        /* @__PURE__ */ f.jsxs("div", { className: "col col-lg-4 col-md-6 col-12", children: [
          /* @__PURE__ */ f.jsx("h4", { children: "For more information contact:" }),
          /* @__PURE__ */ f.jsx("div", { className: "event-author", children: d }),
          /* @__PURE__ */ f.jsx("div", { className: "event-author-title", children: m }),
          (a || p) && /* @__PURE__ */ f.jsxs("div", { className: "event-author-info", children: [
            a && /* @__PURE__ */ f.jsx("div", { children: /* @__PURE__ */ f.jsx("a", { href: `mailto: ${a}`, children: a }) }),
            p && /* @__PURE__ */ f.jsx("div", { children: /* @__PURE__ */ f.jsx("a", { href: `tel: ${p}`, children: p }) })
          ] })
        ] }),
        /* @__PURE__ */ f.jsxs("div", { className: "col col-lg-4 col-md-6 col-12", children: [
          /* @__PURE__ */ f.jsx("h4", { children: "Share this event:" }),
          /* @__PURE__ */ f.jsxs("div", { className: "article-social-media", children: [
            /* @__PURE__ */ f.jsx(ls, { url: t, quote: r, children: /* @__PURE__ */ f.jsx(
              as,
              {
                size: 28,
                borderRadius: 4,
                bgStyle: { fill: "maroon" }
              }
            ) }),
            /* @__PURE__ */ f.jsx(fs, { url: t, quote: r, children: /* @__PURE__ */ f.jsx(
              ds,
              {
                size: 28,
                borderRadius: 4,
                bgStyle: { fill: "maroon" }
              }
            ) }),
            /* @__PURE__ */ f.jsx(jc, { url: a, quote: r, children: /* @__PURE__ */ f.jsx(
              wc,
              {
                size: 28,
                borderRadius: 4,
                bgStyle: { fill: "maroon" }
              }
            ) }),
            /* @__PURE__ */ f.jsx(us, { url: t, quote: r, children: /* @__PURE__ */ f.jsx(
              cs,
              {
                size: 28,
                borderRadius: 4,
                bgStyle: { fill: "maroon" }
              }
            ) })
          ] })
        ] })
      ]
    }
  ), W = () => /* @__PURE__ */ f.jsxs("div", { className: "col col-12 col-lg-4 col-md-6", children: [
    /* @__PURE__ */ f.jsxs("h4", { children: [
      /* @__PURE__ */ f.jsx("i", { className: "fas fa-map-marker-alt" }),
      "Location:"
    ] }),
    /* @__PURE__ */ f.jsx("div", { dangerouslySetInnerHTML: lt(k) }),
    C && w && /* @__PURE__ */ f.jsx("a", { href: w, children: "Attend on Zoom" })
  ] }), A = (X) => /* @__PURE__ */ f.jsx(
    Bi,
    {
      active: X.active,
      tag: "li",
      className: "breadcrumb-item",
      children: /* @__PURE__ */ f.jsx(Bi, { tag: "a", href: X.url, children: X.title })
    },
    X.title
  );
  return /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    I && e !== "event" && /* @__PURE__ */ f.jsx(
      "div",
      {
        "data-testid": "uds-hero",
        className: "uds-hero uds-hero-md",
        style: {
          // @ts-ignore
          "--color1": "#19191900",
          "--color2": "#191919c9",
          // moved colors to variable because hex color in linear-gradient breaks react
          backgroundImage: `linear-gradient(180deg, var(--color1) 0%, var(--color2) 100%), url(${I})`
        }
      }
    ),
    /* @__PURE__ */ f.jsxs(Gc, { className: `container ${e}-container wrapper-container`, children: [
      h && /* @__PURE__ */ f.jsx("div", { className: "row pt-4", "data-testid": "breadcrumbs", children: /* @__PURE__ */ f.jsx("div", { className: "col col-12", children: /* @__PURE__ */ f.jsx(Us, { listClassName: "breadcrumb", children: h.map((X) => A(X)) }) }) }),
      /* @__PURE__ */ f.jsxs("div", { className: "row pb-2 pt-3", children: [
        /* @__PURE__ */ f.jsx("div", { className: N, children: /* @__PURE__ */ f.jsx("h2", { "data-testid": "title", children: r }) }),
        e === "event" && /* @__PURE__ */ f.jsxs("div", { className: "col col-lg-4 col-xs-12", children: [
          (C || w) && M(),
          b && /* @__PURE__ */ f.jsx("div", { className: "card-button uds-button", children: /* @__PURE__ */ f.jsx(
            ln,
            {
              color: "gray",
              size: "small",
              href: b,
              label: "Add to calendar"
            }
          ) })
        ] })
      ] }),
      e === "event" ? /* @__PURE__ */ f.jsxs("div", { className: "row row-spaced pt-3 mb-2", children: [
        _ && /* @__PURE__ */ f.jsxs("div", { className: "col col-lg-4 col-md-6 col-sm-12", children: [
          /* @__PURE__ */ f.jsxs("h4", { children: [
            /* @__PURE__ */ f.jsx("i", { className: "far fa-calendar" }),
            "Date and time:"
          ] }),
          /* @__PURE__ */ f.jsx(
            "div",
            {
              dangerouslySetInnerHTML: lt(_)
            }
          )
        ] }),
        (C && w || k) && W()
      ] }) : /* @__PURE__ */ f.jsx("div", { className: "row row-spaced pt-2", children: /* @__PURE__ */ f.jsxs("div", { className: "col col-12", children: [
        /* @__PURE__ */ f.jsxs("div", { className: "article-social-media", children: [
          /* @__PURE__ */ f.jsx(ls, { url: t, quote: r, children: /* @__PURE__ */ f.jsx(
            as,
            {
              size: 28,
              borderRadius: 4,
              bgStyle: { fill: "maroon" }
            }
          ) }),
          /* @__PURE__ */ f.jsx(fs, { url: t, quote: r, children: /* @__PURE__ */ f.jsx(
            ds,
            {
              size: 28,
              borderRadius: 4,
              bgStyle: { fill: "maroon" }
            }
          ) }),
          /* @__PURE__ */ f.jsx(us, { url: t, quote: r, children: /* @__PURE__ */ f.jsx(
            cs,
            {
              size: 28,
              borderRadius: 4,
              bgStyle: { fill: "maroon" }
            }
          ) })
        ] }),
        n && /* @__PURE__ */ f.jsx("i", { className: "news-date", children: n })
      ] }) }),
      /* @__PURE__ */ f.jsx("div", { className: "row", children: /* @__PURE__ */ f.jsx(
        "div",
        {
          className: "col col-12",
          dangerouslySetInnerHTML: lt(i),
          "data-testid": "body"
        }
      ) }),
      e === "news" && D(),
      e === "event" && V()
    ] })
  ] });
};
Ys.propTypes = {
  /**
   * Type of article
   */
  type: l.oneOf(["event", "news"]),
  /**
   * This is the relative or absolute url to the full-page article
   */
  articleUrl: l.string.isRequired,
  /**
   * Date for the article
   */
  publicationDate: l.string.isRequired,
  /**
   * Title
   */
  title: l.string.isRequired,
  /**
   * Body content for the article
   */
  body: l.string.isRequired,
  /**
   * Article author email
   */
  authorEmail: l.string,
  /**
   * Article author full name
   */
  authorName: l.string.isRequired,
  /**
   * Article author phone number
   */
  authorPhone: l.string,
  /**
   * Article author title
   */
  authorTitle: l.string,
  /**
   * Breadcrumbs array
   */
  breadcrumbs: l.arrayOf(
    l.shape({
      title: l.string,
      url: l.string,
      active: l.bool
    })
  ),
  /**
   * URL for an "add to calendar" button
   */
  calendarUrl: l.string,
  /**
   * Article image
   */
  headerImageUrl: l.string,
  /**
   * Event location
   */
  eventLocation: l.string,
  /**
   * Event time
   */
  eventTime: l.string,
  /**
   * URL for a registation button
   */
  registrationUrl: l.string,
  /**
   * URL for a Zoom button
   */
  zoomUrl: l.string
};
const Kc = {
  name: "onclick",
  event: "link",
  action: "click",
  type: "internal link",
  region: "main content"
}, Qi = ({
  color: e = "gray",
  icon: t = void 0,
  innerRef: n = void 0,
  onClick: r = void 0,
  size: i = "small",
  cardTitle: a = "",
  className: d,
  gaData: p,
  ...m
}) => {
  const h = () => {
    r == null || r();
  };
  return /* @__PURE__ */ f.jsx(
    Ye,
    {
      gaData: {
        ...Kc,
        section: a,
        // @deprecated - remove at some point
        ...p,
        text: `${t == null ? void 0 : t[1]} icon`
      },
      children: /* @__PURE__ */ f.jsx(
        "button",
        {
          type: "button",
          className: `btn btn-circle btn-circle-alt-${e} ${i === "large" && "btn-circle-large"} ${d}`,
          ref: n,
          "aria-label": "Close",
          onClick: h,
          ...m,
          children: /* @__PURE__ */ f.jsx("i", { className: `${t == null ? void 0 : t[0]} fa-${t == null ? void 0 : t[1]}` })
        }
      )
    }
  );
};
Qi.propTypes = {
  /**
    Color the button based on the background color
  */
  color: l.oneOf(["white", "gray", "black"]),
  /**
    React Font Awesome icon prefix and name string to be rendered in button label. Ex: ['fab', 'drupal']
  */
  icon: l.arrayOf(l.string),
  /**
   * ref will only get you a reference to the Button component, use innerRef to
   * get a reference to the DOM element (for things like focus management).
   */
  innerRef: l.oneOfType([
    l.object,
    l.func,
    l.string
  ]),
  /**
    Event handler function for `<button>`
  */
  onClick: l.func,
  /**
   * @deprecated
   * Card title, use `gaData.section` instead
   */
  cardTitle: l.string,
  /**
   * Google Analytics event data
   */
  gaData: Ki,
  /**
    Button size
  */
  size: l.oneOf(["large", "small"]),
  className: l.string
};
const Zc = {
  name: "onclick",
  event: "link",
  action: "click",
  type: "internal link",
  region: "main content"
}, eo = ({
  label: e = "",
  cardTitle: t = "",
  gaData: n,
  ariaLabel: r,
  color: i = "gray",
  disabled: a,
  element: d = "button",
  innerRef: p,
  href: m,
  onClick: h,
  ...b
}) => {
  const k = xe("btn", "btn-tag", {
    "btn-tag-alt-white": i === "white",
    "btn-tag-alt-gray": i === "gray",
    "btn-tag-alt-dark": i === "dark",
    disabled: a
  });
  let _ = d;
  return m && d === "button" && (_ = "a"), /* @__PURE__ */ f.jsx(
    Ye,
    {
      gaData: {
        ...Zc,
        section: t,
        // @deprecated - remove at some point
        ...n,
        text: e
      },
      children: /* @__PURE__ */ f.jsx(
        _,
        {
          type: _ === "button" && h ? "button" : void 0,
          ...b,
          className: k,
          href: m,
          ref: p,
          onClick: h,
          "aria-label": r,
          children: e
        }
      )
    }
  );
};
eo.propTypes = {
  /**
    Button tag label
  */
  label: l.string,
  /**
   * @deprecated
   * Card title, use `gaData.section` instead
   */
  cardTitle: l.string,
  /**
   * Google Analytics event data
   */
  gaData: Ki,
  /**
    ARIA label for accessibility
  */
  ariaLabel: l.string,
  /**
    Button background color
  */
  color: l.oneOf(["white", "gray", "dark"]),
  /**
    Disable the button?
  */
  disabled: l.bool,
  /**
    Pass in a Component to override default button element.
    For example: react-router Link
  */
  element: l.oneOfType([
    l.func,
    l.string,
    l.shape({ $$typeof: l.symbol, render: l.func }),
    l.arrayOf(
      l.oneOfType([
        l.func,
        l.string,
        l.shape({ $$typeof: l.symbol, render: l.func })
      ])
    )
  ]),
  /**
    Link target url; will cause button to be rendered as `<a>` link
  */
  href: l.string,
  /**
   * ref will only get you a reference to the Button component, use innerRef to
   * get a reference to the DOM element (for things like focus management).
   */
  innerRef: l.oneOfType([
    l.object,
    l.func,
    l.string
  ]),
  /**
    Event handler function for `<button>`
  */
  onClick: l.func
};
const Cn = ({
  src: e,
  alt: t,
  cssClasses: n,
  loading: r = "lazy",
  decoding: i = "async",
  dataTestId: a,
  fetchPriority: d = "auto",
  width: p,
  height: m,
  cardLink: h,
  title: b,
  caption: k,
  captionTitle: _,
  border: I,
  dropShadow: C
}) => {
  const w = {
    src: e,
    alt: t,
    loading: r,
    decoding: i,
    fetchpriority: d,
    // React attribute bug workaround
    ...(n == null ? void 0 : n.length) > 0 && { className: Nr(n) },
    ...a && { "data-testid": a },
    ...p && { width: p },
    ...m && { height: m }
  }, N = xe("uds-img", {
    borderless: !I,
    "uds-img-drop-shadow": C
  }), M = (V) => {
    const W = V ? `${w.className} ${V}` : w.className;
    return h ? /* @__PURE__ */ f.jsxs("a", { href: h, children: [
      /* @__PURE__ */ f.jsx("img", { ...w, className: W }),
      /* @__PURE__ */ f.jsx("span", { className: "visually-hidden", children: b })
    ] }) : /* @__PURE__ */ f.jsx("img", { ...w, className: W });
  }, D = () => /* @__PURE__ */ f.jsx("div", { className: N, children: /* @__PURE__ */ f.jsxs("figure", { className: "figure uds-figure", children: [
    M(),
    k && /* @__PURE__ */ f.jsxs("figcaption", { className: "figure-caption uds-figure-caption", children: [
      _ && /* @__PURE__ */ f.jsx("h3", { children: _ }),
      /* @__PURE__ */ f.jsx(
        "span",
        {
          className: "uds-caption-text",
          dangerouslySetInnerHTML: lt(k)
        }
      )
    ] })
  ] }) });
  return /* @__PURE__ */ f.jsx(f.Fragment, { children: k ? D() : M(N) });
};
Cn.propTypes = {
  /**
   * Image source (We keep the same name as in the whole project)
   */
  src: l.string.isRequired,
  /**
   * Image alt text
   */
  alt: l.string.isRequired,
  /**
   * Array classes for the image
   */
  cssClasses: l.arrayOf(l.string),
  /**
   * Image loading mode
   */
  loading: l.oneOf(["lazy", "eager"]),
  /**
   * Image decoding mode
   */
  decoding: l.oneOf(["sync", "async", "auto"]),
  /**
   * Image fetch priority mode
   */
  fetchPriority: l.oneOf(["auto", "high", "low"]),
  /**
   * Width of the image
   */
  width: l.string,
  /**
   * Height of the image
   */
  height: l.string,
  dataTestId: l.string,
  cardLink: l.string,
  title: l.string,
  caption: l.string,
  captionTitle: l.string,
  border: l.bool,
  dropShadow: l.bool
};
const Jc = Pt.div`
  &.cards-components a + &.cards-components a {
    margin-left: 5px;
  }
  .card-button {
    column-gap: 1rem;
  }
  .card-button .btn {
    margin: 0;
  }
`, Qc = (e) => /^[A-Z0-9._+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(e), eu = (e) => !e.startsWith("https://") && !e.startsWith("http://") && Qc(e) ? `mailto:${e}` : e, ps = {
  name: "onclick",
  event: "link",
  action: "click",
  type: "internal link",
  region: "main content"
}, Gs = (e) => e === "event" || e === "news", Gt = ({
  type: e = "default",
  width: t = "100%",
  horizontal: n = !1,
  image: r,
  imageAltText: i,
  title: a,
  icon: d,
  body: p,
  eventFormat: m = "stack",
  eventLocation: h,
  eventTime: b,
  buttons: k,
  linkLabel: _,
  linkUrl: I,
  tags: C,
  showBorders: w = !0,
  cardLink: N
}) => /* @__PURE__ */ f.jsx(
  Xs,
  {
    type: e,
    width: t,
    horizontal: n,
    image: r,
    imageAltText: i,
    title: a,
    icon: d,
    body: p,
    eventFormat: m,
    eventLocation: h,
    eventTime: b,
    buttons: k,
    linkLabel: _,
    linkUrl: I,
    tags: C,
    showBorders: w,
    cardLink: N
  }
);
Gt.propTypes = {
  /**
   * Type of card
   */
  type: l.oneOf(["default", "degree", "event", "news", "story"]),
  /**
   * Width of card
   */
  width: l.oneOf(["25%", "50%", "75%", "100%"]),
  /**
   * Enable horizontal mode
   */
  horizontal: l.bool,
  /**
   * Card title
   */
  title: l.string.isRequired,
  /**
    React Font Awesome icon prefix and name string to be rendered in button label. Ex: ['fab', 'drupal']
  */
  icon: l.arrayOf(l.string),
  /**
   * Card body content
   */
  body: l.string,
  /**
   * Event info format
   */
  eventFormat: l.oneOf(["stack", "inline"]),
  /**
   * Location
   */
  eventLocation: l.string,
  /**
   * Event start time
   */
  eventTime: l.string,
  /**
   * Card header image
   */
  image: l.string,
  /**
   * Card header image alt text
   */
  imageAltText: l.string,
  /**
   * Buttons
   */
  buttons: l.arrayOf(
    l.shape({
      ariaLabel: l.string,
      color: l.oneOf(["gold", "maroon", "gray", "dark"]),
      icon: l.arrayOf(l.string),
      href: l.string,
      label: l.string,
      onClick: l.func,
      size: l.oneOf(["default", "small", "xsmall"]),
      target: l.oneOf(["_blank", "_self", "_top", "_parent"])
    })
  ),
  linkLabel: l.string,
  linkUrl: l.string,
  /**
   * Tags
   */
  tags: l.arrayOf(
    l.shape({
      ariaLabel: l.string,
      color: l.oneOf(["white", "gray", "dark"]),
      href: l.string,
      label: l.string,
      onClick: l.func
    })
  ),
  /**
   * Remove card borders
   */
  showBorders: l.bool,
  /**
   * Card link
   */
  cardLink: l.string
};
const Xs = ({
  type: e = "default",
  width: t = "100%",
  horizontal: n = !1,
  image: r = "",
  imageAltText: i = "",
  title: a,
  icon: d = void 0,
  body: p = "",
  eventFormat: m = "stack",
  eventLocation: h = "",
  eventTime: b = "",
  buttons: k = void 0,
  linkLabel: _ = void 0,
  linkUrl: I = void 0,
  tags: C = void 0,
  showBorders: w = !0,
  cardLink: N
}) => {
  const M = xe("card", "cards-components", {
    "card-degree": e === "degree",
    "card-event": e === "event",
    "card-story": e === "story",
    "card-news": e === "news",
    [`w-${t.replace("%", "")}`]: t !== "100%",
    "card-horizontal": n,
    borderless: !w
  }), D = typeof r == "string" && r.length > 0, V = !Gs(e);
  return /* @__PURE__ */ f.jsxs(Jc, { className: M, "data-testid": "card-container", children: [
    D && /* @__PURE__ */ f.jsx(
      Cn,
      {
        src: r,
        alt: i,
        dataTestId: "card-image",
        cssClasses: ["card-img-top"],
        title: a,
        cardLink: V ? N : void 0
      }
    ),
    !r && d && /* @__PURE__ */ f.jsx(
      "i",
      {
        className: `${d == null ? void 0 : d[0]} fa-${d == null ? void 0 : d[1]} fa-2x card-icon-top`,
        "data-testid": "card-icon"
      }
    ),
    /* @__PURE__ */ f.jsx("div", { className: n ? "card-content-wrapper" : void 0, children: /* @__PURE__ */ f.jsx(
      Ks,
      {
        type: e,
        body: p,
        eventFormat: m,
        eventLocation: h,
        eventTime: b,
        title: a,
        buttons: k,
        linkLabel: _,
        linkUrl: I,
        tags: C,
        cardLink: N
      }
    ) })
  ] });
};
Xs.propTypes = {
  type: l.oneOf(["default", "degree", "event", "news", "story"]),
  width: l.oneOf(["25%", "50%", "75%", "100%"]),
  horizontal: l.bool,
  title: l.string.isRequired,
  icon: l.arrayOf(l.string),
  // React Font Awesome icon prefix and name string to be rendered in button label. Ex: ['fab', 'drupal']
  body: l.string,
  eventFormat: l.oneOf(["stack", "inline"]),
  eventLocation: l.string,
  eventTime: l.string,
  image: l.string,
  imageAltText: l.string,
  buttons: l.arrayOf(
    l.shape({
      ariaLabel: l.string,
      color: l.oneOf(["gold", "maroon", "gray", "dark"]),
      icon: l.arrayOf(l.string),
      href: l.string,
      label: l.string,
      onClick: l.func,
      size: l.oneOf(["default", "small", "xsmall"]),
      target: l.oneOf(["_blank", "_self", "_top", "_parent"])
    })
  ),
  linkLabel: l.string,
  linkUrl: l.string,
  tags: l.arrayOf(
    l.shape({
      ariaLabel: l.string,
      color: l.oneOf(["white", "gray", "dark"]),
      href: l.string,
      label: l.string,
      onClick: l.func
    })
  ),
  showBorders: l.bool,
  cardLink: l.string
};
const Ks = ({
  type: e = "default",
  body: t = "",
  eventFormat: n = "stack",
  eventLocation: r = "",
  eventTime: i = "",
  title: a,
  buttons: d = void 0,
  linkLabel: p = void 0,
  linkUrl: m = void 0,
  tags: h = void 0,
  cardLink: b
}) => {
  const k = Gs(e), _ = b && !k, I = k && b, C = e === "event" && (i || r);
  return /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    /* @__PURE__ */ f.jsx("div", { className: "card-header", "data-testid": "card-title", children: /* @__PURE__ */ f.jsx("h3", { className: "card-title", children: _ ? /* @__PURE__ */ f.jsx("a", { href: b, children: a }) : a }) }),
    t && /* @__PURE__ */ f.jsx("div", { className: "card-body", "data-testid": "card-body", children: /* @__PURE__ */ f.jsx("div", { dangerouslySetInnerHTML: lt(t) }) }),
    C && /* @__PURE__ */ f.jsx(
      Zs,
      {
        eventFormat: n,
        eventTime: i,
        eventLocation: r
      }
    ),
    I ? /* @__PURE__ */ f.jsx("div", { className: "card-link", "data-testid": "card-link", children: /* @__PURE__ */ f.jsx(
      Ye,
      {
        gaData: {
          ...ps,
          text: a
        },
        children: /* @__PURE__ */ f.jsx("a", { href: b, className: "card-arrow-link", "aria-label": a, children: /* @__PURE__ */ f.jsx("i", { className: "fas fa-arrow-right", "aria-hidden": "true" }) })
      }
    ) }) : /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
      d && /* @__PURE__ */ f.jsx("div", { className: "card-buttons", children: d.map((w) => /* @__PURE__ */ f.jsx(
        "div",
        {
          className: "card-button",
          "data-testid": "card-button",
          children: /* @__PURE__ */ f.jsx(
            ln,
            {
              ariaLabel: w.ariaLabel,
              color: w.color,
              icon: w.icon,
              href: w.href,
              label: w.label,
              onClick: w.onClick,
              size: w.size,
              target: w.target,
              cardTitle: a
            }
          )
        },
        `${w.label}-${w.href}`
      )) }),
      m && p && /* @__PURE__ */ f.jsx("div", { className: "card-link", "data-testid": "card-link", children: /* @__PURE__ */ f.jsx(
        Ye,
        {
          gaData: {
            ...ps,
            section: a,
            text: p
          },
          children: /* @__PURE__ */ f.jsx("a", { href: eu(m), children: p })
        }
      ) })
    ] }),
    h && /* @__PURE__ */ f.jsx("div", { className: "card-tags", "data-testid": "card-tags", children: h.map((w) => (
      // @ts-ignore
      /* @__PURE__ */ f.jsx(
        eo,
        {
          ariaLabel: w.ariaLabel,
          color: w.color,
          href: w.href,
          label: w.label,
          onClick: w.onClick,
          cardTitle: a
        },
        `${w.label}-${w.href}`
      )
    )) })
  ] });
};
Ks.propTypes = {
  type: l.oneOf(["default", "degree", "event", "news", "story"]),
  body: l.string,
  eventFormat: l.oneOf(["stack", "inline"]),
  eventLocation: l.string,
  eventTime: l.string,
  title: l.string.isRequired,
  buttons: l.arrayOf(
    l.shape({
      ariaLabel: l.string,
      color: l.oneOf(["gold", "maroon", "gray", "dark"]),
      icon: l.arrayOf(l.string),
      href: l.string,
      label: l.string,
      onClick: l.func,
      size: l.oneOf(["default", "small", "xsmall"]),
      target: l.oneOf(["_blank", "_self", "_top", "_parent"])
    })
  ),
  linkLabel: l.string,
  linkUrl: l.string,
  tags: l.arrayOf(
    l.shape({
      ariaLabel: l.string,
      color: l.oneOf(["white", "gray", "dark"]),
      href: l.string,
      label: l.string,
      onClick: l.func
    })
  ),
  cardLink: l.string
};
const Zs = ({
  eventFormat: e = "stack",
  eventLocation: t = "",
  eventTime: n = ""
}) => e === "inline" ? /* @__PURE__ */ f.jsxs("div", { className: "card-event-details", children: [
  n && /* @__PURE__ */ f.jsxs("div", { className: "card-event-icons", children: [
    /* @__PURE__ */ f.jsx("div", { children: /* @__PURE__ */ f.jsx("i", { className: "far fa-calendar" }) }),
    /* @__PURE__ */ f.jsx("div", { dangerouslySetInnerHTML: lt(n) })
  ] }),
  t && /* @__PURE__ */ f.jsxs("div", { className: "card-event-icons", children: [
    /* @__PURE__ */ f.jsx("div", { children: /* @__PURE__ */ f.jsx("i", { className: "fas fa-map-marker-alt" }) }),
    /* @__PURE__ */ f.jsx(
      "div",
      {
        dangerouslySetInnerHTML: lt(t)
      }
    )
  ] })
] }) : /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
  n && /* @__PURE__ */ f.jsx("div", { className: "card-event-details", children: /* @__PURE__ */ f.jsxs("div", { className: "card-event-icons", children: [
    /* @__PURE__ */ f.jsx("div", { children: /* @__PURE__ */ f.jsx("i", { className: "far fa-calendar" }) }),
    /* @__PURE__ */ f.jsx("div", { dangerouslySetInnerHTML: lt(n) })
  ] }) }),
  t && /* @__PURE__ */ f.jsx("div", { className: "card-event-details", children: /* @__PURE__ */ f.jsxs("div", { className: "card-event-icons", children: [
    /* @__PURE__ */ f.jsx("div", { children: /* @__PURE__ */ f.jsx("i", { className: "fas fa-map-marker-alt" }) }),
    /* @__PURE__ */ f.jsx("span", { children: /* @__PURE__ */ f.jsx(
      "div",
      {
        dangerouslySetInnerHTML: lt(t)
      }
    ) })
  ] }) })
] });
Zs.propTypes = {
  eventFormat: l.oneOf(["stack", "inline"]),
  eventLocation: l.string,
  eventTime: l.string
};
const hs = {
  name: "onclick",
  event: "link",
  action: "click",
  type: "internal link",
  region: "main content"
}, ms = {
  OPEN: "open",
  CLOSE: "close"
}, tu = {
  SMALL: "small"
}, Js = (e) => e === tu.SMALL, Qs = ({ imageSize: e, body: t, heading: n, readMoreLink: r }) => {
  const [i, a] = tt(!1), d = qr(), { isReact: p, isBootstrap: m } = Rn(), h = `info-layer-${d}`, b = Js(e), k = (_) => {
    (_.type === "click" || _.key === "Enter" || _.key === " ") && a(!i);
  };
  return /* @__PURE__ */ f.jsx(
    "div",
    {
      className: xe("info-layer", { show: i }),
      "data-testid": "info-layer",
      id: h,
      children: /* @__PURE__ */ f.jsxs("div", { className: "content", children: [
        /* @__PURE__ */ f.jsxs(
          "div",
          {
            className: xe("header", {
              closed: b && !i
            }),
            children: [
              b && /* @__PURE__ */ f.jsx("p", { dangerouslySetInnerHTML: lt(t) }),
              /* @__PURE__ */ f.jsx(
                Ye,
                {
                  gaData: {
                    ...hs,
                    text: "Expand ranking",
                    // TODO: for bootstrap can we use aria-expanded value of the button to populate the "action" field
                    action: i ? ms.OPEN : ms.CLOSE,
                    section: n
                  },
                  children: /* @__PURE__ */ f.jsxs(
                    "button",
                    {
                      "data-bs-toggle": m && "collapse",
                      "data-bs-target": m && `#${h}`,
                      onClick: p && k,
                      className: xe("btn-expand", {
                        btn: b
                      }),
                      type: "button",
                      "aria-expanded": i,
                      "aria-controls": h,
                      children: [
                        b ? /* @__PURE__ */ f.jsx("span", { className: "visually-hidden", children: n }) : /* @__PURE__ */ f.jsx("h4", { children: n }),
                        /* @__PURE__ */ f.jsx("i", { className: "fas fa-chevron-up" })
                      ]
                    }
                  )
                }
              )
            ]
          }
        ),
        !b && /* @__PURE__ */ f.jsx("p", { dangerouslySetInnerHTML: lt(t) }),
        r && /* @__PURE__ */ f.jsx(
          Ye,
          {
            gaData: {
              ...hs,
              section: n,
              text: "read more"
            },
            children: /* @__PURE__ */ f.jsxs("a", { href: r, className: "read-more", children: [
              "Read more ",
              /* @__PURE__ */ f.jsx("span", { className: "visually-hidden", children: n }),
              /* @__PURE__ */ f.jsx(
                "span",
                {
                  className: "fas icon-small fa-arrow-right",
                  "aria-hidden": "true"
                }
              )
            ] })
          }
        )
      ] })
    }
  );
};
Qs.propTypes = {
  imageSize: l.oneOf(["small", "large"]),
  body: l.string.isRequired,
  heading: l.string.isRequired,
  readMoreLink: l.string
};
const to = ({
  imageSize: e = "large",
  image: t,
  imageAlt: n,
  heading: r,
  body: i,
  readMoreLink: a = "",
  citation: d
}) => {
  const p = Js(e);
  return /* @__PURE__ */ f.jsxs(
    "div",
    {
      className: xe("card-ranking", {
        "large-image": !p,
        "small-image": p
      }),
      children: [
        p ? /* @__PURE__ */ f.jsx("div", { className: "image-wrapper", children: /* @__PURE__ */ f.jsx(Cn, { src: t, alt: n, fetchPriority: "high" }) }) : /* @__PURE__ */ f.jsx(Cn, { src: t, alt: n, fetchPriority: "high" }),
        p && /* @__PURE__ */ f.jsxs("div", { className: "citation", children: [
          /* @__PURE__ */ f.jsx("h4", { children: r }),
          /* @__PURE__ */ f.jsxs("p", { children: [
            "— ",
            d
          ] })
        ] }),
        /* @__PURE__ */ f.jsx(
          Qs,
          {
            imageSize: e,
            body: i,
            heading: r,
            readMoreLink: a
          }
        )
      ]
    }
  );
};
to.propTypes = {
  /**
   * Size of ranking card
   */
  imageSize: l.oneOf(["small", "large"]).isRequired,
  /**
   * Ranking card image
   */
  image: l.string.isRequired,
  /**
   * Card header image alt text
   */
  imageAlt: l.string.isRequired,
  /**
   * Ranking card heading
   */
  heading: l.string.isRequired,
  /**
   * Ranking card body content
   */
  body: l.string.isRequired,
  /**
   * Link for read more
   */
  readMoreLink: l.string,
  /**
   * Ranking card citation content (Required for small size only)
   */
  citation: l.string
};
const nu = {
  1: "col-12",
  2: "col-12 col-md-6",
  3: "col-12 col-md-6 col-lg-4",
  4: "col-12 col-md-6 col-lg-4 col-xl-3"
}, ea = ({ cards: e, cardType: t = "card", columns: n }) => {
  if (!e || e.length === 0)
    return null;
  let r;
  switch (t) {
    case "ranking":
      r = to;
      break;
    case "image":
      r = Cn;
      break;
    default:
      r = Gt;
      break;
  }
  const i = nu[n] || "col-12 col-md-auto";
  return /* @__PURE__ */ f.jsx("div", { className: "row", "data-testid": "card-arrangement", children: e.map((a, d) => /* @__PURE__ */ f.jsx(
    "div",
    {
      "data-testid": "uds-card-arrangement-content-container",
      className: `${a.horizontal ? "col-12 col-md-6" : i} mb-4`,
      children: /* @__PURE__ */ f.jsx(r, { ...a })
    },
    d
  )) });
};
ea.propTypes = {
  /**
   * Array of card objects to render. Each object should contain props for the
   * Card or RankingCard component. Cards will wrap naturally based on their
   * intrinsic min/max widths.
   */
  cards: l.arrayOf(l.object).isRequired,
  /**
   * Type of card to render - either "card" (default), "ranking", or "image"
   */
  cardType: l.oneOf(["card", "ranking", "image"]),
  /**
   * Number of columns to display.
   */
  columns: l.oneOf([1, 2, 3, 4, "1", "2", "3", "4"])
};
const ru = {
  name: "onclick",
  event: "link",
  action: "click",
  type: "internal link",
  region: "main content"
}, ta = ({
  backgroundImage: e,
  icon: t,
  title: n,
  highlightText: r,
  description: i,
  button: a
}) => {
  const d = () => {
    if (!t) return null;
    let p = "";
    return Array.isArray(t) ? p = t.join(" ") : p = t.includes(" ") ? t : `fas fa-${t}`, /* @__PURE__ */ f.jsx("i", { className: p, "aria-hidden": "true" });
  };
  return /* @__PURE__ */ f.jsxs("div", { className: "content-spotlight", children: [
    /* @__PURE__ */ f.jsx("div", { className: "content-spotlight-image-container", children: /* @__PURE__ */ f.jsxs("div", { className: "content-spotlight-image-wrapper", children: [
      /* @__PURE__ */ f.jsx("div", { className: "content-spotlight-overlay" }),
      /* @__PURE__ */ f.jsx(
        "img",
        {
          src: e,
          alt: "",
          "aria-hidden": "true",
          className: "content-spotlight-image"
        }
      )
    ] }) }),
    /* @__PURE__ */ f.jsxs("div", { className: "content-spotlight-content", children: [
      t && /* @__PURE__ */ f.jsx("div", { className: "content-spotlight-icon", children: d() }),
      /* @__PURE__ */ f.jsxs("h2", { className: "content-spotlight-title", children: [
        n,
        r && /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
          n && r && /* @__PURE__ */ f.jsx("br", {}),
          /* @__PURE__ */ f.jsx("span", { className: "highlight", children: r })
        ] })
      ] }),
      i && /* @__PURE__ */ f.jsx(
        "p",
        {
          className: "content-spotlight-description",
          dangerouslySetInnerHTML: lt(i)
        }
      ),
      a && /* @__PURE__ */ f.jsx(
        Ye,
        {
          gaData: {
            ...ru,
            text: a.label,
            component: "ContentSpotlight"
          },
          children: /* @__PURE__ */ f.jsx(
            "a",
            {
              href: a.href,
              className: `btn ${a.color ? `btn-${a.color}` : "btn-gold"}`,
              children: a.label
            }
          )
        }
      )
    ] })
  ] });
};
ta.propTypes = {
  backgroundImage: l.string.isRequired,
  icon: l.oneOfType([
    l.string,
    l.arrayOf(l.string)
  ]),
  title: l.node.isRequired,
  highlightText: l.string,
  description: l.string,
  button: l.shape({
    label: l.string.isRequired,
    href: l.string.isRequired,
    color: l.string
  })
};
var iu = /* @__PURE__ */ ((e) => (e.COPY = "copy", e))(iu || {});
const ou = ({ type: e }) => e == "copy" ? /* @__PURE__ */ f.jsx("hr", { className: "copy-divider" }) : /* @__PURE__ */ f.jsx("hr", {}), su = Pt.div`
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
  div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 30px;
    height: 30px;
    margin: 3px;
    border: 3px solid #1b1b1b;
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: #1b1b1b transparent transparent transparent;
  }
  div:nth-child(1) {
    animation-delay: -0.45s;
  }
  div:nth-child(2) {
    animation-delay: -0.3s;
  }
  div:nth-child(3) {
    animation-delay: -0.15s;
  }
  @keyframes lds-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`, au = () => /* @__PURE__ */ f.jsxs(su, { children: [
  /* @__PURE__ */ f.jsx("div", {}),
  /* @__PURE__ */ f.jsx("div", {}),
  /* @__PURE__ */ f.jsx("div", {}),
  /* @__PURE__ */ f.jsx("div", {})
] }), lu = Pt.section``, cu = Da(null), uu = ({
  defaultProps: e,
  dataSource: t,
  noFeedText: n,
  renderHeader: r,
  renderBody: i,
  dataTransformer: a,
  dataFilter: d,
  maxItems: p
}) => {
  const [{ data: m, loading: h, error: b }, k] = Ua(), [_, I] = tt([]), C = { ...e.dataSource, ...t };
  return at(() => {
    k(C == null ? void 0 : C.url);
  }, [C == null ? void 0 : C.url]), at(() => {
    const w = m == null ? void 0 : m.nodes.map(a), N = w == null ? void 0 : w.filter(
      (M) => d(M, t == null ? void 0 : t.filters)
    );
    I(p ? N == null ? void 0 : N.slice(0, p) : N);
  }, [m]), // Init the context to be used on its childrens
  /* @__PURE__ */ f.jsx(cu.Provider, { value: { feeds: _ }, children: /* @__PURE__ */ f.jsxs(lu, { children: [
    r,
    b ? /* @__PURE__ */ f.jsx("span", { children: "Error, try again!" }) : /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
      h && !(_ != null && _.length) && /* @__PURE__ */ f.jsx("div", { className: "text-center mt-4", children: /* @__PURE__ */ f.jsx(au, {}) }),
      _ != null && _.length ? i : !h && /* @__PURE__ */ f.jsx("p", { className: "text-center", children: n })
    ] })
  ] }) });
};
uu.propTypes = {
  renderHeader: l.element,
  renderBody: l.element,
  maxItems: l.number,
  dataTransformer: l.func,
  dataFilter: l.func,
  noFeedText: l.string
};
const na = l.shape({
  color: l.oneOf(["white", "dark"]),
  text: l.string
}), ra = l.shape({
  color: l.oneOf(["gold", "maroon", "gray", "dark"]),
  text: l.string
}), Wd = l.shape({
  color: l.oneOf(["gold", "maroon", "gray", "dark"]),
  text: l.string,
  size: l.string
}), du = l.shape({
  url: l.string,
  filters: l.string
}), fu = l.shape({
  header: na,
  ctaButton: ra,
  dataSource: du,
  maxItems: l.number
}), pu = Pt.div`
  @media screen and (min-width: 768px) {
    & {
      display: inline-flex;
      justify-content: flex-end;
    }
  }
`, hu = ({
  defaultProps: e,
  header: t,
  ctaButton: n
}) => {
  const r = { ...e.header, ...t }, i = { ...e.ctaButton, ...n }, a = r.tag || "h2", d = a !== "h2", p = `text-${r.color} ${d ? "h2" : ""}`.trim();
  return /* @__PURE__ */ f.jsxs(
    "div",
    {
      className: "row justify-content-between align-items-center pb-6",
      "data-testid": "feed-header",
      children: [
        /* @__PURE__ */ f.jsx("div", { className: "col-sm-12 col-md-9", children: /* @__PURE__ */ f.jsx(a, { className: p, children: r.text }) }),
        /* @__PURE__ */ f.jsx(pu, { className: "col-sm-12 col-md-3", children: /* @__PURE__ */ f.jsx(
          Ye,
          {
            gaData: {
              event: "link",
              action: "click",
              name: "onclick",
              type: "internal link",
              region: "main content",
              section: r.text,
              text: i.text
            },
            children: /* @__PURE__ */ f.jsx("a", { className: `btn btn-${i.color}`, href: i.url, children: i.text })
          }
        ) })
      ]
    }
  );
};
hu.propTypes = {
  defaultProps: fu,
  header: na,
  ctaButton: ra
};
const mu = ({ children: e }) => /* @__PURE__ */ f.jsx("div", { className: "row", "data-testid": "feed-body", children: /* @__PURE__ */ f.jsx("div", { className: "col", children: e }) });
mu.propTypes = {
  children: l.element
};
const gu = Pt.img`
  width: 100%;
`;
function vu({ image: e, title: t, contents: n }) {
  return console.log({ image: e, title: t, contents: n }), /* @__PURE__ */ f.jsx("div", { children: "TODO: to be implemented" });
}
function yu({
  image: e,
  subTitle: t,
  title: n,
  contents: r,
  contentsColor: i
}) {
  const a = {
    small: "uds-hero-sm",
    medium: "uds-hero-md",
    large: "uds-hero-lg",
    undefined: ""
  }, d = {
    gold: "highlight-gold",
    black: "highlight-black",
    white: "highlight-white",
    none: "text-white",
    undefined: ""
  }, p = {
    black: "text-dark",
    white: "text-white",
    undefined: ""
  };
  return /* @__PURE__ */ f.jsxs(
    "div",
    {
      className: xe("uds-hero", {
        [a[e == null ? void 0 : e.size]]: e == null ? void 0 : e.size
      }),
      children: [
        /* @__PURE__ */ f.jsx("div", { className: "hero-overlay" }),
        /* @__PURE__ */ f.jsx(
          gu,
          {
            className: "hero",
            src: e == null ? void 0 : e.url,
            alt: e == null ? void 0 : e.altText,
            "data-testid": "hero-image"
          }
        ),
        t && /* @__PURE__ */ f.jsx("div", { role: "doc-subtitle", "data-testid": "hero-subtitle", children: /* @__PURE__ */ f.jsx(
          "span",
          {
            className: xe({
              [p[t.color]]: t.color,
              [d[t.highlightColor]]: t.highlightColor
            }),
            children: t.text
          }
        ) }),
        n && /* @__PURE__ */ f.jsx("h1", { style: { maxWidth: n.maxWidth || "" }, "data-testid": "hero-title", children: /* @__PURE__ */ f.jsx(
          "span",
          {
            className: xe({
              [p[n.color]]: n.color,
              [d[n.highlightColor]]: n.highlightColor
            }),
            children: n.text
          }
        ) }),
        r && /* @__PURE__ */ f.jsx(
          "div",
          {
            "data-testid": "hero-content",
            className: xe("content", {
              [p[i]]: i
            }),
            children: r.map((m, h) => /* @__PURE__ */ f.jsx("p", { children: m.text }, `content-${h}`))
          }
        )
      ]
    }
  );
}
const ia = (e) => {
  const t = e.type || "heading-hero";
  return {
    "heading-hero": () => yu(e),
    "story-hero": () => vu(e),
    undefined: () => (console.error(
      `the type '${t}' is not supported by the 'Hero' component.`
    ), null)
  }[t]();
};
ia.propTypes = {
  type: l.oneOf(["heading-hero", "story-hero"]),
  image: bl,
  title: bi,
  subTitle: bi,
  contents: l.arrayOf(bi),
  contentsColor: l.string
};
const xu = ({
  title: e = "Highly ranked",
  description: t = "",
  ctaText: n = "",
  ctaUrl: r = "",
  ctaButtonColor: i = "dark",
  rankings: a = []
}) => /* @__PURE__ */ f.jsx("section", { className: "highly-ranked-section", children: /* @__PURE__ */ f.jsxs("div", { className: "container", children: [
  /* @__PURE__ */ f.jsx("div", { className: "row", children: /* @__PURE__ */ f.jsxs("div", { className: "col-12 col-lg-8", children: [
    e && /* @__PURE__ */ f.jsx("h2", { className: "highly-ranked-title", children: /* @__PURE__ */ f.jsx("span", { className: "highlight-gold", children: e }) }),
    t && /* @__PURE__ */ f.jsx(
      "p",
      {
        className: "highly-ranked-description",
        dangerouslySetInnerHTML: lt(t)
      }
    ),
    n && r && /* @__PURE__ */ f.jsx("div", { className: "highly-ranked-cta", children: /* @__PURE__ */ f.jsx(
      ln,
      {
        label: n,
        href: r,
        color: i,
        size: "small",
        classes: []
      }
    ) })
  ] }) }),
  /* @__PURE__ */ f.jsx("div", { className: "row highly-ranked-grid", children: a.map((d, p) => /* @__PURE__ */ f.jsx("div", { className: "col-12 col-lg-6 mb-4", children: /* @__PURE__ */ f.jsxs("div", { className: "highly-ranked-card", children: [
    /* @__PURE__ */ f.jsx("div", { className: "ranking-value-container", children: /* @__PURE__ */ f.jsxs("h3", { className: "ranking-value", children: [
      /* @__PURE__ */ f.jsx(
        "span",
        {
          className: `ranking-value-main${d.headingLevel ? ` ${d.headingLevel}` : " h1"}`,
          children: d.value
        }
      ),
      d.title && /* @__PURE__ */ f.jsx("span", { className: "ranking-value-subsection", children: d.title })
    ] }) }),
    d.description && /* @__PURE__ */ f.jsx("div", { className: "ranking-content", children: /* @__PURE__ */ f.jsx(
      "p",
      {
        className: "ranking-description",
        dangerouslySetInnerHTML: lt(
          d.description
        )
      }
    ) })
  ] }) }, p)) })
] }) }), Nt = ({
  dataId: e,
  isClickeable: t = !1,
  disabled: n = !1,
  pageLinkIcon: r = !1,
  selectedPage: i = !1,
  onClick: a = () => {
  },
  ellipses: d,
  ariaLabel: p,
  children: m,
  ariaDisabled: h
}) => /* @__PURE__ */ f.jsx(
  "li",
  {
    className: xe("page-item", {
      disabled: n,
      active: i,
      elipses: d
    }),
    children: t ? /* @__PURE__ */ f.jsxs(
      "button",
      {
        type: "button",
        "aria-label": p,
        className: xe("page-link", {
          "page-link-icon": r
        }),
        onClick: a,
        "data-testid": e ? `pagination-${e}` : "page-link",
        "data-id": e,
        "aria-current": i ? "page" : null,
        "aria-disabled": h,
        children: [
          m,
          i && /* @__PURE__ */ f.jsx("span", { className: "visually-hidden", children: "(current)" })
        ]
      }
    ) : /* @__PURE__ */ f.jsx("span", { className: "page-link", "data-testid": "page-link", children: m })
  }
);
Nt.propTypes = {
  isClickeable: l.bool,
  disabled: l.bool,
  pageLinkIcon: l.bool,
  selectedPage: l.bool,
  dataId: l.string,
  onClick: l.func,
  children: l.node,
  ellipses: l.bool,
  ariaLabel: l.string,
  ariaDisabled: l.bool
};
const bu = {
  event: "select",
  action: "click",
  name: "onclick",
  type: "pagination",
  region: "main content"
}, oa = ({
  type: e,
  background: t,
  currentPage: n = 1,
  totalPages: r = 10,
  onChange: i
}) => {
  const [a, d] = tt(null);
  at(() => {
    d(n);
  }, [n]);
  const p = (b) => {
    As({ ...bu, text: `page ${b}` });
  }, m = (b, k) => {
    const I = {
      first: 1,
      prev: a === 1 ? 1 : a - 1,
      next: a === r ? r : a + 1,
      last: r
    }[k] ?? k;
    d(I), p(I), i == null || i(b, I);
  }, h = () => {
    if (r < 5)
      return /* @__PURE__ */ f.jsx(f.Fragment, { children: Array.from({ length: r }, (N, M) => {
        const D = M + 1;
        return /* @__PURE__ */ f.jsx(
          Nt,
          {
            ariaLabel: `Page ${D} of ${r}`,
            isClickeable: !0,
            selectedPage: a === D,
            onClick: (V) => m(V, D),
            children: D
          },
          D
        );
      }) });
    const b = 2, k = jo(
      a === r - 1,
      1,
      a === r ? 2 : 1
    ), _ = jo(
      a === 1,
      2,
      1
    ), I = zo(
      a - k,
      a,
      r
    ), C = zo(
      a,
      a + 1 + _,
      r
    ), w = [...I, ...C];
    return /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
      w[0] !== 1 && /* @__PURE__ */ f.jsx(
        Nt,
        {
          ariaLabel: `Page 1 of ${r}`,
          isClickeable: !0,
          selectedPage: a === 1,
          onClick: (N) => m(N, "first"),
          children: "1"
        }
      ),
      a > r - b && /* @__PURE__ */ f.jsx(
        Nt,
        {
          isClickeable: !0,
          ariaLabel: `Page 2 of ${r}`,
          selectedPage: a === 2,
          onClick: (N) => m(N, 2),
          children: "2"
        }
      ),
      w[0] > 2 && /* @__PURE__ */ f.jsx(Nt, { ellipses: !0, children: "..." }),
      w.map((N) => /* @__PURE__ */ f.jsx(
        Nt,
        {
          ariaLabel: `Page ${N} of ${r}`,
          isClickeable: !0,
          selectedPage: a === N,
          onClick: (M) => m(M, N),
          children: N
        },
        N
      )),
      w[w.length - 1] < r - 1 && /* @__PURE__ */ f.jsx(Nt, { ellipses: !0, children: "..." }),
      a < b + 1 && /* @__PURE__ */ f.jsx(
        Nt,
        {
          isClickeable: !0,
          ariaLabel: `Page ${r - 1} of ${r}`,
          selectedPage: a === r - 1,
          onClick: (N) => m(N, r - 1),
          children: r - 1
        }
      ),
      w[w.length - 1] !== r && /* @__PURE__ */ f.jsx(
        Nt,
        {
          isClickeable: !0,
          ariaLabel: `Page ${r} of ${r}`,
          selectedPage: a === r,
          onClick: (N) => m(N, "last"),
          children: r
        }
      )
    ] });
  };
  return /* @__PURE__ */ f.jsx("nav", { "aria-label": "Pagination", "data-testid": "pagination", children: /* @__PURE__ */ f.jsxs(
    "ul",
    {
      className: xe(
        "pagination",
        "justify-content-center",
        "pt-2",
        "pb-2",
        {
          border: e === "bordered",
          "uds-bg-gray1": t === "gray1",
          "uds-bg-gray": t === "gray2",
          "uds-bg-dark": t === "gray7"
        }
      ),
      children: [
        /* @__PURE__ */ f.jsx(
          Nt,
          {
            dataId: "prev",
            isClickeable: !0,
            disabled: a === 1,
            pageLinkIcon: !0,
            onClick: (b) => m(b, "prev"),
            ariaDisabled: a === 1,
            ariaLabel: "Previous Page"
          }
        ),
        h(),
        /* @__PURE__ */ f.jsx(
          Nt,
          {
            dataId: "next",
            isClickeable: !0,
            ariaDisabled: a === r,
            disabled: a === r,
            pageLinkIcon: !0,
            onClick: (b) => m(b, "next"),
            ariaLabel: "Next Page"
          }
        )
      ]
    }
  ) });
};
oa.propTypes = {
  /**
   * Type of pagination
   */
  type: l.oneOf(["default", "bordered"]).isRequired,
  /**
   * Background of pagination
   */
  background: l.oneOf(["white", "gray1", "gray2", "gray7"]).isRequired,
  /**
   * Current page
   */
  currentPage: l.number,
  /**
   * Total number of pages
   */
  totalPages: l.number,
  /**
   * Callback fired when the page is changed
   */
  onChange: l.func.isRequired
};
var wu = /* @__PURE__ */ ((e) => (e.WARNING = "warning", e.INFO = "info", e.SUCCESS = "success", e.ERROR = "error", e))(wu || {});
const Su = ({
  type: e,
  dismissable: t,
  children: n
}) => {
  var h, b, k;
  const { isBootstrap: r, isReact: i } = Rn(), [a, d] = tt(!0), p = () => d(!1), m = {
    warning: {
      iconTitle: "Warning",
      iconName: "bell",
      alertClass: "warning"
    },
    info: {
      iconTitle: "Information",
      iconName: "info-circle",
      alertClass: "info"
    },
    success: {
      iconTitle: "Success",
      iconName: "check-circle",
      alertClass: "success"
    },
    error: {
      iconTitle: "Error",
      iconName: "exclamation-triangle",
      alertClass: "danger"
    }
  };
  return a && /* @__PURE__ */ f.jsxs(
    "div",
    {
      className: xe("alert", {
        "alert-dismissable": t,
        [`alert-${(h = m[e]) == null ? void 0 : h.alertClass}`]: e
      }),
      role: "alert",
      children: [
        /* @__PURE__ */ f.jsx("div", { className: "alert-icon", children: /* @__PURE__ */ f.jsx(
          "span",
          {
            title: (b = m[e]) == null ? void 0 : b.iconTitle,
            className: `fa fa-icon fa-${(k = m[e]) == null ? void 0 : k.iconName}`
          }
        ) }),
        /* @__PURE__ */ f.jsx("div", { className: "alert-content", children: n }),
        t && /* @__PURE__ */ f.jsx("div", { className: "alert-close", children: /* @__PURE__ */ f.jsx(
          Qi,
          {
            icon: ["fas", "times"],
            onClick: i && p,
            "data-bs-dismiss": r && "alert"
          }
        ) })
      ]
    }
  );
}, ku = Pt.div`
  button {
    padding: 16px 0;
    border: none;
    outline: none;
  }
`, sa = ({ gaData: e, hidePrev: t, hideNext: n, slideNav: r }) => {
  const { isReact: i, isBootstrap: a } = Rn();
  return /* @__PURE__ */ f.jsxs(ku, { children: [
    (!t || a) && /* @__PURE__ */ f.jsx(Ye, { gaData: { ...e, text: "left chevron" }, children: /* @__PURE__ */ f.jsxs(
      "button",
      {
        className: "scroll-control-prev",
        type: "button",
        onClick: i && (() => r(-1)),
        tabIndex: -1,
        children: [
          /* @__PURE__ */ f.jsx("span", { className: "carousel-control-prev-icon", "aria-hidden": "true" }),
          /* @__PURE__ */ f.jsx("span", { className: "visually-hidden", children: "Previous" })
        ]
      }
    ) }),
    (!n || a) && /* @__PURE__ */ f.jsx(Ye, { gaData: { ...e, text: "right chevron" }, children: /* @__PURE__ */ f.jsxs(
      "button",
      {
        className: "scroll-control-next",
        type: "button",
        onClick: i && (() => r(1)),
        tabIndex: -1,
        children: [
          /* @__PURE__ */ f.jsx("span", { className: "carousel-control-next-icon", "aria-hidden": "true" }),
          /* @__PURE__ */ f.jsx("span", { className: "visually-hidden", children: "Next" })
        ]
      }
    ) })
  ] });
};
sa.propTypes = {
  gaData: l.object,
  hidePrev: l.bool,
  hideNext: l.bool,
  slideNav: l.func.isRequired
};
const aa = Yi(function(t, n) {
  const {
    id: r,
    selected: i,
    title: a,
    selectTab: d,
    leftKeyPressed: p,
    rightKeyPressed: m,
    icon: h,
    gaData: b
  } = t, { isReact: k, isBootstrap: _ } = Rn(), I = En(null);
  Fa(n, () => ({
    focus() {
      I.current.focus();
    },
    scrollIntoView() {
      var M, D, V, W, A, X, re;
      const w = ((M = I.current) == null ? void 0 : M.offsetWidth) / 2 + I.current.offsetLeft, N = ((V = (D = I.current) == null ? void 0 : D.offsetParent) == null ? void 0 : V.scrollLeft) + ((A = (W = I.current) == null ? void 0 : W.offsetParent) == null ? void 0 : A.offsetWidth) / 2;
      (re = (X = I.current) == null ? void 0 : X.offsetParent) == null || re.scrollBy({
        left: w - N
      });
    }
  }), []);
  const C = (w) => {
    w.keyCode === 37 ? (w.preventDefault(), p()) : w.keyCode === 39 && (w.preventDefault(), m());
  };
  return /* @__PURE__ */ f.jsx(Ye, { gaData: { ...b, text: a }, children: /* @__PURE__ */ f.jsxs(
    "a",
    {
      ref: I,
      className: `nav-item nav-link ${i ? "active" : ""}`,
      id: r,
      href: `#nav-${r}`,
      role: "tab",
      "aria-controls": `nav-${r}`,
      "aria-selected": i,
      "data-bs-toggle": _ && "tab",
      onClick: k && ((w) => d(w, r, a)),
      onKeyDown: k && C,
      tabIndex: i ? "" : "-1",
      children: [
        a,
        " ",
        h && /* @__PURE__ */ f.jsx("i", { className: `${h == null ? void 0 : h[0]} fa-${h == null ? void 0 : h[1]} me-1` })
      ]
    }
  ) });
});
aa.propTypes = {
  gaData: l.object,
  id: l.string.isRequired,
  selected: l.bool.isRequired,
  title: l.string.isRequired,
  selectTab: l.func.isRequired,
  leftKeyPressed: l.func.isRequired,
  rightKeyPressed: l.func.isRequired,
  icon: l.arrayOf(l.string)
};
function Tu() {
  const e = En({}), t = Ln(
    (n) => (r) => {
      e.current[n] = r;
    },
    []
  );
  return [e, t];
}
const _u = ({ id: e, bgColor: t, selected: n, children: r }) => {
  const { isBootstrap: i } = Rn();
  return n || i ? /* @__PURE__ */ f.jsx(
    "div",
    {
      className: `tab-pane fade show ${n ? "show active" : ""} ${t === "bg-dark" ? "text-white" : ""}`,
      id: `nav-${e}`,
      role: "tabpanel",
      "aria-labelledby": `nav-${e}-tab`,
      children: r
    }
  ) : null;
};
_u.propTypes = {
  id: l.string.isRequired,
  bgColor: l.string,
  selected: l.bool,
  children: l.oneOfType([l.array, l.element])
};
const la = ({
  initialTab: e = "",
  children: t,
  bgColor: n = "",
  onTabChange: r = (i) => {
  }
}) => {
  var ve, fe;
  const i = Ve.Children.toArray(t), a = En(!1), [d, p] = tt(
    e && e !== "null" ? e : ((fe = (ve = i[0]) == null ? void 0 : ve.props) == null ? void 0 : fe.id) || ""
  ), m = En(null), [h, b] = Tu(), [k, _] = tt(0), [I, C] = tt(), w = Ln(() => {
    var Z, ue;
    C(
      ((Z = m.current) == null ? void 0 : Z.scrollWidth) - ((ue = m.current) == null ? void 0 : ue.offsetWidth)
    );
  }, []), N = Ln(() => {
    var Z;
    _((Z = m.current) == null ? void 0 : Z.scrollLeft);
  }, []), M = Ln(() => {
    Ri(N, 150), Oi(N, 150);
  }, [N]), D = Ln(() => {
    Ri(w, 150), Oi(w, 150);
  }, [w]);
  if (at(() => {
    const Z = m.current;
    return Z && (Z.addEventListener("scroll", M), N()), () => {
      Z && Z.removeEventListener("scroll", M);
    };
  }, [I, M, N]), at(() => (window.addEventListener("resize", D), w(), () => {
    window.removeEventListener("resize", D);
  }), [D, w]), at(() => {
    h.current[d] && h.current[d].scrollIntoView();
  }, [d, h]), at(() => {
    a.current && e && e !== "null" && d !== e && p(e);
  }, [e, d]), at(() => {
    a.current = !0;
  }, []), i.length === 0)
    return null;
  const V = (Z) => {
    var ue;
    r(Z), (ue = h.current[Z]) == null || ue.focus(), p(Z);
  }, W = {
    event: "select",
    action: "click",
    name: "onclick",
    type: "carousel",
    region: "main content",
    text: ""
  }, A = {
    event: "link",
    action: "click",
    name: "onclick",
    type: "internal link",
    text: ""
  }, X = i.map((Z) => Ve.cloneElement(Z, {
    bgColor: n,
    selected: d === Z.props.id
  })), re = (Z) => {
    const ue = m.current, Ae = ue.scrollWidth - ue.clientWidth;
    let ze = ue.scrollLeft + 200 * Z;
    ze = Math.max(0, Math.min(Ae, ze)), ue.scrollTo({
      left: ze,
      behavior: "smooth"
    });
  }, Me = (Z, ue, Ae) => {
    Z.preventDefault(), V(ue);
  }, Ne = (Z = !0) => {
    const ue = i.length, Ae = Z ? 1 : -1, dt = i.findIndex((He) => He.props.id === d), ze = i[(ue + dt + Ae) % ue].props.id;
    V(ze);
  };
  let De = "uds-tabbed-panels";
  return n === "bg-dark" && (De += " uds-tabbed-panels-dark"), /* @__PURE__ */ f.jsxs("div", { className: n, children: [
    /* @__PURE__ */ f.jsxs("nav", { className: De, children: [
      /* @__PURE__ */ f.jsx("div", { className: "nav nav-tabs", role: "tablist", ref: m, children: i.map((Z, ue) => /* @__PURE__ */ f.jsx(
        aa,
        {
          ref: b(Z.props.id),
          id: Z.props.id,
          title: Z.props.title,
          selected: d === Z.props.id,
          gaData: A,
          selectTab: Me,
          leftKeyPressed: () => Ne(!1),
          rightKeyPressed: () => Ne(),
          icon: Z.props.icon,
          index: ue
        },
        Z.props.id
      )) }),
      /* @__PURE__ */ f.jsx(
        sa,
        {
          hidePrev: k <= 0,
          hideNext: k >= I,
          gaData: W,
          slideNav: re
        }
      )
    ] }),
    /* @__PURE__ */ f.jsx(
      "div",
      {
        className: "tab-content",
        tabIndex: 0,
        role: "tabpanel",
        id: "nav-tabContent",
        children: X
      }
    )
  ] });
};
la.propTypes = {
  initialTab: l.string,
  children: l.arrayOf(l.element).isRequired,
  bgColor: l.string,
  onTabChange: l.func
};
const no = ({ imageSource: e, imageAltText: t, quote: n, itemStyle: r = {} }) => {
  var i, a;
  return /* @__PURE__ */ f.jsxs(
    "div",
    {
      className: `uds-blockquote uds-testimonial ${e ? "with-image" : ""} ${Nr(r.containerCssClass)}`,
      children: [
        e && /* @__PURE__ */ f.jsx(
          Cn,
          {
            src: e,
            alt: t,
            dataTestId: "testimonial-image",
            fetchPriority: "high"
          }
        ),
        /* @__PURE__ */ f.jsx("svg", { role: "presentation", viewBox: "0 0 302.87 245.82", children: /* @__PURE__ */ f.jsx("path", { d: "M113.61,245.82H0V164.56q0-49.34,8.69-77.83T40.84,35.58Q64.29,12.95,100.67,0l22.24,46.9q-34,11.33-48.72,31.54T58.63,132.21h55Zm180,0H180V164.56q0-49.74,8.7-78T221,35.58Q244.65,12.95,280.63,0l22.24,46.9q-34,11.33-48.72,31.54t-15.57,53.77h55Z" }) }),
        /* @__PURE__ */ f.jsxs("blockquote", { style: { paddingLeft: 0 }, children: [
          n.title && /* @__PURE__ */ f.jsx("h3", { className: "text-center", "data-testid": "testimonial-title", children: /* @__PURE__ */ f.jsx("span", { className: Nr(r.titleCssClass), children: n.title }) }),
          n.content && /* @__PURE__ */ f.jsx(
            "p",
            {
              className: Nr(r.contentCssClass),
              "data-testid": "testimonial-content",
              children: n.content
            }
          ),
          (!!((i = n.cite) != null && i.name) || !!((a = n.cite) != null && a.description)) && /* @__PURE__ */ f.jsxs("div", { className: "citation", "data-testid": "testimonial-citation", children: [
            /* @__PURE__ */ f.jsx("cite", { className: "name", children: n.cite.name }),
            n.cite && /* @__PURE__ */ f.jsx("cite", { className: "description", children: n.cite.description })
          ] })
        ] })
      ]
    }
  );
};
no.propTypes = {
  quote: l.shape({
    title: l.string,
    content: l.string,
    cite: l.shape({
      name: l.string,
      description: l.string
    })
  }).isRequired,
  imageSource: l.string,
  imageAltText: l.string,
  itemStyle: l.shape({
    containerCssClass: l.arrayOf(l.string),
    titleCssClass: l.arrayOf(l.string),
    contentCssClass: l.arrayOf(l.string)
  })
};
const Eu = (e) => /* @__PURE__ */ f.jsx("button", { className: "uds-tooltip uds-tooltip-gray", ...e, children: /* @__PURE__ */ f.jsxs("span", { className: "fa-stack", "aria-hidden": "true", children: [
  /* @__PURE__ */ f.jsx("i", { className: "fas fa-circle fa-stack-2x" }),
  /* @__PURE__ */ f.jsx("i", { className: "fas fa-info fa-stack-1x" })
] }) }), Cu = ({
  title: e,
  content: t,
  triggerElement: n,
  children: r,
  iconLabel: i
}) => {
  const a = "tooltip-" + qr(), d = () => i || (e ? `Show tooltip: ${e}` : t && typeof t == "string" ? `Show tooltip: ${t.length > 50 ? t.substring(0, 47) + "..." : t}` : "Show more information");
  let p = r || n || /* @__PURE__ */ f.jsx(Eu, { "aria-label": d() });
  return typeof p == "string" && (p = /* @__PURE__ */ f.jsx("button", { type: "button", children: p })), /* @__PURE__ */ f.jsxs("span", { className: "uds-tooltip-container", children: [
    Ve.cloneElement(p, {
      "aria-describedby": a,
      tabIndex: 0
    }),
    /* @__PURE__ */ f.jsxs("div", { role: "tooltip", className: "uds-tooltip-description", id: a, children: [
      e && /* @__PURE__ */ f.jsx("span", { className: "uds-tooltip-heading", children: e }),
      t
    ] })
  ] });
}, Ru = {
  name: "onclick",
  event: "link",
  action: "click",
  type: "internal link",
  region: "main content",
  text: "play button"
}, Ou = ({
  url: e = "",
  vttUrl: t,
  caption: n,
  title: r = "",
  className: i,
  controls: a = !0
}) => {
  const d = En(null);
  return /* @__PURE__ */ f.jsxs(
    "div",
    {
      className: xe(`uds-video-container ${i}`, {
        "uds-video-with-caption": n
      }),
      children: [
        /* @__PURE__ */ f.jsx("div", { className: "uds-video-player", children: /* @__PURE__ */ f.jsx(Ye, { gaData: { ...Ru, section: r }, children: /* @__PURE__ */ f.jsxs(
          "video",
          {
            ref: d,
            title: r,
            playsInline: !0,
            controls: a || !0,
            children: [
              /* @__PURE__ */ f.jsx("source", { src: e }),
              /* @__PURE__ */ f.jsx(
                "track",
                {
                  src: t,
                  kind: "captions",
                  srcLang: "en",
                  label: "english_captions"
                }
              )
            ]
          }
        ) }) }),
        n && /* @__PURE__ */ f.jsx("figure", { "data-testid": "video-caption", children: /* @__PURE__ */ f.jsx("figcaption", { children: n }) })
      ]
    }
  );
}, Au = ({ title: e = "", caption: t, url: n = "", className: r }) => /* @__PURE__ */ f.jsxs(
  "div",
  {
    className: xe(`uds-video-container ${r}`, {
      "uds-video-with-caption": t
    }),
    children: [
      /* @__PURE__ */ f.jsx("div", { className: "uds-video-player youtube-video", children: /* @__PURE__ */ f.jsx("iframe", { title: e, src: n }) }),
      t && /* @__PURE__ */ f.jsx("figure", { "data-testid": "video-caption", children: /* @__PURE__ */ f.jsx("figcaption", { children: t }) })
    ]
  }
), ca = (e) => {
  const {
    type: t = "video",
    url: n = "",
    vttUrl: r,
    title: i = "",
    caption: a,
    className: d,
    controls: p = !0
  } = e;
  return t === "youtube" ? Au({ url: n, title: i, caption: a, className: d }) : Ou({
    url: n,
    vttUrl: r,
    title: i,
    caption: a,
    className: d,
    controls: p
  });
};
ca.propTypes = {
  type: l.oneOf(["video", "youtube"]),
  url: l.string,
  vttUrl: l.string,
  title: l.string,
  className: l.string,
  caption: l.string,
  controls: l.bool
};
const ju = {
  event: "select",
  action: "click",
  name: "onclick",
  region: "main content",
  type: "pagination",
  text: "owl dot"
}, ro = ({ children: e }) => /* @__PURE__ */ f.jsx(
  "div",
  {
    role: "group",
    className: "glide__bullets",
    "data-glide-el": "controls[nav]",
    "data-testid": "bullets-container",
    onClick: (t) => t.stopPropagation(),
    onKeyDown: (t) => t.stopPropagation(),
    children: e
  }
);
ro.propTypes = {
  children: l.oneOfType([
    l.element,
    l.arrayOf(l.element)
  ]).isRequired
};
const ua = ({ buttonCount: e }) => {
  const t = [];
  for (let n = 0; n < e; n += 1)
    t.push(
      /* @__PURE__ */ f.jsx(Ye, { gaData: ju, children: /* @__PURE__ */ f.jsx(
        "button",
        {
          type: "button",
          className: "glide__bullet",
          "data-glide-dir": `=${n}`,
          "aria-label": `Slide view ${n + 1}`
        }
      ) }, `bullet-${n}`)
    );
  return /* @__PURE__ */ f.jsx(ro, { children: t });
};
ua.propTypes = {
  buttonCount: l.number.isRequired
};
const da = ({ imageItems: e, onItemClick: t = () => null }) => {
  const n = (i, a) => {
    const { ariaSelected: d } = i.currentTarget.dataset;
    i.currentTarget.dataset.ariaSelected = String(!d), i.stopPropagation(), t(a);
  }, r = e.map((i, a) => /* @__PURE__ */ f.jsx(
    "button",
    {
      type: "button",
      role: "option",
      className: "bullet-image-container",
      "data-glide-dir": `=${a}`,
      "aria-label": `Slide view ${a + 1}`,
      "aria-selected": "false",
      onClick: (d) => n(d, a),
      onKeyDown: (d) => n(d, a),
      children: /* @__PURE__ */ f.jsx(
        "img",
        {
          src: i,
          alt: `Slide ${a + 1}`,
          className: "glide__bullet bullet-image",
          loading: "lazy",
          decoding: "async",
          fetchpriority: "low"
        }
      )
    },
    `bullet-${a}`
  ));
  return /* @__PURE__ */ f.jsx(ro, { children: r });
};
da.propTypes = {
  imageItems: l.arrayOf(l.string).isRequired,
  onItemClick: l.func
};
const io = ({ onClick: e = () => null }) => /* @__PURE__ */ f.jsx(
  "button",
  {
    type: "button",
    className: "glide__arrow glide__arrow--next",
    "data-glide-dir": ">",
    "aria-label": "Next slide",
    onClick: e,
    children: /* @__PURE__ */ f.jsx("i", { className: "fas fa-chevron-right arrow-icon" })
  }
);
io.propTypes = {
  onClick: l.func
};
const oo = ({ onClick: e = () => null }) => /* @__PURE__ */ f.jsx(
  "button",
  {
    type: "button",
    className: "glide__arrow glide__arrow--prev",
    "data-glide-dir": "<",
    "aria-label": "Previous slide",
    onClick: e,
    children: /* @__PURE__ */ f.jsx("span", { className: "fas fa-chevron-left arrow-icon" })
  }
);
oo.propTypes = {
  onClick: l.func
};
const gs = {
  event: "select",
  action: "click",
  name: "onclick",
  region: "main content",
  type: "carousel"
}, so = ({ children: e = null }) => /* @__PURE__ */ f.jsx(
  "div",
  {
    className: "glide__arrows",
    "data-glide-el": "controls",
    "data-testid": "arrows-container",
    children: e
  }
);
so.propTypes = {
  children: l.arrayOf(l.element)
};
const fa = ({ onClick: e = () => null, children: t = null }) => /* @__PURE__ */ f.jsxs(so, { children: [
  /* @__PURE__ */ f.jsx(Ye, { gaData: { ...gs, text: "left chevron" }, children: /* @__PURE__ */ f.jsx(oo, { onClick: e }) }),
  t,
  /* @__PURE__ */ f.jsx(Ye, { gaData: { ...gs, text: "right chevron" }, children: /* @__PURE__ */ f.jsx(io, { onClick: e }) })
] });
fa.propTypes = {
  children: l.element,
  onClick: l.func
};
const pa = ({ carouselItems: e }) => {
  const t = e.map((n) => /* @__PURE__ */ f.jsx("li", { className: "glide__slide slider", children: n.item }, n.id.toString()));
  return /* @__PURE__ */ f.jsx("ul", { className: "glide__slides", children: t });
};
pa.propTypes = {
  carouselItems: l.arrayOf(l.object)
};
function vs(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function ys(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? vs(Object(n), !0).forEach(function(r) {
      Iu(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : vs(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Mr(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Mr = function(t) {
    return typeof t;
  } : Mr = function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Mr(e);
}
function Xr(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Nu(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function Kr(e, t, n) {
  return t && Nu(e.prototype, t), e;
}
function Iu(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function Pu(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), t && zi(e, t);
}
function $n(e) {
  return $n = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, $n(e);
}
function zi(e, t) {
  return zi = Object.setPrototypeOf || function(r, i) {
    return r.__proto__ = i, r;
  }, zi(e, t);
}
function Lu() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Mu(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Du(e, t) {
  if (t && (typeof t == "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Mu(e);
}
function Fu(e) {
  var t = Lu();
  return function() {
    var r = $n(e), i;
    if (t) {
      var a = $n(this).constructor;
      i = Reflect.construct(r, arguments, a);
    } else
      i = r.apply(this, arguments);
    return Du(this, i);
  };
}
function $u(e, t) {
  for (; !Object.prototype.hasOwnProperty.call(e, t) && (e = $n(e), e !== null); )
    ;
  return e;
}
function Dr() {
  return typeof Reflect < "u" && Reflect.get ? Dr = Reflect.get : Dr = function(t, n, r) {
    var i = $u(t, n);
    if (i) {
      var a = Object.getOwnPropertyDescriptor(i, n);
      return a.get ? a.get.call(arguments.length < 3 ? t : r) : a.value;
    }
  }, Dr.apply(this, arguments);
}
var Bu = {
  /**
   * Type of the movement.
   *
   * Available types:
   * `slider` - Rewinds slider to the start/end when it reaches the first or last slide.
   * `carousel` - Changes slides without starting over when it reaches the first or last slide.
   *
   * @type {String}
   */
  type: "slider",
  /**
   * Start at specific slide number defined with zero-based index.
   *
   * @type {Number}
   */
  startAt: 0,
  /**
   * A number of slides visible on the single viewport.
   *
   * @type {Number}
   */
  perView: 1,
  /**
   * Focus currently active slide at a specified position in the track.
   *
   * Available inputs:
   * `center` - Current slide will be always focused at the center of a track.
   * `0,1,2,3...` - Current slide will be focused on the specified zero-based index.
   *
   * @type {String|Number}
   */
  focusAt: 0,
  /**
   * A size of the gap added between slides.
   *
   * @type {Number}
   */
  gap: 10,
  /**
   * Change slides after a specified interval. Use `false` for turning off autoplay.
   *
   * @type {Number|Boolean}
   */
  autoplay: !1,
  /**
   * Stop autoplay on mouseover event.
   *
   * @type {Boolean}
   */
  hoverpause: !0,
  /**
   * Allow for changing slides with left and right keyboard arrows.
   *
   * @type {Boolean}
   */
  keyboard: !0,
  /**
   * Stop running `perView` number of slides from the end. Use this
   * option if you don't want to have an empty space after
   * a slider. Works only with `slider` type and a
   * non-centered `focusAt` setting.
   *
   * @type {Boolean}
   */
  bound: !1,
  /**
   * Minimal swipe distance needed to change the slide. Use `false` for turning off a swiping.
   *
   * @type {Number|Boolean}
   */
  swipeThreshold: 80,
  /**
   * Minimal mouse drag distance needed to change the slide. Use `false` for turning off a dragging.
   *
   * @type {Number|Boolean}
   */
  dragThreshold: 120,
  /**
   * A number of slides moved on single swipe.
   *
   * Available types:
   * `` - Moves slider by one slide per swipe
   * `|` - Moves slider between views per swipe (number of slides defined in `perView` options)
   *
   * @type {String}
   */
  perSwipe: "",
  /**
   * Moving distance ratio of the slides on a swiping and dragging.
   *
   * @type {Number}
   */
  touchRatio: 0.5,
  /**
   * Angle required to activate slides moving on swiping or dragging.
   *
   * @type {Number}
   */
  touchAngle: 45,
  /**
   * Duration of the animation in milliseconds.
   *
   * @type {Number}
   */
  animationDuration: 400,
  /**
   * Allows looping the `slider` type. Slider will rewind to the first/last slide when it's at the start/end.
   *
   * @type {Boolean}
   */
  rewind: !0,
  /**
   * Duration of the rewinding animation of the `slider` type in milliseconds.
   *
   * @type {Number}
   */
  rewindDuration: 800,
  /**
   * Easing function for the animation.
   *
   * @type {String}
   */
  animationTimingFunc: "cubic-bezier(.165, .840, .440, 1)",
  /**
   * Wait for the animation to finish until the next user input can be processed
   *
   * @type {boolean}
   */
  waitForTransition: !0,
  /**
   * Throttle costly events at most once per every wait milliseconds.
   *
   * @type {Number}
   */
  throttle: 10,
  /**
   * Moving direction mode.
   *
   * Available inputs:
   * - 'ltr' - left to right movement,
   * - 'rtl' - right to left movement.
   *
   * @type {String}
   */
  direction: "ltr",
  /**
   * The distance value of the next and previous viewports which
   * have to peek in the current view. Accepts number and
   * pixels as a string. Left and right peeking can be
   * set up separately with a directions object.
   *
   * For example:
   * `100` - Peek 100px on the both sides.
   * { before: 100, after: 50 }` - Peek 100px on the left side and 50px on the right side.
   *
   * @type {Number|String|Object}
   */
  peek: 0,
  /**
   * Defines how many clones of current viewport will be generated.
   *
   * @type {Number}
   */
  cloningRatio: 1,
  /**
   * Collection of options applied at specified media breakpoints.
   * For example: display two slides per view under 800px.
   * `{
   *   '800px': {
   *     perView: 2
   *   }
   * }`
   */
  breakpoints: {},
  /**
   * Collection of internally used HTML classes.
   *
   * @todo Refactor `slider` and `carousel` properties to single `type: { slider: '', carousel: '' }` object
   * @type {Object}
   */
  classes: {
    swipeable: "glide--swipeable",
    dragging: "glide--dragging",
    direction: {
      ltr: "glide--ltr",
      rtl: "glide--rtl"
    },
    type: {
      slider: "glide--slider",
      carousel: "glide--carousel"
    },
    slide: {
      clone: "glide__slide--clone",
      active: "glide__slide--active"
    },
    arrow: {
      disabled: "glide__arrow--disabled"
    },
    nav: {
      active: "glide__bullet--active"
    }
  }
};
function Kt(e) {
  console.error("[Glide warn]: ".concat(e));
}
function et(e) {
  return parseInt(e);
}
function zu(e) {
  return parseFloat(e);
}
function Hi(e) {
  return typeof e == "string";
}
function Bn(e) {
  var t = Mr(e);
  return t === "function" || t === "object" && !!e;
}
function Vr(e) {
  return typeof e == "function";
}
function ha(e) {
  return typeof e > "u";
}
function Vi(e) {
  return e.constructor === Array;
}
function Hu(e, t, n) {
  var r = {};
  for (var i in t)
    Vr(t[i]) ? r[i] = t[i](e, r, n) : Kt("Extension must be a function");
  for (var a in r)
    Vr(r[a].mount) && r[a].mount();
  return r;
}
function Be(e, t, n) {
  Object.defineProperty(e, t, n);
}
function Vu(e) {
  return Object.keys(e).sort().reduce(function(t, n) {
    return t[n] = e[n], t[n], t;
  }, {});
}
function Wi(e, t) {
  var n = Object.assign({}, e, t);
  if (t.hasOwnProperty("classes")) {
    n.classes = Object.assign({}, e.classes, t.classes);
    var r = ["direction", "type", "slide", "arrow", "nav"];
    r.forEach(function(i) {
      t.classes.hasOwnProperty(i) && (n.classes[i] = ys(ys({}, e.classes[i]), t.classes[i]));
    });
  }
  return t.hasOwnProperty("breakpoints") && (n.breakpoints = Object.assign({}, e.breakpoints, t.breakpoints)), n;
}
var Wu = /* @__PURE__ */ function() {
  function e() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    Xr(this, e), this.events = t, this.hop = t.hasOwnProperty;
  }
  return Kr(e, [{
    key: "on",
    value: function(n, r) {
      if (Vi(n)) {
        for (var i = 0; i < n.length; i++)
          this.on(n[i], r);
        return;
      }
      this.hop.call(this.events, n) || (this.events[n] = []);
      var a = this.events[n].push(r) - 1;
      return {
        remove: function() {
          delete this.events[n][a];
        }
      };
    }
    /**
     * Runs registered handlers for specified event.
     *
     * @param {String|Array} event
     * @param {Object=} context
     */
  }, {
    key: "emit",
    value: function(n, r) {
      if (Vi(n)) {
        for (var i = 0; i < n.length; i++)
          this.emit(n[i], r);
        return;
      }
      this.hop.call(this.events, n) && this.events[n].forEach(function(a) {
        a(r || {});
      });
    }
  }]), e;
}(), qu = /* @__PURE__ */ function() {
  function e(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    Xr(this, e), this._c = {}, this._t = [], this._e = new Wu(), this.disabled = !1, this.selector = t, this.settings = Wi(Bu, n), this.index = this.settings.startAt;
  }
  return Kr(e, [{
    key: "mount",
    value: function() {
      var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      return this._e.emit("mount.before"), Bn(n) ? this._c = Hu(this, n, this._e) : Kt("You need to provide a object on `mount()`"), this._e.emit("mount.after"), this;
    }
    /**
     * Collects an instance `translate` transformers.
     *
     * @param  {Array} transformers Collection of transformers.
     * @return {Void}
     */
  }, {
    key: "mutate",
    value: function() {
      var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
      return Vi(n) ? this._t = n : Kt("You need to provide a array on `mutate()`"), this;
    }
    /**
     * Updates glide with specified settings.
     *
     * @param {Object} settings
     * @return {Glide}
     */
  }, {
    key: "update",
    value: function() {
      var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      return this.settings = Wi(this.settings, n), n.hasOwnProperty("startAt") && (this.index = n.startAt), this._e.emit("update"), this;
    }
    /**
     * Change slide with specified pattern. A pattern must be in the special format:
     * `>` - Move one forward
     * `<` - Move one backward
     * `={i}` - Go to {i} zero-based slide (eq. '=1', will go to second slide)
     * `>>` - Rewinds to end (last slide)
     * `<<` - Rewinds to start (first slide)
     * `|>` - Move one viewport forward
     * `|<` - Move one viewport backward
     *
     * @param {String} pattern
     * @return {Glide}
     */
  }, {
    key: "go",
    value: function(n) {
      return this._c.Run.make(n), this;
    }
    /**
     * Move track by specified distance.
     *
     * @param {String} distance
     * @return {Glide}
     */
  }, {
    key: "move",
    value: function(n) {
      return this._c.Transition.disable(), this._c.Move.make(n), this;
    }
    /**
     * Destroy instance and revert all changes done by this._c.
     *
     * @return {Glide}
     */
  }, {
    key: "destroy",
    value: function() {
      return this._e.emit("destroy"), this;
    }
    /**
     * Start instance autoplaying.
     *
     * @param {Boolean|Number} interval Run autoplaying with passed interval regardless of `autoplay` settings
     * @return {Glide}
     */
  }, {
    key: "play",
    value: function() {
      var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
      return n && (this.settings.autoplay = n), this._e.emit("play"), this;
    }
    /**
     * Stop instance autoplaying.
     *
     * @return {Glide}
     */
  }, {
    key: "pause",
    value: function() {
      return this._e.emit("pause"), this;
    }
    /**
     * Sets glide into a idle status.
     *
     * @return {Glide}
     */
  }, {
    key: "disable",
    value: function() {
      return this.disabled = !0, this;
    }
    /**
     * Sets glide into a active status.
     *
     * @return {Glide}
     */
  }, {
    key: "enable",
    value: function() {
      return this.disabled = !1, this;
    }
    /**
     * Adds cuutom event listener with handler.
     *
     * @param  {String|Array} event
     * @param  {Function} handler
     * @return {Glide}
     */
  }, {
    key: "on",
    value: function(n, r) {
      return this._e.on(n, r), this;
    }
    /**
     * Checks if glide is a precised type.
     *
     * @param  {String} name
     * @return {Boolean}
     */
  }, {
    key: "isType",
    value: function(n) {
      return this.settings.type === n;
    }
    /**
     * Gets value of the core options.
     *
     * @return {Object}
     */
  }, {
    key: "settings",
    get: function() {
      return this._o;
    },
    set: function(n) {
      Bn(n) ? this._o = n : Kt("Options must be an `object` instance.");
    }
    /**
     * Gets current index of the slider.
     *
     * @return {Object}
     */
  }, {
    key: "index",
    get: function() {
      return this._i;
    },
    set: function(n) {
      this._i = et(n);
    }
    /**
     * Gets type name of the slider.
     *
     * @return {String}
     */
  }, {
    key: "type",
    get: function() {
      return this.settings.type;
    }
    /**
     * Gets value of the idle status.
     *
     * @return {Boolean}
     */
  }, {
    key: "disabled",
    get: function() {
      return this._d;
    },
    set: function(n) {
      this._d = !!n;
    }
  }]), e;
}();
function Uu(e, t, n) {
  var r = {
    /**
     * Initializes autorunning of the glide.
     *
     * @return {Void}
     */
    mount: function() {
      this._o = !1;
    },
    /**
     * Makes glides running based on the passed moving schema.
     *
     * @param {String} move
     */
    make: function(h) {
      var b = this;
      e.disabled || (!e.settings.waitForTransition || e.disable(), this.move = h, n.emit("run.before", this.move), this.calculate(), n.emit("run", this.move), t.Transition.after(function() {
        b.isStart() && n.emit("run.start", b.move), b.isEnd() && n.emit("run.end", b.move), b.isOffset() && (b._o = !1, n.emit("run.offset", b.move)), n.emit("run.after", b.move), e.enable();
      }));
    },
    /**
     * Calculates current index based on defined move.
     *
     * @return {Number|Undefined}
     */
    calculate: function() {
      var h = this.move, b = this.length, k = h.steps, _ = h.direction, I = 1;
      if (_ === "=") {
        if (e.settings.bound && et(k) > b) {
          e.index = b;
          return;
        }
        e.index = k;
        return;
      }
      if (_ === ">" && k === ">") {
        e.index = b;
        return;
      }
      if (_ === "<" && k === "<") {
        e.index = 0;
        return;
      }
      if (_ === "|" && (I = e.settings.perView || 1), _ === ">" || _ === "|" && k === ">") {
        var C = i(I);
        C > b && (this._o = !0), e.index = a(C, I);
        return;
      }
      if (_ === "<" || _ === "|" && k === "<") {
        var w = d(I);
        w < 0 && (this._o = !0), e.index = p(w, I);
        return;
      }
      Kt("Invalid direction pattern [".concat(_).concat(k, "] has been used"));
    },
    /**
     * Checks if we are on the first slide.
     *
     * @return {Boolean}
     */
    isStart: function() {
      return e.index <= 0;
    },
    /**
     * Checks if we are on the last slide.
     *
     * @return {Boolean}
     */
    isEnd: function() {
      return e.index >= this.length;
    },
    /**
     * Checks if we are making a offset run.
     *
     * @param {String} direction
     * @return {Boolean}
     */
    isOffset: function() {
      var h = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : void 0;
      return h ? this._o ? h === "|>" ? this.move.direction === "|" && this.move.steps === ">" : h === "|<" ? this.move.direction === "|" && this.move.steps === "<" : this.move.direction === h : !1 : this._o;
    },
    /**
     * Checks if bound mode is active
     *
     * @return {Boolean}
     */
    isBound: function() {
      return e.isType("slider") && e.settings.focusAt !== "center" && e.settings.bound;
    }
  };
  function i(m) {
    var h = e.index;
    return e.isType("carousel") ? h + m : h + (m - h % m);
  }
  function a(m, h) {
    var b = r.length;
    return m <= b ? m : e.isType("carousel") ? m - (b + 1) : e.settings.rewind ? r.isBound() && !r.isEnd() ? b : 0 : r.isBound() ? b : Math.floor(b / h) * h;
  }
  function d(m) {
    var h = e.index;
    if (e.isType("carousel"))
      return h - m;
    var b = Math.ceil(h / m);
    return (b - 1) * m;
  }
  function p(m, h) {
    var b = r.length;
    return m >= 0 ? m : e.isType("carousel") ? m + (b + 1) : e.settings.rewind ? r.isBound() && r.isStart() ? b : Math.floor(b / h) * h : 0;
  }
  return Be(r, "move", {
    /**
     * Gets value of the move schema.
     *
     * @returns {Object}
     */
    get: function() {
      return this._m;
    },
    /**
     * Sets value of the move schema.
     *
     * @returns {Object}
     */
    set: function(h) {
      var b = h.substr(1);
      this._m = {
        direction: h.substr(0, 1),
        steps: b ? et(b) ? et(b) : b : 0
      };
    }
  }), Be(r, "length", {
    /**
     * Gets value of the running distance based
     * on zero-indexing number of slides.
     *
     * @return {Number}
     */
    get: function() {
      var h = e.settings, b = t.Html.slides.length;
      return this.isBound() ? b - 1 - (et(h.perView) - 1) + et(h.focusAt) : b - 1;
    }
  }), Be(r, "offset", {
    /**
     * Gets status of the offsetting flag.
     *
     * @return {Boolean}
     */
    get: function() {
      return this._o;
    }
  }), r;
}
function xs() {
  return (/* @__PURE__ */ new Date()).getTime();
}
function Zr(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r, i, a, d, p = 0, m = function() {
    p = n.leading === !1 ? 0 : xs(), r = null, d = e.apply(i, a), r || (i = a = null);
  }, h = function() {
    var k = xs();
    !p && n.leading === !1 && (p = k);
    var _ = t - (k - p);
    return i = this, a = arguments, _ <= 0 || _ > t ? (r && (clearTimeout(r), r = null), p = k, d = e.apply(i, a), r || (i = a = null)) : !r && n.trailing !== !1 && (r = setTimeout(m, _)), d;
  };
  return h.cancel = function() {
    clearTimeout(r), p = 0, r = i = a = null;
  }, h;
}
var Or = {
  ltr: ["marginLeft", "marginRight"],
  rtl: ["marginRight", "marginLeft"]
};
function Yu(e, t, n) {
  var r = {
    /**
     * Applies gaps between slides. First and last
     * slides do not receive it's edge margins.
     *
     * @param {HTMLCollection} slides
     * @return {Void}
     */
    apply: function(a) {
      for (var d = 0, p = a.length; d < p; d++) {
        var m = a[d].style, h = t.Direction.value;
        d !== 0 ? m[Or[h][0]] = "".concat(this.value / 2, "px") : m[Or[h][0]] = "", d !== a.length - 1 ? m[Or[h][1]] = "".concat(this.value / 2, "px") : m[Or[h][1]] = "";
      }
    },
    /**
     * Removes gaps from the slides.
     *
     * @param {HTMLCollection} slides
     * @returns {Void}
    */
    remove: function(a) {
      for (var d = 0, p = a.length; d < p; d++) {
        var m = a[d].style;
        m.marginLeft = "", m.marginRight = "";
      }
    }
  };
  return Be(r, "value", {
    /**
     * Gets value of the gap.
     *
     * @returns {Number}
     */
    get: function() {
      return et(e.settings.gap);
    }
  }), Be(r, "grow", {
    /**
     * Gets additional dimensions value caused by gaps.
     * Used to increase width of the slides wrapper.
     *
     * @returns {Number}
     */
    get: function() {
      return r.value * t.Sizes.length;
    }
  }), Be(r, "reductor", {
    /**
     * Gets reduction value caused by gaps.
     * Used to subtract width of the slides.
     *
     * @returns {Number}
     */
    get: function() {
      var a = e.settings.perView;
      return r.value * (a - 1) / a;
    }
  }), n.on(["build.after", "update"], Zr(function() {
    r.apply(t.Html.wrapper.children);
  }, 30)), n.on("destroy", function() {
    r.remove(t.Html.wrapper.children);
  }), r;
}
function ma(e) {
  if (e && e.parentNode) {
    for (var t = e.parentNode.firstChild, n = []; t; t = t.nextSibling)
      t.nodeType === 1 && t !== e && n.push(t);
    return n;
  }
  return [];
}
function qi(e) {
  return Array.prototype.slice.call(e);
}
var Gu = '[data-glide-el="track"]';
function Xu(e, t, n) {
  var r = {
    /**
     * Setup slider HTML nodes.
     *
     * @param {Glide} glide
     */
    mount: function() {
      this.root = e.selector, this.track = this.root.querySelector(Gu), this.collectSlides();
    },
    /**
     * Collect slides
     */
    collectSlides: function() {
      this.slides = qi(this.wrapper.children).filter(function(a) {
        return !a.classList.contains(e.settings.classes.slide.clone);
      });
    }
  };
  return Be(r, "root", {
    /**
     * Gets node of the glide main element.
     *
     * @return {Object}
     */
    get: function() {
      return r._r;
    },
    /**
     * Sets node of the glide main element.
     *
     * @return {Object}
     */
    set: function(a) {
      Hi(a) && (a = document.querySelector(a)), a !== null ? r._r = a : Kt("Root element must be a existing Html node");
    }
  }), Be(r, "track", {
    /**
     * Gets node of the glide track with slides.
     *
     * @return {Object}
     */
    get: function() {
      return r._t;
    },
    /**
     * Sets node of the glide track with slides.
     *
     * @return {Object}
     */
    set: function(a) {
      r._t = a;
    }
  }), Be(r, "wrapper", {
    /**
     * Gets node of the slides wrapper.
     *
     * @return {Object}
     */
    get: function() {
      return r.track.children[0];
    }
  }), n.on("update", function() {
    r.collectSlides();
  }), r;
}
function Ku(e, t, n) {
  var r = {
    /**
     * Setups how much to peek based on settings.
     *
     * @return {Void}
     */
    mount: function() {
      this.value = e.settings.peek;
    }
  };
  return Be(r, "value", {
    /**
     * Gets value of the peek.
     *
     * @returns {Number|Object}
     */
    get: function() {
      return r._v;
    },
    /**
     * Sets value of the peek.
     *
     * @param {Number|Object} value
     * @return {Void}
     */
    set: function(a) {
      Bn(a) ? (a.before = et(a.before), a.after = et(a.after)) : a = et(a), r._v = a;
    }
  }), Be(r, "reductor", {
    /**
     * Gets reduction value caused by peek.
     *
     * @returns {Number}
     */
    get: function() {
      var a = r.value, d = e.settings.perView;
      return Bn(a) ? a.before / d + a.after / d : a * 2 / d;
    }
  }), n.on(["resize", "update"], function() {
    r.mount();
  }), r;
}
function Zu(e, t, n) {
  var r = {
    /**
     * Constructs move component.
     *
     * @returns {Void}
     */
    mount: function() {
      this._o = 0;
    },
    /**
     * Calculates a movement value based on passed offset and currently active index.
     *
     * @param  {Number} offset
     * @return {Void}
     */
    make: function() {
      var a = this, d = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
      this.offset = d, n.emit("move", {
        movement: this.value
      }), t.Transition.after(function() {
        n.emit("move.after", {
          movement: a.value
        });
      });
    }
  };
  return Be(r, "offset", {
    /**
     * Gets an offset value used to modify current translate.
     *
     * @return {Object}
     */
    get: function() {
      return r._o;
    },
    /**
     * Sets an offset value used to modify current translate.
     *
     * @return {Object}
     */
    set: function(a) {
      r._o = ha(a) ? 0 : et(a);
    }
  }), Be(r, "translate", {
    /**
     * Gets a raw movement value.
     *
     * @return {Number}
     */
    get: function() {
      return t.Sizes.slideWidth * e.index;
    }
  }), Be(r, "value", {
    /**
     * Gets an actual movement value corrected by offset.
     *
     * @return {Number}
     */
    get: function() {
      var a = this.offset, d = this.translate;
      return t.Direction.is("rtl") ? d + a : d - a;
    }
  }), n.on(["build.before", "run"], function() {
    r.make();
  }), r;
}
function Ju(e, t, n) {
  var r = {
    /**
     * Setups dimensions of slides.
     *
     * @return {Void}
     */
    setupSlides: function() {
      for (var a = "".concat(this.slideWidth, "px"), d = t.Html.slides, p = 0; p < d.length; p++)
        d[p].style.width = a;
    },
    /**
     * Setups dimensions of slides wrapper.
     *
     * @return {Void}
     */
    setupWrapper: function() {
      t.Html.wrapper.style.width = "".concat(this.wrapperSize, "px");
    },
    /**
     * Removes applied styles from HTML elements.
     *
     * @returns {Void}
     */
    remove: function() {
      for (var a = t.Html.slides, d = 0; d < a.length; d++)
        a[d].style.width = "";
      t.Html.wrapper.style.width = "";
    }
  };
  return Be(r, "length", {
    /**
     * Gets count number of the slides.
     *
     * @return {Number}
     */
    get: function() {
      return t.Html.slides.length;
    }
  }), Be(r, "width", {
    /**
     * Gets width value of the slider (visible area).
     *
     * @return {Number}
     */
    get: function() {
      return t.Html.track.offsetWidth;
    }
  }), Be(r, "wrapperSize", {
    /**
     * Gets size of the slides wrapper.
     *
     * @return {Number}
     */
    get: function() {
      return r.slideWidth * r.length + t.Gaps.grow + t.Clones.grow;
    }
  }), Be(r, "slideWidth", {
    /**
     * Gets width value of a single slide.
     *
     * @return {Number}
     */
    get: function() {
      return r.width / e.settings.perView - t.Peek.reductor - t.Gaps.reductor;
    }
  }), n.on(["build.before", "resize", "update"], function() {
    r.setupSlides(), r.setupWrapper();
  }), n.on("destroy", function() {
    r.remove();
  }), r;
}
function Qu(e, t, n) {
  var r = {
    /**
     * Init glide building. Adds classes, sets
     * dimensions and setups initial state.
     *
     * @return {Void}
     */
    mount: function() {
      n.emit("build.before"), this.typeClass(), this.activeClass(), n.emit("build.after");
    },
    /**
     * Adds `type` class to the glide element.
     *
     * @return {Void}
     */
    typeClass: function() {
      t.Html.root.classList.add(e.settings.classes.type[e.settings.type]);
    },
    /**
     * Sets active class to current slide.
     *
     * @return {Void}
     */
    activeClass: function() {
      var a = e.settings.classes, d = t.Html.slides[e.index];
      d && (d.classList.add(a.slide.active), ma(d).forEach(function(p) {
        p.classList.remove(a.slide.active);
      }));
    },
    /**
     * Removes HTML classes applied at building.
     *
     * @return {Void}
     */
    removeClasses: function() {
      var a = e.settings.classes, d = a.type, p = a.slide;
      t.Html.root.classList.remove(d[e.settings.type]), t.Html.slides.forEach(function(m) {
        m.classList.remove(p.active);
      });
    }
  };
  return n.on(["destroy", "update"], function() {
    r.removeClasses();
  }), n.on(["resize", "update"], function() {
    r.mount();
  }), n.on("move.after", function() {
    r.activeClass();
  }), r;
}
function ed(e, t, n) {
  var r = {
    /**
     * Create pattern map and collect slides to be cloned.
     */
    mount: function() {
      this.items = [], e.isType("carousel") && (this.items = this.collect());
    },
    /**
     * Collect clones with pattern.
     *
     * @return {[]}
     */
    collect: function() {
      var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], d = t.Html.slides, p = e.settings, m = p.perView, h = p.classes, b = p.cloningRatio;
      if (d.length > 0)
        for (var k = +!!e.settings.peek, _ = m + k + Math.round(m / 2), I = d.slice(0, _).reverse(), C = d.slice(_ * -1), w = 0; w < Math.max(b, Math.floor(m / d.length)); w++) {
          for (var N = 0; N < I.length; N++) {
            var M = I[N].cloneNode(!0);
            M.classList.add(h.slide.clone), a.push(M);
          }
          for (var D = 0; D < C.length; D++) {
            var V = C[D].cloneNode(!0);
            V.classList.add(h.slide.clone), a.unshift(V);
          }
        }
      return a;
    },
    /**
     * Append cloned slides with generated pattern.
     *
     * @return {Void}
     */
    append: function() {
      for (var a = this.items, d = t.Html, p = d.wrapper, m = d.slides, h = Math.floor(a.length / 2), b = a.slice(0, h).reverse(), k = a.slice(h * -1).reverse(), _ = "".concat(t.Sizes.slideWidth, "px"), I = 0; I < k.length; I++)
        p.appendChild(k[I]);
      for (var C = 0; C < b.length; C++)
        p.insertBefore(b[C], m[0]);
      for (var w = 0; w < a.length; w++)
        a[w].style.width = _;
    },
    /**
     * Remove all cloned slides.
     *
     * @return {Void}
     */
    remove: function() {
      for (var a = this.items, d = 0; d < a.length; d++)
        t.Html.wrapper.removeChild(a[d]);
    }
  };
  return Be(r, "grow", {
    /**
     * Gets additional dimensions value caused by clones.
     *
     * @return {Number}
     */
    get: function() {
      return (t.Sizes.slideWidth + t.Gaps.value) * r.items.length;
    }
  }), n.on("update", function() {
    r.remove(), r.mount(), r.append();
  }), n.on("build.before", function() {
    e.isType("carousel") && r.append();
  }), n.on("destroy", function() {
    r.remove();
  }), r;
}
var un = /* @__PURE__ */ function() {
  function e() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    Xr(this, e), this.listeners = t;
  }
  return Kr(e, [{
    key: "on",
    value: function(n, r, i) {
      var a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
      Hi(n) && (n = [n]);
      for (var d = 0; d < n.length; d++)
        this.listeners[n[d]] = i, r.addEventListener(n[d], this.listeners[n[d]], a);
    }
    /**
     * Removes event listeners from arrows HTML elements.
     *
     * @param  {String|Array} events
     * @param  {Element|Window|Document} el
     * @param  {Boolean|Object} capture
     * @return {Void}
     */
  }, {
    key: "off",
    value: function(n, r) {
      var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
      Hi(n) && (n = [n]);
      for (var a = 0; a < n.length; a++)
        r.removeEventListener(n[a], this.listeners[n[a]], i);
    }
    /**
     * Destroy collected listeners.
     *
     * @returns {Void}
     */
  }, {
    key: "destroy",
    value: function() {
      delete this.listeners;
    }
  }]), e;
}();
function td(e, t, n) {
  var r = new un(), i = {
    /**
     * Initializes window bindings.
     */
    mount: function() {
      this.bind();
    },
    /**
     * Binds `rezsize` listener to the window.
     * It's a costly event, so we are debouncing it.
     *
     * @return {Void}
     */
    bind: function() {
      r.on("resize", window, Zr(function() {
        n.emit("resize");
      }, e.settings.throttle));
    },
    /**
     * Unbinds listeners from the window.
     *
     * @return {Void}
     */
    unbind: function() {
      r.off("resize", window);
    }
  };
  return n.on("destroy", function() {
    i.unbind(), r.destroy();
  }), i;
}
var nd = ["ltr", "rtl"], rd = {
  ">": "<",
  "<": ">",
  "=": "="
};
function id(e, t, n) {
  var r = {
    /**
     * Setups gap value based on settings.
     *
     * @return {Void}
     */
    mount: function() {
      this.value = e.settings.direction;
    },
    /**
     * Resolves pattern based on direction value
     *
     * @param {String} pattern
     * @returns {String}
     */
    resolve: function(a) {
      var d = a.slice(0, 1);
      return this.is("rtl") ? a.split(d).join(rd[d]) : a;
    },
    /**
     * Checks value of direction mode.
     *
     * @param {String} direction
     * @returns {Boolean}
     */
    is: function(a) {
      return this.value === a;
    },
    /**
     * Applies direction class to the root HTML element.
     *
     * @return {Void}
     */
    addClass: function() {
      t.Html.root.classList.add(e.settings.classes.direction[this.value]);
    },
    /**
     * Removes direction class from the root HTML element.
     *
     * @return {Void}
     */
    removeClass: function() {
      t.Html.root.classList.remove(e.settings.classes.direction[this.value]);
    }
  };
  return Be(r, "value", {
    /**
     * Gets value of the direction.
     *
     * @returns {Number}
     */
    get: function() {
      return r._v;
    },
    /**
     * Sets value of the direction.
     *
     * @param {String} value
     * @return {Void}
     */
    set: function(a) {
      nd.indexOf(a) > -1 ? r._v = a : Kt("Direction value must be `ltr` or `rtl`");
    }
  }), n.on(["destroy", "update"], function() {
    r.removeClass();
  }), n.on("update", function() {
    r.mount();
  }), n.on(["build.before", "update"], function() {
    r.addClass();
  }), r;
}
function od(e, t) {
  return {
    /**
     * Negates the passed translate if glide is in RTL option.
     *
     * @param  {Number} translate
     * @return {Number}
     */
    modify: function(r) {
      return t.Direction.is("rtl") ? -r : r;
    }
  };
}
function sd(e, t) {
  return {
    /**
     * Modifies passed translate value with number in the `gap` settings.
     *
     * @param  {Number} translate
     * @return {Number}
     */
    modify: function(r) {
      var i = Math.floor(r / t.Sizes.slideWidth);
      return r + t.Gaps.value * i;
    }
  };
}
function ad(e, t) {
  return {
    /**
     * Adds to the passed translate width of the half of clones.
     *
     * @param  {Number} translate
     * @return {Number}
     */
    modify: function(r) {
      return r + t.Clones.grow / 2;
    }
  };
}
function ld(e, t) {
  return {
    /**
     * Modifies passed translate value with a `peek` setting.
     *
     * @param  {Number} translate
     * @return {Number}
     */
    modify: function(r) {
      if (e.settings.focusAt >= 0) {
        var i = t.Peek.value;
        return Bn(i) ? r - i.before : r - i;
      }
      return r;
    }
  };
}
function cd(e, t) {
  return {
    /**
     * Modifies passed translate value with index in the `focusAt` setting.
     *
     * @param  {Number} translate
     * @return {Number}
     */
    modify: function(r) {
      var i = t.Gaps.value, a = t.Sizes.width, d = e.settings.focusAt, p = t.Sizes.slideWidth;
      return d === "center" ? r - (a / 2 - p / 2) : r - p * d - i * d;
    }
  };
}
function ud(e, t, n) {
  var r = [sd, ad, ld, cd].concat(e._t, [od]);
  return {
    /**
     * Piplines translate value with registered transformers.
     *
     * @param  {Number} translate
     * @return {Number}
     */
    mutate: function(a) {
      for (var d = 0; d < r.length; d++) {
        var p = r[d];
        Vr(p) && Vr(p().modify) ? a = p(e, t, n).modify(a) : Kt("Transformer should be a function that returns an object with `modify()` method");
      }
      return a;
    }
  };
}
function dd(e, t, n) {
  var r = {
    /**
     * Sets value of translate on HTML element.
     *
     * @param {Number} value
     * @return {Void}
     */
    set: function(a) {
      var d = ud(e, t).mutate(a), p = "translate3d(".concat(-1 * d, "px, 0px, 0px)");
      t.Html.wrapper.style.mozTransform = p, t.Html.wrapper.style.webkitTransform = p, t.Html.wrapper.style.transform = p;
    },
    /**
     * Removes value of translate from HTML element.
     *
     * @return {Void}
     */
    remove: function() {
      t.Html.wrapper.style.transform = "";
    },
    /**
     * @return {number}
     */
    getStartIndex: function() {
      var a = t.Sizes.length, d = e.index, p = e.settings.perView;
      return t.Run.isOffset(">") || t.Run.isOffset("|>") ? a + (d - p) : (d + p) % a;
    },
    /**
     * @return {number}
     */
    getTravelDistance: function() {
      var a = t.Sizes.slideWidth * e.settings.perView;
      return t.Run.isOffset(">") || t.Run.isOffset("|>") ? a * -1 : a;
    }
  };
  return n.on("move", function(i) {
    if (!e.isType("carousel") || !t.Run.isOffset())
      return r.set(i.movement);
    t.Transition.after(function() {
      n.emit("translate.jump"), r.set(t.Sizes.slideWidth * e.index);
    });
    var a = t.Sizes.slideWidth * t.Translate.getStartIndex();
    return r.set(a - t.Translate.getTravelDistance());
  }), n.on("destroy", function() {
    r.remove();
  }), r;
}
function fd(e, t, n) {
  var r = !1, i = {
    /**
     * Composes string of the CSS transition.
     *
     * @param {String} property
     * @return {String}
     */
    compose: function(d) {
      var p = e.settings;
      return r ? "".concat(d, " 0ms ").concat(p.animationTimingFunc) : "".concat(d, " ").concat(this.duration, "ms ").concat(p.animationTimingFunc);
    },
    /**
     * Sets value of transition on HTML element.
     *
     * @param {String=} property
     * @return {Void}
     */
    set: function() {
      var d = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "transform";
      t.Html.wrapper.style.transition = this.compose(d);
    },
    /**
     * Removes value of transition from HTML element.
     *
     * @return {Void}
     */
    remove: function() {
      t.Html.wrapper.style.transition = "";
    },
    /**
     * Runs callback after animation.
     *
     * @param  {Function} callback
     * @return {Void}
     */
    after: function(d) {
      setTimeout(function() {
        d();
      }, this.duration);
    },
    /**
     * Enable transition.
     *
     * @return {Void}
     */
    enable: function() {
      r = !1, this.set();
    },
    /**
     * Disable transition.
     *
     * @return {Void}
     */
    disable: function() {
      r = !0, this.set();
    }
  };
  return Be(i, "duration", {
    /**
     * Gets duration of the transition based
     * on currently running animation type.
     *
     * @return {Number}
     */
    get: function() {
      var d = e.settings;
      return e.isType("slider") && t.Run.offset ? d.rewindDuration : d.animationDuration;
    }
  }), n.on("move", function() {
    i.set();
  }), n.on(["build.before", "resize", "translate.jump"], function() {
    i.disable();
  }), n.on("run", function() {
    i.enable();
  }), n.on("destroy", function() {
    i.remove();
  }), i;
}
var ga = !1;
try {
  var bs = Object.defineProperty({}, "passive", {
    get: function() {
      ga = !0;
    }
  });
  window.addEventListener("testPassive", null, bs), window.removeEventListener("testPassive", null, bs);
} catch {
}
var Ui = ga, Ar = ["touchstart", "mousedown"], ws = ["touchmove", "mousemove"], Ss = ["touchend", "touchcancel", "mouseup", "mouseleave"], ks = ["mousedown", "mousemove", "mouseup", "mouseleave"];
function pd(e, t, n) {
  var r = new un(), i = 0, a = 0, d = 0, p = !1, m = Ui ? {
    passive: !0
  } : !1, h = {
    /**
     * Initializes swipe bindings.
     *
     * @return {Void}
     */
    mount: function() {
      this.bindSwipeStart();
    },
    /**
     * Handler for `swipestart` event. Calculates entry points of the user's tap.
     *
     * @param {Object} event
     * @return {Void}
     */
    start: function(k) {
      if (!p && !e.disabled) {
        this.disable();
        var _ = this.touches(k);
        i = null, a = et(_.pageX), d = et(_.pageY), this.bindSwipeMove(), this.bindSwipeEnd(), n.emit("swipe.start");
      }
    },
    /**
     * Handler for `swipemove` event. Calculates user's tap angle and distance.
     *
     * @param {Object} event
     */
    move: function(k) {
      if (!e.disabled) {
        var _ = e.settings, I = _.touchAngle, C = _.touchRatio, w = _.classes, N = this.touches(k), M = et(N.pageX) - a, D = et(N.pageY) - d, V = Math.abs(M << 2), W = Math.abs(D << 2), A = Math.sqrt(V + W), X = Math.sqrt(W);
        if (i = Math.asin(X / A), i * 180 / Math.PI < I)
          k.stopPropagation(), t.Move.make(M * zu(C)), t.Html.root.classList.add(w.dragging), n.emit("swipe.move");
        else
          return !1;
      }
    },
    /**
     * Handler for `swipeend` event. Finitializes user's tap and decides about glide move.
     *
     * @param {Object} event
     * @return {Void}
     */
    end: function(k) {
      if (!e.disabled) {
        var _ = e.settings, I = _.perSwipe, C = _.touchAngle, w = _.classes, N = this.touches(k), M = this.threshold(k), D = N.pageX - a, V = i * 180 / Math.PI;
        this.enable(), D > M && V < C ? t.Run.make(t.Direction.resolve("".concat(I, "<"))) : D < -M && V < C ? t.Run.make(t.Direction.resolve("".concat(I, ">"))) : t.Move.make(), t.Html.root.classList.remove(w.dragging), this.unbindSwipeMove(), this.unbindSwipeEnd(), n.emit("swipe.end");
      }
    },
    /**
     * Binds swipe's starting event.
     *
     * @return {Void}
     */
    bindSwipeStart: function() {
      var k = this, _ = e.settings, I = _.swipeThreshold, C = _.dragThreshold;
      I && r.on(Ar[0], t.Html.wrapper, function(w) {
        k.start(w);
      }, m), C && r.on(Ar[1], t.Html.wrapper, function(w) {
        k.start(w);
      }, m);
    },
    /**
     * Unbinds swipe's starting event.
     *
     * @return {Void}
     */
    unbindSwipeStart: function() {
      r.off(Ar[0], t.Html.wrapper, m), r.off(Ar[1], t.Html.wrapper, m);
    },
    /**
     * Binds swipe's moving event.
     *
     * @return {Void}
     */
    bindSwipeMove: function() {
      var k = this;
      r.on(ws, t.Html.wrapper, Zr(function(_) {
        k.move(_);
      }, e.settings.throttle), m);
    },
    /**
     * Unbinds swipe's moving event.
     *
     * @return {Void}
     */
    unbindSwipeMove: function() {
      r.off(ws, t.Html.wrapper, m);
    },
    /**
     * Binds swipe's ending event.
     *
     * @return {Void}
     */
    bindSwipeEnd: function() {
      var k = this;
      r.on(Ss, t.Html.wrapper, function(_) {
        k.end(_);
      });
    },
    /**
     * Unbinds swipe's ending event.
     *
     * @return {Void}
     */
    unbindSwipeEnd: function() {
      r.off(Ss, t.Html.wrapper);
    },
    /**
     * Normalizes event touches points accorting to different types.
     *
     * @param {Object} event
     */
    touches: function(k) {
      return ks.indexOf(k.type) > -1 ? k : k.touches[0] || k.changedTouches[0];
    },
    /**
     * Gets value of minimum swipe distance settings based on event type.
     *
     * @return {Number}
     */
    threshold: function(k) {
      var _ = e.settings;
      return ks.indexOf(k.type) > -1 ? _.dragThreshold : _.swipeThreshold;
    },
    /**
     * Enables swipe event.
     *
     * @return {self}
     */
    enable: function() {
      return p = !1, t.Transition.enable(), this;
    },
    /**
     * Disables swipe event.
     *
     * @return {self}
     */
    disable: function() {
      return p = !0, t.Transition.disable(), this;
    }
  };
  return n.on("build.after", function() {
    t.Html.root.classList.add(e.settings.classes.swipeable);
  }), n.on("destroy", function() {
    h.unbindSwipeStart(), h.unbindSwipeMove(), h.unbindSwipeEnd(), r.destroy();
  }), h;
}
function hd(e, t, n) {
  var r = new un(), i = {
    /**
     * Binds listener to glide wrapper.
     *
     * @return {Void}
     */
    mount: function() {
      this.bind();
    },
    /**
     * Binds `dragstart` event on wrapper to prevent dragging images.
     *
     * @return {Void}
     */
    bind: function() {
      r.on("dragstart", t.Html.wrapper, this.dragstart);
    },
    /**
     * Unbinds `dragstart` event on wrapper.
     *
     * @return {Void}
     */
    unbind: function() {
      r.off("dragstart", t.Html.wrapper);
    },
    /**
     * Event handler. Prevents dragging.
     *
     * @return {Void}
     */
    dragstart: function(d) {
      d.preventDefault();
    }
  };
  return n.on("destroy", function() {
    i.unbind(), r.destroy();
  }), i;
}
function md(e, t, n) {
  var r = new un(), i = !1, a = !1, d = {
    /**
     * Setups a initial state of anchors component.
     *
     * @returns {Void}
     */
    mount: function() {
      this._a = t.Html.wrapper.querySelectorAll("a"), this.bind();
    },
    /**
     * Binds events to anchors inside a track.
     *
     * @return {Void}
     */
    bind: function() {
      r.on("click", t.Html.wrapper, this.click);
    },
    /**
     * Unbinds events attached to anchors inside a track.
     *
     * @return {Void}
     */
    unbind: function() {
      r.off("click", t.Html.wrapper);
    },
    /**
     * Handler for click event. Prevents clicks when glide is in `prevent` status.
     *
     * @param  {Object} event
     * @return {Void}
     */
    click: function(m) {
      a && (m.stopPropagation(), m.preventDefault());
    },
    /**
     * Detaches anchors click event inside glide.
     *
     * @return {self}
     */
    detach: function() {
      if (a = !0, !i) {
        for (var m = 0; m < this.items.length; m++)
          this.items[m].draggable = !1;
        i = !0;
      }
      return this;
    },
    /**
     * Attaches anchors click events inside glide.
     *
     * @return {self}
     */
    attach: function() {
      if (a = !1, i) {
        for (var m = 0; m < this.items.length; m++)
          this.items[m].draggable = !0;
        i = !1;
      }
      return this;
    }
  };
  return Be(d, "items", {
    /**
     * Gets collection of the arrows HTML elements.
     *
     * @return {HTMLElement[]}
     */
    get: function() {
      return d._a;
    }
  }), n.on("swipe.move", function() {
    d.detach();
  }), n.on("swipe.end", function() {
    t.Transition.after(function() {
      d.attach();
    });
  }), n.on("destroy", function() {
    d.attach(), d.unbind(), r.destroy();
  }), d;
}
var gd = '[data-glide-el="controls[nav]"]', ao = '[data-glide-el^="controls"]', vd = "".concat(ao, ' [data-glide-dir*="<"]'), yd = "".concat(ao, ' [data-glide-dir*=">"]');
function xd(e, t, n) {
  var r = new un(), i = Ui ? {
    passive: !0
  } : !1, a = {
    /**
     * Inits arrows. Binds events listeners
     * to the arrows HTML elements.
     *
     * @return {Void}
     */
    mount: function() {
      this._n = t.Html.root.querySelectorAll(gd), this._c = t.Html.root.querySelectorAll(ao), this._arrowControls = {
        previous: t.Html.root.querySelectorAll(vd),
        next: t.Html.root.querySelectorAll(yd)
      }, this.addBindings();
    },
    /**
     * Sets active class to current slide.
     *
     * @return {Void}
     */
    setActive: function() {
      for (var p = 0; p < this._n.length; p++)
        this.addClass(this._n[p].children);
    },
    /**
     * Removes active class to current slide.
     *
     * @return {Void}
     */
    removeActive: function() {
      for (var p = 0; p < this._n.length; p++)
        this.removeClass(this._n[p].children);
    },
    /**
     * Toggles active class on items inside navigation.
     *
     * @param  {HTMLElement} controls
     * @return {Void}
     */
    addClass: function(p) {
      var m = e.settings, h = p[e.index];
      h && (h.classList.add(m.classes.nav.active), ma(h).forEach(function(b) {
        b.classList.remove(m.classes.nav.active);
      }));
    },
    /**
     * Removes active class from active control.
     *
     * @param  {HTMLElement} controls
     * @return {Void}
     */
    removeClass: function(p) {
      var m = p[e.index];
      m == null || m.classList.remove(e.settings.classes.nav.active);
    },
    /**
     * Calculates, removes or adds `Glide.settings.classes.disabledArrow` class on the control arrows
     */
    setArrowState: function() {
      if (!e.settings.rewind) {
        var p = a._arrowControls.next, m = a._arrowControls.previous;
        this.resetArrowState(p, m), e.index === 0 && this.disableArrow(m), e.index === t.Run.length && this.disableArrow(p);
      }
    },
    /**
     * Removes `Glide.settings.classes.disabledArrow` from given NodeList elements
     *
     * @param {NodeList[]} lists
     */
    resetArrowState: function() {
      for (var p = e.settings, m = arguments.length, h = new Array(m), b = 0; b < m; b++)
        h[b] = arguments[b];
      h.forEach(function(k) {
        qi(k).forEach(function(_) {
          _.classList.remove(p.classes.arrow.disabled);
        });
      });
    },
    /**
     * Adds `Glide.settings.classes.disabledArrow` to given NodeList elements
     *
     * @param {NodeList[]} lists
     */
    disableArrow: function() {
      for (var p = e.settings, m = arguments.length, h = new Array(m), b = 0; b < m; b++)
        h[b] = arguments[b];
      h.forEach(function(k) {
        qi(k).forEach(function(_) {
          _.classList.add(p.classes.arrow.disabled);
        });
      });
    },
    /**
     * Adds handles to the each group of controls.
     *
     * @return {Void}
     */
    addBindings: function() {
      for (var p = 0; p < this._c.length; p++)
        this.bind(this._c[p].children);
    },
    /**
     * Removes handles from the each group of controls.
     *
     * @return {Void}
     */
    removeBindings: function() {
      for (var p = 0; p < this._c.length; p++)
        this.unbind(this._c[p].children);
    },
    /**
     * Binds events to arrows HTML elements.
     *
     * @param {HTMLCollection} elements
     * @return {Void}
     */
    bind: function(p) {
      for (var m = 0; m < p.length; m++)
        r.on("click", p[m], this.click), r.on("touchstart", p[m], this.click, i);
    },
    /**
     * Unbinds events binded to the arrows HTML elements.
     *
     * @param {HTMLCollection} elements
     * @return {Void}
     */
    unbind: function(p) {
      for (var m = 0; m < p.length; m++)
        r.off(["click", "touchstart"], p[m]);
    },
    /**
     * Handles `click` event on the arrows HTML elements.
     * Moves slider in direction given via the
     * `data-glide-dir` attribute.
     *
     * @param {Object} event
     * @return {void}
     */
    click: function(p) {
      !Ui && p.type === "touchstart" && p.preventDefault();
      var m = p.currentTarget.getAttribute("data-glide-dir");
      t.Run.make(t.Direction.resolve(m));
    }
  };
  return Be(a, "items", {
    /**
     * Gets collection of the controls HTML elements.
     *
     * @return {HTMLElement[]}
     */
    get: function() {
      return a._c;
    }
  }), n.on(["mount.after", "move.after"], function() {
    a.setActive();
  }), n.on(["mount.after", "run"], function() {
    a.setArrowState();
  }), n.on("destroy", function() {
    a.removeBindings(), a.removeActive(), r.destroy();
  }), a;
}
function bd(e, t, n) {
  var r = new un(), i = {
    /**
     * Binds keyboard events on component mount.
     *
     * @return {Void}
     */
    mount: function() {
      e.settings.keyboard && this.bind();
    },
    /**
     * Adds keyboard press events.
     *
     * @return {Void}
     */
    bind: function() {
      r.on("keyup", document, this.press);
    },
    /**
     * Removes keyboard press events.
     *
     * @return {Void}
     */
    unbind: function() {
      r.off("keyup", document);
    },
    /**
     * Handles keyboard's arrows press and moving glide foward and backward.
     *
     * @param  {Object} event
     * @return {Void}
     */
    press: function(d) {
      var p = e.settings.perSwipe, m = {
        ArrowRight: ">",
        ArrowLeft: "<"
      };
      ["ArrowRight", "ArrowLeft"].includes(d.code) && t.Run.make(t.Direction.resolve("".concat(p).concat(m[d.code])));
    }
  };
  return n.on(["destroy", "update"], function() {
    i.unbind();
  }), n.on("update", function() {
    i.mount();
  }), n.on("destroy", function() {
    r.destroy();
  }), i;
}
function wd(e, t, n) {
  var r = new un(), i = {
    /**
     * Initializes autoplaying and events.
     *
     * @return {Void}
     */
    mount: function() {
      this.enable(), this.start(), e.settings.hoverpause && this.bind();
    },
    /**
     * Enables autoplaying
     *
     * @returns {Void}
     */
    enable: function() {
      this._e = !0;
    },
    /**
     * Disables autoplaying.
     *
     * @returns {Void}
     */
    disable: function() {
      this._e = !1;
    },
    /**
     * Starts autoplaying in configured interval.
     *
     * @param {Boolean|Number} force Run autoplaying with passed interval regardless of `autoplay` settings
     * @return {Void}
     */
    start: function() {
      var d = this;
      this._e && (this.enable(), e.settings.autoplay && ha(this._i) && (this._i = setInterval(function() {
        d.stop(), t.Run.make(">"), d.start(), n.emit("autoplay");
      }, this.time)));
    },
    /**
     * Stops autorunning of the glide.
     *
     * @return {Void}
     */
    stop: function() {
      this._i = clearInterval(this._i);
    },
    /**
     * Stops autoplaying while mouse is over glide's area.
     *
     * @return {Void}
     */
    bind: function() {
      var d = this;
      r.on("mouseover", t.Html.root, function() {
        d._e && d.stop();
      }), r.on("mouseout", t.Html.root, function() {
        d._e && d.start();
      });
    },
    /**
     * Unbind mouseover events.
     *
     * @returns {Void}
     */
    unbind: function() {
      r.off(["mouseover", "mouseout"], t.Html.root);
    }
  };
  return Be(i, "time", {
    /**
     * Gets time period value for the autoplay interval. Prioritizes
     * times in `data-glide-autoplay` attrubutes over options.
     *
     * @return {Number}
     */
    get: function() {
      var d = t.Html.slides[e.index].getAttribute("data-glide-autoplay");
      return et(d || e.settings.autoplay);
    }
  }), n.on(["destroy", "update"], function() {
    i.unbind();
  }), n.on(["run.before", "swipe.start", "update"], function() {
    i.stop();
  }), n.on(["pause", "destroy"], function() {
    i.disable(), i.stop();
  }), n.on(["run.after", "swipe.end"], function() {
    i.start();
  }), n.on(["play"], function() {
    i.enable(), i.start();
  }), n.on("update", function() {
    i.mount();
  }), n.on("destroy", function() {
    r.destroy();
  }), i;
}
function Ts(e) {
  return Bn(e) ? Vu(e) : (Kt("Breakpoints option must be an object"), {});
}
function Sd(e, t, n) {
  var r = new un(), i = e.settings, a = Ts(i.breakpoints), d = Object.assign({}, i), p = {
    /**
     * Matches settings for currectly matching media breakpoint.
     *
     * @param {Object} points
     * @returns {Object}
     */
    match: function(h) {
      if (typeof window.matchMedia < "u") {
        for (var b in h)
          if (h.hasOwnProperty(b) && window.matchMedia("(max-width: ".concat(b, "px)")).matches)
            return h[b];
      }
      return d;
    }
  };
  return Object.assign(i, p.match(a)), r.on("resize", window, Zr(function() {
    e.settings = Wi(i, p.match(a));
  }, e.settings.throttle)), n.on("update", function() {
    a = Ts(a), d = Object.assign({}, i);
  }), n.on("destroy", function() {
    r.off("resize", window);
  }), p;
}
var kd = {
  // Required
  Html: Xu,
  Translate: dd,
  Transition: fd,
  Direction: id,
  Peek: Ku,
  Sizes: Ju,
  Gaps: Yu,
  Move: Zu,
  Clones: ed,
  Resize: td,
  Build: Qu,
  Run: Uu,
  // Optional
  Swipe: pd,
  Images: hd,
  Anchors: md,
  Controls: xd,
  Keyboard: bd,
  Autoplay: wd,
  Breakpoints: Sd
}, Td = /* @__PURE__ */ function(e) {
  Pu(n, e);
  var t = Fu(n);
  function n() {
    return Xr(this, n), t.apply(this, arguments);
  }
  return Kr(n, [{
    key: "mount",
    value: function() {
      var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      return Dr($n(n.prototype), "mount", this).call(this, Object.assign({}, kd, i));
    }
  }]), n;
}(qu);
function _d(e) {
  let t, n, r;
  switch (e) {
    case 3:
      t = 1, n = 2, r = 3;
      break;
    case 2:
      t = 1, n = 2, r = 2;
      break;
    case 1:
    default:
      t = 1, n = 1, r = 1;
  }
  return {
    perViewSm: t,
    perViewMd: n,
    perViewLg: r
  };
}
function Ed(e = 1, t, n = !0, r) {
  const { perViewSm: i, perViewMd: a, perViewLg: d } = _d(e), p = n ? 24 : 0, m = n ? { before: 48, after: 48 } : 0, h = n ? { before: 124, after: 124 } : 0;
  return {
    type: "slider",
    // No wrap-around.
    focusAt: 0,
    bound: !0,
    // Only if type slider with focusAt 0
    rewind: !1,
    // Only if type slider
    gap: p,
    // Space between slides... may be impacted by viewport size.
    // `keyboard` Left/Right arrow key support for slides - true is default.
    // Is not fully Accessible, on keydown allcarousels move simultaneously
    // A custome keyboard handler is implemented
    keyboard: !1,
    startAt: 0,
    swipeThreshold: 80,
    // Distance required for swipe to change slide.
    dragThreshold: r ? 120 : !1,
    // Distance for mouse drag to change slide.
    perTouch: 1,
    // Number of slides that can be moved per each swipe/drag.
    perView: d,
    // Can be overwritten at breakpoints
    peek: h,
    // Can be overwritten at breakpoints
    // if isFullWidth = true, then we have only 1 image per view which takes the full width.
    // no need for breakpoints
    breakpoints: t ? null : {
      576: {
        // BS4 sm
        perView: i,
        peek: m
      },
      768: {
        // BS4 md
        perView: a,
        peek: m
      },
      992: {
        // BS4 lg
        perView: d,
        peek: m
      },
      1260: {
        // BS4 xl
        perView: d,
        peek: m
      },
      1400: {
        perView: d,
        peek: h
      },
      1920: {
        perView: d,
        peek: h
      }
    }
  };
}
function Cd(e, t, n) {
  const r = e.querySelector(".glide__arrow--prev"), i = e.querySelector(".glide__arrow--next"), a = e.querySelector(".glide__track"), d = e.querySelector(
    ".image-navigator-images"
  );
  if (!(r || i)) return;
  const p = ["slider-start", "slider-mid", "slider-end"], m = "glide__arrow--disabled";
  a == null || a.classList.remove(...p), d == null || d.classList.remove(...p), t === 0 ? (a == null || a.classList.add("slider-start"), d == null || d.classList.add("slider-start"), r == null || r.classList.add(m), r == null || r.setAttribute("aria-disabled", "true"), i == null || i.classList.remove(m), i == null || i.setAttribute("aria-disabled", "false")) : t >= n - 1 ? (a == null || a.classList.add("slider-end"), d == null || d.classList.add("slider-end"), r == null || r.classList.remove(m), r == null || r.setAttribute("aria-disabled", "false"), i == null || i.classList.add(m), i == null || i.setAttribute("aria-disabled", "true")) : (a == null || a.classList.add("slider-mid"), d == null || d.classList.add("slider-mid"), r == null || r.classList.remove(m), i == null || i.classList.remove(m), r == null || r.setAttribute("aria-disabled", "false"), i == null || i.setAttribute("aria-disabled", "false"));
}
function Rd(e, t, n) {
  const r = e.querySelectorAll(".glide__slide"), i = t, a = Math.min(
    r.length - 1,
    t + n - 1
  );
  r.forEach((d, p) => {
    p < i || p > a ? (d.setAttribute("aria-hidden", "true"), d.setAttribute("tabindex", "-1"), d.setAttribute("inert", "")) : (d.setAttribute("aria-hidden", "false"), d.removeAttribute("tabindex"), d.removeAttribute("inert"));
  });
}
function Od({
  instanceName: e,
  perView: t,
  buttonCount: n,
  isFullWidth: r = !1,
  onItemClick: i,
  hasPeek: a = !0,
  isDraggable: d
}) {
  const p = Ed(t, r, a, d), m = new Td(`#${e}`, p);
  let h = document.querySelector(`#${e}`);
  return h.addEventListener("keyup", (b) => {
    const k = b;
    k.keyCode === 39 ? m.go(">") : k.keyCode === 37 ? m.go("<") : k.keyCode === 13 && m.go(document.activeElement.dataset.glideDir);
  }), m.on("build.before", () => {
    h = document.querySelector(`#${e}`), h && h.classList.add("slider-start");
  }), m.on("move", () => {
    if (h = document.querySelector(`#${e}`), !h) return;
    const b = m.index;
    Rd(h, b, t);
    const k = h.querySelector(".navigation-slider"), _ = h.querySelector(".image-navigator-images");
    if (k && _) {
      const I = k.querySelectorAll(
        ".bullet-image-container"
      ), C = k.clientWidth, w = 82, N = I[b], M = _.getBoundingClientRect().x, D = k.getBoundingClientRect().x - M, V = N.getBoundingClientRect().x - M, W = N.getBoundingClientRect().x + N.getBoundingClientRect().width - M;
      if (b === 0 || V <= 0 + w)
        k.style.left = `${D - V + w}px`;
      else if (W >= C - w) {
        const A = W - C;
        k.style.left = `${D - A - w}px`;
      }
    }
    Cd(h, b, n), h.setAttribute("data-current-index", b), i && i(b);
  }), m.mount(), m;
}
function Ad(e, t) {
  let n;
  const r = Math.max(
    document.documentElement.clientWidth || 0,
    window.innerWidth || 0
  );
  return n = e, r >= 992 && (t >= 2 && (n = e - 1), t >= 3 && (n = e - 2)), n;
}
const lr = ({
  perView: e = 1,
  width: t,
  maxWidth: n,
  carouselItems: r,
  cssClass: i = "",
  CustomNavComponent: a,
  role: d,
  ariaLabelledBy: p,
  isFullWidth: m,
  removeSideBackground: h = !1,
  hasNavButtons: b = !0,
  hasPositionIndicators: k = !0,
  imageAutoSize: _ = !0,
  onItemClick: I = () => null,
  hasPeek: C = !0,
  isDraggable: w = !0,
  hasShadow: N = !0
}) => {
  const M = `glide-${Math.ceil(Math.random() * 1e4)}`, D = Ad(r.length, e);
  return at(() => {
    Od({
      instanceName: M,
      perView: e,
      buttonCount: D,
      isFullWidth: m,
      onItemClick: I,
      hasPeek: C,
      isDraggable: w
    });
  }, [
    M,
    e,
    D,
    m,
    I,
    C,
    w
  ]), /* @__PURE__ */ f.jsxs(
    "div",
    {
      role: d,
      "aria-labelledby": p,
      className: `glide ${i}`,
      id: M,
      style: { width: t, maxWidth: n },
      "data-remove-side-background": h,
      "data-image-auto-size": _,
      "data-has-shadow": N,
      children: [
        /* @__PURE__ */ f.jsx("div", { className: "glide__track", "data-glide-el": "track", children: /* @__PURE__ */ f.jsx(pa, { carouselItems: r }) }),
        a ? (
          // @ts-ignore
          /* @__PURE__ */ f.jsx(a, { instanceName: M })
        ) : /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
          k && /* @__PURE__ */ f.jsx(ua, { buttonCount: D }),
          b && /* @__PURE__ */ f.jsx(fa, {})
        ] })
      ]
    }
  );
};
lr.propTypes = {
  perView: l.number,
  width: l.string,
  maxWidth: l.string,
  carouselItems: l.arrayOf(l.object).isRequired,
  cssClass: l.string,
  CustomNavComponent: l.func,
  role: l.string,
  ariaLabelledBy: l.string,
  onItemClick: l.func,
  isFullWidth: l.bool,
  removeSideBackground: l.bool,
  hasNavButtons: l.bool,
  hasPositionIndicators: l.bool,
  imageAutoSize: l.bool,
  hasPeek: l.bool,
  isDraggable: l.bool,
  hasShadow: l.bool
};
const jd = ({
  id: e,
  imageSource: t,
  imageAltText: n,
  title: r,
  content: i,
  eventLocation: a,
  eventTime: d,
  buttons: p,
  linkLabel: m,
  linkUrl: h,
  tags: b
}, k, _, I) => {
  var C, w;
  return {
    // @ts-ignore
    id: e,
    item: /* @__PURE__ */ f.jsx(
      Gt,
      {
        type: k,
        horizontal: _,
        image: t,
        imageAltText: n,
        title: r,
        body: i,
        eventFormat: I,
        eventLocation: a,
        eventTime: d,
        buttons: p,
        linkLabel: m,
        linkUrl: h || ((C = p == null ? void 0 : p[0]) == null ? void 0 : C.href),
        tags: b,
        cardLink: h || ((w = p == null ? void 0 : p[0]) == null ? void 0 : w.href)
      }
    )
  };
}, va = ({
  perView: e = 0,
  cardItems: t = [],
  cardType: n = "default",
  cardEventFormat: r = "stack",
  cardHorizontal: i = !1,
  width: a = void 0,
  maxWidth: d = void 0,
  imageAutoSize: p = !0
}) => {
  const m = parseInt(`${e}`, 10), [h, b] = tt(m), k = 1024, _ = 768;
  at(() => {
    const w = () => {
      const N = window.innerWidth;
      let M;
      switch (m) {
        case 3:
          N > k ? M = 3 : N > _ ? M = 2 : M = 1;
          break;
        case 2:
          M = N < _ ? 1 : 2;
          break;
        default:
          M = 1;
          break;
      }
      b(M);
    };
    return w(), window.addEventListener("resize", w), () => window.removeEventListener("resize", w);
  }, [m]);
  const I = t.map(
    (w) => jd(w, n, i, r)
  ), C = t.length > h;
  return /* @__PURE__ */ f.jsx(
    lr,
    {
      perView: +h,
      maxWidth: d,
      width: a,
      carouselItems: I,
      cssClass: "aligned-carousel",
      imageAutoSize: p,
      removeSideBackground: t.length <= h,
      hasPositionIndicators: C,
      hasNavButtons: C,
      isDraggable: C,
      hasShadow: !0
    }
  );
};
va.propTypes = {
  perView: l.string.isRequired,
  cardItems: l.arrayOf(
    l.shape({
      title: l.string.isRequired,
      content: l.string,
      eventLocation: l.string,
      eventTime: l.string,
      image: l.string,
      imageAltText: l.string,
      buttons: Gt.propTypes.buttons,
      linkLabel: l.string,
      linkUrl: l.string,
      tags: Gt.propTypes.tags
    })
  ).isRequired,
  cardType: Gt.propTypes.type,
  cardEventFormat: Gt.propTypes.eventFormat,
  cardHorizontal: Gt.propTypes.horizontal,
  width: l.string,
  maxWidth: l.string,
  imageAutoSize: l.bool
};
const Nd = ({ id: e, imageSource: t, imageAltText: n, title: r, content: i }) => ({
  // @ts-ignore
  id: e,
  item: /* @__PURE__ */ f.jsx("div", { className: "uds-img", children: /* @__PURE__ */ f.jsxs("figure", { className: "figure uds-figure", children: [
    /* @__PURE__ */ f.jsx(
      "img",
      {
        src: t,
        className: "uds-img figure-img img-fluid",
        alt: n,
        loading: "lazy",
        decoding: "async"
      }
    ),
    (r || i) && /* @__PURE__ */ f.jsx(
      "figcaption",
      {
        className: "figure-caption uds-figure-caption",
        "data-testid": "image-content-container",
        children: /* @__PURE__ */ f.jsx("div", { className: "uds-caption-text", children: r ? /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
          /* @__PURE__ */ f.jsx("h2", { children: r }),
          /* @__PURE__ */ f.jsx("div", { dangerouslySetInnerHTML: { __html: i } })
        ] }) : /* @__PURE__ */ f.jsx("div", { dangerouslySetInnerHTML: { __html: i } }) })
      }
    )
  ] }) })
}), ya = ({
  perView: e = 0,
  imageItems: t = [],
  width: n = void 0,
  maxWidth: r = void 0,
  imageAutoSize: i = !0
}) => {
  if (!t || t.length === 0)
    return null;
  const a = parseInt(`${e}`, 10), d = t.map(Nd) || [], p = t.length > a;
  return /* @__PURE__ */ f.jsx(
    lr,
    {
      perView: +a,
      maxWidth: r,
      width: n,
      cssClass: "image-carousel aligned-carousel",
      carouselItems: d,
      imageAutoSize: i,
      removeSideBackground: t.length <= a,
      hasPositionIndicators: p,
      hasNavButtons: p,
      isDraggable: p,
      hasShadow: !0
    }
  );
};
ya.propTypes = {
  perView: l.number.isRequired,
  imageItems: l.arrayOf(l.object).isRequired,
  width: l.string,
  maxWidth: l.string,
  imageAutoSize: l.bool
};
const Id = (e, t) => {
  if (!e)
    return 0;
  const n = (e.match(/<br/g) || []).length, r = t / 6;
  return (parseInt(`${e.length / r}`, 10) + n) * 20;
}, Wr = {
  imageItems: l.arrayOf(
    l.shape({
      id: l.number,
      imageSource: l.string,
      thumbnailSource: l.string,
      imageAltText: l.string,
      content: l.oneOfType([l.string, l.element])
    })
  ),
  hasContent: l.bool
}, Pd = ({ id: e, imageSource: t, imageAltText: n }) => ({
  // @ts-ignore
  id: e,
  item: /* @__PURE__ */ f.jsx("div", { className: "uds-img", children: /* @__PURE__ */ f.jsx(
    "img",
    {
      src: t,
      className: "uds-img figure-img img-fluid",
      alt: n,
      loading: "lazy",
      decoding: "async"
    }
  ) })
}), xa = ({ instanceName: e, imageItems: t, hasContent: n }) => {
  var b, k;
  const r = "data-current-index", [i, a] = tt(((b = t == null ? void 0 : t[0]) == null ? void 0 : b.title) || ""), [d, p] = tt(((k = t == null ? void 0 : t[0]) == null ? void 0 : k.content) || ""), m = Ln(
    (_) => {
      const I = t == null ? void 0 : t[_];
      I && (a(I.title), p(I.content));
    },
    [t]
  );
  if (at(() => {
    if (!t || t.length === 0)
      return;
    const _ = document.querySelector(
      ".image-gallery figcaption .uds-caption-text div"
    );
    if (_) {
      const N = parseInt(
        window.getComputedStyle(_, null).getPropertyValue("width").split("px")[0],
        10
      ), M = t.reduce((D, V) => {
        const W = Id(V.content, N);
        return W > D ? W : D;
      }, 0);
      _.style.height = `${M}px`;
    }
    const I = document.querySelector(`#${e}`);
    if (!I)
      return;
    function C(N) {
      for (const M of N)
        if (M && M.attributeName === r) {
          const D = I.getAttribute(r);
          D !== null && m(+D);
          return;
        }
    }
    const w = new MutationObserver(C);
    return w.observe(I, {
      attributes: !0
    }), () => {
      w.disconnect();
    };
  }, [e, t, m]), !t || t.length === 0)
    return null;
  const h = t.map((_) => _.imageSource);
  return /* @__PURE__ */ f.jsxs("div", { className: "image-gallery-action-area", "data-has-content": n, children: [
    /* @__PURE__ */ f.jsx("div", { className: "image-navigator", children: /* @__PURE__ */ f.jsxs(so, { children: [
      /* @__PURE__ */ f.jsx(oo, {}),
      /* @__PURE__ */ f.jsx("div", { className: "image-navigator-images", children: /* @__PURE__ */ f.jsx("div", { className: "navigation-slider", children: /* @__PURE__ */ f.jsx(
        da,
        {
          imageItems: h,
          onItemClick: (_) => m(_)
        }
      ) }) }),
      /* @__PURE__ */ f.jsx(io, {})
    ] }) }),
    n && (i || d) ? /* @__PURE__ */ f.jsx(
      "figcaption",
      {
        id: "caption",
        className: "figure-caption uds-figure-caption",
        "data-testid": "image-gallery-content-container",
        children: /* @__PURE__ */ f.jsxs("div", { className: "uds-caption-text", children: [
          i ? /* @__PURE__ */ f.jsx("h2", { children: i }) : null,
          /* @__PURE__ */ f.jsx("div", { dangerouslySetInnerHTML: { __html: d } })
        ] })
      }
    ) : null
  ] });
};
xa.propTypes = {
  instanceName: l.string,
  imageItems: Wr.imageItems,
  hasContent: Wr.hasContent
};
const ba = ({
  width: e,
  maxWidth: t,
  imageItems: n = [],
  hasContent: r = !1,
  imageAutoSize: i = !0
}) => {
  const a = n.map(Pd), d = n.length > 1;
  return /* @__PURE__ */ f.jsx(
    lr,
    {
      perView: 1,
      maxWidth: t,
      width: e,
      carouselItems: a,
      cssClass: "image-gallery",
      role: "figure",
      ariaLabelledBy: r ? "caption" : null,
      isFullWidth: !0,
      imageAutoSize: i,
      hasPeek: !1,
      CustomNavComponent: ({ instanceName: p }) => /* @__PURE__ */ f.jsx(
        xa,
        {
          instanceName: p,
          hasContent: r,
          imageItems: n
        }
      ),
      removeSideBackground: n.length <= 1,
      hasPositionIndicators: d,
      hasNavButtons: d,
      isDraggable: d,
      hasShadow: !0
    }
  );
};
ba.propTypes = {
  imageItems: Wr.imageItems.isRequired,
  hasContent: Wr.hasContent,
  width: l.string,
  maxWidth: l.string,
  imageAutoSize: l.bool
};
const Ld = ({ id: e, imageSource: t, imageAltText: n, quote: r }, i = {}) => ({
  // @ts-ignore
  id: e,
  item: /* @__PURE__ */ f.jsx(
    no,
    {
      imageSource: t,
      imageAltText: n,
      quote: r,
      itemStyle: i
    }
  )
}), wa = ({
  width: e,
  maxWidth: t,
  testimonialItems: n = [],
  itemStyle: r = {},
  hasNavButtons: i = !1,
  hasPositionIndicators: a = !1,
  imageAutoSize: d = !0
}) => {
  const p = n.map(
    (m) => Ld(m, r)
  );
  return /* @__PURE__ */ f.jsx(
    lr,
    {
      perView: 1,
      maxWidth: t,
      width: e,
      carouselItems: p,
      isFullWidth: !0,
      removeSideBackground: !0,
      hasNavButtons: i,
      hasPositionIndicators: a,
      imageAutoSize: d,
      hasPeek: !1,
      hasShadow: !1
    }
  );
};
wa.propTypes = {
  testimonialItems: l.arrayOf(
    l.shape({
      title: l.string,
      content: l.string,
      cite: l.shape({
        name: l.string,
        description: l.string
      })
    })
  ).isRequired,
  itemStyle: l.shape({
    containerCssClass: l.arrayOf(l.string),
    titleCssClass: l.arrayOf(l.string),
    contentCssClass: l.arrayOf(l.string)
  }),
  width: l.string,
  maxWidth: l.string,
  imageAutoSize: l.bool,
  hasNavButtons: l.bool,
  hasPositionIndicators: l.bool
};
var Bt = /* @__PURE__ */ ((e) => (e.UNORDERED = "unordered", e.ORDERED = "ordered", e.ICON = "icon", e.STEP = "step", e.DISPLAY = "display", e))(Bt || {}), Fr = /* @__PURE__ */ ((e) => (e.UL = "ul", e.OL = "ol", e))(Fr || {}), _n = /* @__PURE__ */ ((e) => (e.NONE = "none", e.LIGHT = "light", e.MEDIUM = "medium", e.DARK = "dark", e))(_n || {}), $r = /* @__PURE__ */ ((e) => (e.DEFAULT = "default", e.PRIMARY = "primary", e.SECONDARY = "secondary", e))($r || {});
const Sa = (e) => {
  switch (e) {
    case Fr.OL:
    case Bt.ORDERED:
    case Bt.STEP:
      return Fr.OL;
    default:
      return Fr.UL;
  }
}, ka = ({
  listType: e,
  content: t,
  icon: n,
  nestedType: r,
  nestedItems: i
}) => {
  const [a, ...d] = Array.isArray(t) ? t : [t];
  let p = null;
  if (i != null && i.length) {
    const m = r || e, h = Sa(m);
    p = /* @__PURE__ */ f.jsx(h, { children: i.map((b, k) => /* @__PURE__ */ f.jsx(ka, { listType: m, ...b }, k)) });
  }
  return /* @__PURE__ */ f.jsxs("li", { children: [
    n && /* @__PURE__ */ f.jsx("span", { className: `fa-li ${n == null ? void 0 : n[0]} fa-${n == null ? void 0 : n[1]}` }),
    a,
    " ",
    d.map((m, h) => [/* @__PURE__ */ f.jsx("br", {}, `br-${h}`), /* @__PURE__ */ f.jsx("span", { children: m }, h)]),
    p
  ] });
}, Md = ({
  listType: e = Bt.UNORDERED,
  backgroundColor: t = _n.NONE,
  listItemStyleColor: n = $r.DEFAULT,
  items: r
}) => {
  const i = Sa(e);
  let a = "maroon", d = "maroon";
  t === _n.DARK && (a = "gold", d = "gold"), e === Bt.STEP && (a = "uds-steplist-maroon", d = "uds-steplist-gold", t === _n.DARK && (a = "uds-steplist-gold"));
  const p = xe({
    "uds-list": e === Bt.UNORDERED || e === Bt.ORDERED,
    "uds-list fa-ul": e === Bt.ICON,
    "uds-list uds-steplist": e === Bt.STEP,
    "uds-list uds-display-list": e === Bt.DISPLAY,
    "light-smokemode": t === _n.LIGHT,
    smokemode: t === _n.MEDIUM,
    darkmode: t === _n.DARK,
    [`${a}`]: n === $r.PRIMARY,
    // Intentional space ` ${secondaryColor}` for when primary and secondary colors are the same
    [` ${d}`]: n === $r.SECONDARY
  });
  return /* @__PURE__ */ f.jsx(i, { className: p || null, children: r.map((m, h) => /* @__PURE__ */ f.jsx(ka, { listType: e, ...m }, h)) });
}, Dd = {
  none: "",
  gold: "text-gold",
  white: "text-white"
}, Fd = {
  name: "onclick",
  event: "link",
  action: "click",
  type: "internal link",
  region: "main content"
}, $d = ({
  gridLinkItems: e,
  numColumns: t,
  textColor: n,
  children: r
}) => /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
  /* @__PURE__ */ f.jsx(
    "div",
    {
      className: [
        "uds-grid-links",
        t,
        Dd[n]
      ].join(" "),
      children: e && e.map((i) => /* @__PURE__ */ f.jsx(
        Ye,
        {
          gaData: {
            ...Fd,
            text: i.label,
            section: `grid links ${i.label}`
          },
          children: /* @__PURE__ */ f.jsxs("a", { href: i.href, children: [
            /* @__PURE__ */ f.jsx("span", { className: `fa fa-fw ${i.icon}` }),
            i.label
          ] })
        },
        i.label + i.href
      ))
    }
  ),
  /* @__PURE__ */ f.jsx("div", { children: r })
] });
var jr = {}, _s;
function Bd() {
  if (_s) return jr;
  _s = 1;
  var e = $a;
  return jr.createRoot = e.createRoot, jr.hydrateRoot = e.hydrateRoot, jr;
}
var Ta = Bd();
const zd = (e, t, n) => {
  Ta.createRoot(n).render(Ve.createElement(e, t));
}, Jr = ({ typeCarousel: e, targetSelector: t, props: n }) => {
  const i = {
    card: va,
    testimonial: wa,
    image: ya,
    "image-gallery": ba
  }[e];
  i && zd(i, n, document.querySelector(t));
}, qd = ({ targetSelector: e, props: t }) => Jr({
  typeCarousel: "card",
  targetSelector: e,
  props: t
}), Ud = ({ targetSelector: e, props: t }) => {
  Jr({
    typeCarousel: "testimonial",
    targetSelector: e,
    props: t
  });
}, Yd = ({ targetSelector: e, props: t }) => {
  Jr({ typeCarousel: "image", targetSelector: e, props: t });
}, Gd = ({ targetSelector: e, props: t }) => {
  Jr({
    typeCarousel: "image-gallery",
    targetSelector: e,
    props: t
  });
}, qe = (e, t, n) => {
  Ta.createRoot(n).render(Ve.createElement(e, t));
}, Xd = ({ targetSelector: e, props: t }) => qe(Ps, t, document.querySelector(e)), Kd = ({ targetSelector: e, props: t }) => qe(Ws, t, document.querySelector(e)), Zd = ({ targetSelector: e, props: t }) => qe(Ys, t, document.querySelector(e)), Jd = ({ targetSelector: e, props: t }) => qe(ln, t, document.querySelector(e)), Qd = ({ targetSelector: e, props: t }) => qe(Qi, t, document.querySelector(e)), ef = ({ targetSelector: e, props: t }) => qe(eo, t, document.querySelector(e)), tf = ({ targetSelector: e, props: t }) => qe(Gt, t, document.querySelector(e)), nf = ({ targetSelector: e, props: t }) => qe(ea, t, document.querySelector(e)), rf = ({ targetSelector: e, props: t }) => qe(ta, t, document.querySelector(e)), of = ({ targetSelector: e, props: t }) => qe($d, t, document.querySelector(e)), sf = ({ targetSelector: e, props: t }) => qe(ia, t, document.querySelector(e)), af = ({ targetSelector: e, props: t }) => qe(Cn, t, document.querySelector(e)), lf = ({ targetSelector: e, props: t }) => qe(oa, t, document.querySelector(e)), cf = ({ targetSelector: e, props: t }) => qe(to, t, document.querySelector(e)), uf = ({ targetSelector: e, props: t }) => qe(la, t, document.querySelector(e)), df = ({ targetSelector: e, props: t }) => qe(no, t, document.querySelector(e)), ff = ({ targetSelector: e, props: t }) => qe(ca, t, document.querySelector(e)), pf = ({ targetSelector: e, props: t }) => qe(Su, t, document.querySelector(e)), hf = ({ targetSelector: e, props: t }) => qe(ou, t, document.querySelector(e)), mf = ({ targetSelector: e, props: t }) => qe(Cu, t, document.querySelector(e)), gf = ({ targetSelector: e, props: t }) => qe(Md, t, document.querySelector(e)), vf = ({ targetSelector: e, props: t }) => qe(xu, t, document.querySelector(e));
export {
  Ps as Accordion,
  Ws as AnchorMenu,
  Ys as Article,
  ln as Button,
  Qi as ButtonIconOnly,
  eo as ButtonTag,
  Gt as Card,
  ea as CardArrangement,
  va as CardCarousel,
  ta as ContentSpotlight,
  ou as Divider,
  iu as DividerType,
  mu as FeedBody,
  uu as FeedContainerProvider,
  cu as FeedContext,
  hu as FeedHeader,
  $d as GridLinks,
  ia as Hero,
  xu as HighlyRanked,
  Cn as Image,
  ya as ImageCarousel,
  ba as ImageGalleryCarousel,
  Md as List,
  sa as NavControls,
  oa as Pagination,
  to as RankingCard,
  Su as SystemAlert,
  wu as SystemAlertType,
  _u as Tab,
  aa as TabHeader,
  la as TabbedPanels,
  no as Testimonial,
  wa as TestimonialCarousel,
  Cu as Tooltip,
  ca as Video,
  Wd as feedCardButtonShape,
  fu as feedComponentShape,
  ra as feedCtaButtonShape,
  du as feedDataSourceShape,
  na as feedHeaderShape,
  Xd as initAccordion,
  Kd as initAnchorMenu,
  Zd as initArticle,
  Jd as initButton,
  Qd as initButtonIconOnly,
  ef as initButtonTag,
  tf as initCard,
  nf as initCardArrangement,
  qd as initCardCarousel,
  rf as initContentSpotlight,
  hf as initDivider,
  of as initGridLinks,
  sf as initHero,
  vf as initHighlyRanked,
  af as initImage,
  Yd as initImageCarousel,
  Gd as initImageGalleryCarousel,
  gf as initList,
  lf as initPagination,
  cf as initRankingCard,
  pf as initSystemAlert,
  uf as initTabbedPanels,
  df as initTestimonial,
  Ud as initTestimonialCarousel,
  mf as initTooltip,
  ff as initVideo
};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
/*! @license DOMPurify 3.4.0 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.4.0/LICENSE */
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/**
 * @license React
 * react-dom-server-legacy.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
/**
 * @license React
 * react-dom-server.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
/*!
 * Glide.js v3.6.2
 * (c) 2013-2024 Jędrzej Chałubek (https://github.com/jedrzejchalubek/)
 * Released under the MIT License.
 */

(function() {
                var css = `@charset "UTF-8";.glide{position:relative;width:100%;box-sizing:border-box}.glide *{box-sizing:inherit}.glide__track{overflow:hidden}.glide__slides{position:relative;width:100%;list-style:none;backface-visibility:hidden;transform-style:preserve-3d;touch-action:pan-Y;overflow:hidden;margin:0;padding:0;white-space:nowrap;display:flex;flex-wrap:nowrap;will-change:transform}.glide__slides--dragging{-webkit-user-select:none;user-select:none}.glide__slide{width:100%;height:100%;flex-shrink:0;white-space:normal;-webkit-user-select:none;user-select:none;-webkit-touch-callout:none;-webkit-tap-highlight-color:transparent}.glide__slide a{-webkit-user-select:none;user-select:none;-webkit-user-drag:none;-moz-user-select:none;-ms-user-select:none}.glide__arrows,.glide__bullets{-webkit-touch-callout:none;-webkit-user-select:none;user-select:none}.glide--rtl{direction:rtl}@media only screen and (min-width: 1260px){.container .aligned-carousel{margin-left:-124px!important}}.glide{display:flex;flex-direction:column;gap:32px;position:relative}[data-image-auto-size=true] .glide__slides .glide__slide{height:auto;position:relative;display:inline-flex;justify-content:center}[data-image-auto-size=true] .glide__slides .glide__slide>div.uds-img{display:flex;width:100%;max-width:100%}[data-image-auto-size=true] .glide__slides .glide__slide>div.uds-img img{flex-grow:1;object-fit:cover}[data-image-auto-size=true] .glide__slides .glide__slide>div.uds-img img.uds-img{max-width:100%}[data-image-auto-size=true] .glide__slides .glide__slide>div.uds-img figure.uds-figure{display:flex;justify-content:space-between;flex-direction:column}.glide .glide__track{position:relative}.glide .glide__track .glide__slides{margin-bottom:0;touch-action:auto}.glide .glide__track .glide__slides .glide__slide .card{width:100%}@media only screen and (min-width: 576px){.glide[data-has-shadow=true] .glide__track.slider-start:after{background:linear-gradient(to left,#19191933,48px,#fff0 96px);content:" ";height:100%;position:absolute;pointer-events:none;width:100%;top:0}.glide[data-has-shadow=true] .glide__track.slider-mid:after{background:linear-gradient(to right,#19191933,48px,#fff0 96px),linear-gradient(to left,#19191933,48px,#fff0 96px);content:" ";height:100%;position:absolute;pointer-events:none;width:100%;top:0}.glide[data-has-shadow=true] .glide__track.slider-end:after{background:linear-gradient(to right,#19191933,48px,#fff0 96px);content:" ";height:100%;position:absolute;pointer-events:none;width:100%;top:0}}.glide__arrows{z-index:2;align-self:center}.glide__arrows .glide__arrow{color:#191919;width:4rem;height:4rem;margin:0 .5rem;background-color:#e8e8e8;border:1px solid #d0d0d0;border-radius:50%;font-size:1.3rem;text-shadow:0 .25em .5em rgba(0,0,0,.1);opacity:1;cursor:pointer;transition:opacity .15s ease,border .3s ease-in-out;line-height:1}.glide__arrows .glide__arrow.glide__arrow--disabled{color:#e8e8e8;background-color:#fafafa;border:1px solid #e8e8e8;opacity:1}.glide__arrows .glide__arrow:focus{outline:none}.glide__arrows .glide__arrow:hover{border-color:#fff}.glide__arrows .glide__arrow--left{left:2em}.glide__arrows .glide__arrow--right{right:2em}.glide__arrows .glide__arrow--disabled{opacity:.33}.glide__bullets{z-index:2;list-style:none;max-width:100%;display:flex;justify-content:center}.glide__bullet{transition:all .3s ease-in-out;background-color:#d0d0d0;width:1rem;height:1rem;padding:0;border-radius:50%;border:2px solid transparent;cursor:pointer;line-height:0;margin:.375rem}.glide__bullet:focus{outline:none}.glide__bullet:hover,.glide__bullet:focus{border:1px solid #d0d0d0;background-color:#191919}.glide__bullet--active{background-color:#191919}.glide.aligned-carousel{width:1448px;margin:auto}.glide.image-gallery{gap:0;overflow:hidden}.glide.image-gallery .glide__track{border:1px solid #d0d0d0}.glide.image-gallery .glide__track:after{content:none}.glide.image-gallery .glide__track .glide__slides{margin-bottom:0;height:100%}.glide.image-gallery .glide__track .glide__slides li.glide__slide{display:list-item}.glide.image-gallery .glide__track .glide__slides .glide__slide>div.uds-img{height:100%}.glide.image-gallery .glide__track .glide__slides .glide__slide>div.uds-img img{object-fit:cover;border:none}.glide.image-gallery .image-gallery-action-area{border:1px solid #d0d0d0;border-top:0}.glide.image-gallery .image-gallery-action-area[data-has-content=true] .image-navigator{border-bottom:1px solid #d0d0d0}.glide.image-gallery .image-gallery-action-area[data-has-content=true] .uds-caption-text{padding:1rem 0;display:inline-block}.glide.image-gallery .image-gallery-action-area[data-has-content=true] .uds-caption-text>div{height:auto!important}.glide.image-gallery figcaption{padding:0 .75rem;font-size:.75rem}.glide.image-gallery figcaption h2{font-size:1.5rem;line-height:1.75rem;letter-spacing:-.0525rem}.glide.image-gallery .image-navigator{position:relative}.glide.image-gallery .image-navigator .image-navigator-images{min-height:64px;padding-top:1rem;padding-bottom:1rem;width:100%;margin:auto;overflow:hidden}.glide.image-gallery .image-navigator .image-navigator-images.slider-start:after{background:linear-gradient(to left,#19191933,48px,#fff0 96px);content:" ";height:100%;position:absolute;pointer-events:none;width:100%;top:0}.glide.image-gallery .image-navigator .image-navigator-images.slider-mid:after{background:linear-gradient(to right,#19191933,48px,#fff0 96px),linear-gradient(to left,#19191933,48px,#fff0 96px);content:" ";height:100%;position:absolute;pointer-events:none;width:100%;top:0}.glide.image-gallery .image-navigator .image-navigator-images.slider-end:after{background:linear-gradient(to right,#19191933,48px,#fff0 96px);content:" ";height:100%;position:absolute;pointer-events:none;width:100%;top:0}.glide.image-gallery .image-navigator .image-navigator-images .navigation-slider{position:relative;left:0}.glide.image-gallery .image-navigator .image-navigator-images .navigation-slider .glide__bullets{position:relative}.glide.image-gallery .image-navigator .image-navigator-images .navigation-slider .glide__bullets .bullet-image-container{position:relative;margin:0 .5rem;height:48px;border:0;padding:0}.glide.image-gallery .image-navigator .image-navigator-images .navigation-slider .glide__bullets .bullet-image-container:first-child{margin-left:16rem}.glide.image-gallery .image-navigator .image-navigator-images .navigation-slider .glide__bullets .bullet-image-container .bullet-image{flex-basis:auto;width:88px;height:100%;border-radius:0;border:0;z-index:2;object-fit:cover;margin:0}.glide.image-gallery .image-navigator .image-navigator-images .navigation-slider .glide__bullets .bullet-image-container:focus{box-shadow:0 0 0 2px #fff,0 0 0 4px #191919!important}.glide.image-gallery .image-navigator .image-navigator-images .navigation-slider .glide__bullets .glide__bullet--active{background-color:transparent;border:5px solid #ffc627}.glide.image-gallery .image-navigator .glide__arrows{width:100%;display:flex;justify-content:space-between;align-items:center}.glide.image-gallery .image-navigator .glide__arrows .glide__arrow{width:2.5rem;height:2.5rem;display:flex;align-items:center;justify-content:center;z-index:3;position:absolute;background-color:#fff}.glide.image-gallery .image-navigator .glide__arrows .glide__arrow:hover{border-color:#d0d0d0}.glide.image-gallery .image-navigator .glide__arrows .glide__arrow .arrow-icon{font-size:1rem}.glide.image-gallery .image-navigator .glide__arrows .glide__arrow.glide__arrow--prev{left:0}.glide.image-gallery .image-navigator .glide__arrows .glide__arrow.glide__arrow--next{right:0}@media only screen and (max-width: 576px){.glide{gap:21px}.glide:not(.glide.image-gallery) .glide__bullets{display:none}.glide.image-gallery{width:100%;margin:auto!important}.glide.image-gallery .image-navigator .image-navigator-images .glide__arrows .glide__arrow{display:none}}@media only screen and (max-width: 1260px){.glide.aligned-carousel{width:100%}}.glide--swipeable{cursor:grab;cursor:-moz-grab;cursor:-webkit-grab}.glide--dragging{cursor:grabbing;cursor:-moz-grabbing;cursor:-webkit-grabbing}.glide[data-remove-side-background=true]:after,.glide[data-remove-side-background=true]:before{content:none}.glide button:focus,.glide a:focus,.glide input:focus,.glide textarea:focus,.glide select:focus{outline:none!important;box-shadow:0 0 0 2px #fff,0 0 0 4px #191919!important}.glide.image-gallery,.glide.image-carousel{margin:auto}.glide.image-gallery[role=figure],.glide.image-gallery figure.uds-figure,.glide.image-carousel[role=figure],.glide.image-carousel figure.uds-figure{margin:0}.glide.image-gallery[role=figure] figcaption *,.glide.image-gallery[role=figure] .uds-caption-text,.glide.image-gallery figure.uds-figure figcaption *,.glide.image-gallery figure.uds-figure .uds-caption-text,.glide.image-carousel[role=figure] figcaption *,.glide.image-carousel[role=figure] .uds-caption-text,.glide.image-carousel figure.uds-figure figcaption *,.glide.image-carousel figure.uds-figure .uds-caption-text{color:#191919;max-width:100%}
`;
                var style = document.createElement('style');
                style.type = 'text/css';
                if (style.styleSheet) {
                  style.styleSheet.cssText = css;
                } else {
                  style.appendChild(document.createTextNode(css));
                }
                document.head.appendChild(style);
              })();